export default {
    "no-active-users-with-login-codes": {
        "de": "Keine aktiven Benutzer mit Anmeldecodes",
        "en": "No active users with login codes",
        "es": "No hay usuarios activos con códigos de inicio de sesión",
        "fr": "Aucun utilisateur actif avec des codes de connexion",
        "km": "គ្មានអ្នកប្រើប្រាស់សកម្មដែលមានលេខកូដចូលប្រើទេ",
        "lv": "Nav aktīvu lietotāju ar pieteikšanās kodiem",
        "nl": "Geen actieve gebruikers met inlogcodes",
        "pl": "Brak aktywnych użytkowników z kodami logowania",
        "pt": "Não há usuários ativos com códigos de acesso",
        "sk": "Žiadni aktívni používatelia s prihlasovacími kódmi",
        "th": "ไม่มีผู้ใช้ที่ใช้งานอยู่พร้อมรหัสเข้าสู่ระบบ"
    },
    "print-codes": {
        "de": "Zugangscodes drucken",
        "en": "Print Codes",
        "es": "Imprimir códigos",
        "fr": "Imprimer les codes",
        "km": "បោះពុម្ពលេខកូដ",
        "lv": "Drukāt kodus",
        "nl": "Codes afdrukken",
        "pl": "Drukuj kody",
        "pt": "Imprimir códigos",
        "sk": "Vytlačiť kódy",
        "th": "พิมพ์รหัส"
    },
    "assign-and-monitor": {
        "de": "Zuweisen und überwachen",
        "en": "Assign and Monitor",
        "es": "Asignar y monitorear",
        "fr": "Attribuer et suivre",
        "km": "ចាត់តាំង និងត្រួតពិនិត្យ",
        "lv": "Piešķirt un uzraudzīt",
        "nl": "Toewijzen en monitoren",
        "pl": "Przypisz i monitoruj",
        "pt": "Atribuir e monitorar",
        "sk": "Priradiť a sledovať",
        "th": "มอบหมายและติดตาม"
    },
    "log-in-with": {
        "de": "Anmelden mit",
        "en": "Log in with",
        "es": "Inicia sesión con",
        "fr": "Se connecter avec",
        "km": "ចូលប្រើដោយ",
        "lv": "Piesakieties ar",
        "nl": "Inloggen met",
        "pl": "Zaloguj przez",
        "pt": "Entrar com",
        "sk": "Prihlásiť sa pomocou",
        "th": "เข้าสู่ระบบด้วย"
    },
    "suggest-a-feature": {
        "de": "Eine Funktion vorschlagen",
        "en": "Suggest a Feature",
        "es": "Sugerir una característica",
        "fr": "Suggérer une fonctionnalité",
        "km": "ផ្តល់អត្ថបទមួយ",
        "lv": "Ieteikt funkciju",
        "nl": "Stel een functie voor",
        "pl": "Zasugeruj funkcję",
        "pt": "Sugira um recurso",
        "sk": "Navrhnite funkciu",
        "th": "แนะนำคุณสมบัติ"
    },
    "group-name": {
        "de": "Gruppenname",
        "en": "Group name",
        "es": "Nombre del grupo",
        "fr": "Nom du groupe",
        "km": "ឈ្មោះក្រុម",
        "lv": "Grupas nosaukums",
        "nl": "Groepsnaam",
        "pl": "Nazwa grupy",
        "pt": "Nome do grupo",
        "sk": "Názov skupiny",
        "th": "ชื่อกลุ่ม"
    },
    "try-again": {
        "de": "Erneut versuchen",
        "en": "Try Again",
        "es": "Intentar de nuevo",
        "fr": "Réessayer",
        "km": "ព្យាយាមម្ដងទៀត",
        "lv": "Mēģināt vēlreiz",
        "nl": "Opnieuw proberen",
        "pl": "Spróbuj ponownie",
        "pt": "Tentar novamente",
        "sk": "Skúsiť znova",
        "th": "ลองอีกครั้ง"
    },
    "refresh-status": {
        "de": "Status aktualisieren",
        "en": "Refresh Status",
        "es": "Actualizar estado",
        "fr": "Actualiser l’état",
        "km": "ផ្ទុកស្ថានភាពឡើងវិញ",
        "lv": "Atjaunot statusu",
        "nl": "Vernieuwingsstatus",
        "pl": "Odśwież status",
        "pt": "Atualizar status",
        "sk": "Aktualizovať stav",
        "th": "รีเฟรชสถานะ"
    },
    "create-an-account-or-log-in-with-the-service-tha": {
        "de": "Erstelle ein Konto oder melde Dich mit dem Dienst an, den Du an Deiner Schule nutzt. Wenn der Dienst, den Du normalerweise nutzt, nicht zu den Optionen gehört, bitte Deine Lehrkraft, sich an koordination.power.feedback@uni-rostock.de zu wenden.",
        "en": "Create an account or log in with the Service that you use at your school. If the Service you normally use is not among the options, please ask your teacher to contact edu.pila@oecd.org.",
        "es": "Cree una cuenta o inicie sesión en el Servicio que utiliza en su escuela. Si el Servicio que utiliza normalmente no está entre las opciones, pídale a su maestro que se comunique con edu.pila@oecd.org.",
        "fr": "Créez un compte ou connectez-vous avec le service que vous utilisez dans votre école. Si le service que vous utilisez habituellement ne figure pas parmi les options, veuillez demander à votre enseignant de contacter pila_france@povertyactionlab.org.",
        "km": "បង្កើតគណនី ឬចូលប្រើដោយសេវាដែលអ្នកប្រើនៅសាលា។ ប្រសិនបើសេវាដែលអ្នកប្រើប្រចាំមិនមានក្នុងជម្រើស សូមស្នើឲ្យគ្រូរបស់អ្នកទំនាក់ទំនងទៅ edu.pila@oecd.org។",
        "lv": "Izveidojiet kontu vai piesakieties pakalpojumā, ko izmantojat savā skolā. Ja pakalpojums, kuru parasti izmantojat, nav pieejams, lūdziet savam skolotājam sazināties ar dace.rutina@lu.lv.",
        "nl": "Maak een account aan of log in met de Dienst die u op uw school gebruikt. Als de dienst die u normaal gebruikt niet tot de mogelijkheden behoort, kunt u uw docent vragen contact op te nemen met edu.pila@oecd.org.",
        "pl": "Utwórz konto lub zaloguj się za pomocą usługi, której używasz w swojej szkole. Jeśli usługa, której zwykle używasz, nie jest dostępna, poproś nauczyciela o kontakt z edu.pila@oecd.org.",
        "pt": "Crie uma conta ou faça login com o serviço que você utiliza na sua escola. Se o serviço que você normalmente usa não estiver entre as opções, por favor, peça ao seu professor que entre em contato com edu.pila@oecd.org.",
        "sk": "Vytvor si účet alebo sa prihlás pomocou služby, ktorú používaš vo svojej škole. Ak služba, ktorú bežne používaš, nie je medzi možnosťami, požiadaj svojho učiteľa/ku, aby kontaktoval/a aitutor@minedu.sk.",
        "th": "สร้างบัญชีหรือเข้าสู่ระบบด้วยบริการที่คุณใช้ในโรงเรียนของคุณ หากบริการที่คุณใช้ปกติไม่อยู่ในตัวเลือก กรุณาขอให้ครูของคุณติดต่อ edu.pila@oecd.org"
    },
    "group-details": {
        "de": "GRUPPENDETAILS",
        "en": "GROUP DETAILS",
        "es": "DETALLES DEL GRUPO",
        "fr": "Détails du groupe",
        "km": "ព័ត៌មានលម្អិតក្រុម",
        "lv": "GRUPAS INFORMĀCIJA",
        "nl": "GROEPSGEGEVENS",
        "pl": "SZCZEGÓŁY GRUPY",
        "pt": "DETALHES DO GRUPO",
        "sk": "PODROBNOSTI SKUPINY",
        "th": "รายละเอียดของกลุ่ม"
    },
    "add-students-to-your-student-list": {
        "de": "Fügen Sie Schülerinnen und Schüler zu Ihrer Schülerinnen-/Schülerliste hinzu",
        "en": "Add students to student list",
        "es": "Agregue estudiantes a su lista de estudiantes",
        "fr": "Ajouter des élèves à votre liste",
        "km": "បន្ថែមសិស្សទៅបញ្ជីសិស្សរបស់អ្នក",
        "lv": "Pievienojiet skolēnus savam skolēnu sarakstam",
        "nl": "Voeg studenten toe aan uw studentenlijst",
        "pl": "Dodaj uczniów do listy uczniów",
        "pt": "Adicione alunos à sua lista de alunos",
        "sk": "Pridajte žiakov do svojho zoznamu žiakov",
        "th": "เพิ่มนักเรียนเข้าสู่ระบบ"
    },
    "request-role-of": {
        "de": "Rolle anfordern für",
        "en": "Request Role of",
        "es": "Solicitar rol de",
        "fr": "Demander le rôle de",
        "km": "ស្នើសុំតួនាទី",
        "lv": "Pieprasīt lomu",
        "nl": "Verzoek Rol van",
        "pl": "Poproś o rolę",
        "pt": "Solicitar função de",
        "sk": "Požiadať o rolu",
        "th": "ขอบทบาทเป็น"
    },
    "intermediate": {
        "de": "Fortgeschritten",
        "en": "Intermediate",
        "es": "Intermedia",
        "fr": "Intermédiaire",
        "km": "មធ្យម",
        "lv": "Vidēja līmeņa",
        "nl": "Tussenliggend",
        "pl": "Średniozaawansowany",
        "pt": "Intermediária",
        "sk": "Stredne pokročilý",
        "th": "ระดับปานกลาง"
    },
    "remove-all": {
        "de": "Alle entfernen",
        "en": "Remove All",
        "es": "Quitar todo",
        "fr": "Tout supprimer",
        "km": "លុបទាំងអស់",
        "lv": "Noņemt visu",
        "nl": "Alles verwijderen",
        "pl": "Usuń wszystko",
        "pt": "Remover tudo",
        "sk": "Odstrániť všetko",
        "th": "นำออกทั้งหมด"
    },
    "classes-assigned": {
        "de": "Zugewiesene Klassen",
        "en": "Classes Assigned",
        "es": "Clases asignadas",
        "fr": "Classes attribuées",
        "km": "ថ្នាក់ដែលបានចាត់តាំង",
        "lv": "Piešķirtās nodarbības",
        "nl": "Klassen toegewezen",
        "pl": "Przypisane klasy",
        "pt": "Aulas atribuídas",
        "sk": "Priradené triedy",
        "th": "ชั้นเรียนที่ได้รับมอบหมาย"
    },
    "select-teachers-in-the-group": {
        "de": "Lehrkräfte in der Gruppe auswählen",
        "en": "Select teachers in the group",
        "es": "Seleccionar maestras en el grupo",
        "fr": "Sélectionner des enseignants dans le groupe",
        "km": "ជ្រើសរើសគ្រូនៅក្នុងក្រុម",
        "lv": "Izvēlieties skolotājus grupā",
        "nl": "Selecteer docenten in de groep",
        "pl": "Wybierz nauczycieli w grupie",
        "pt": "Selecione professores no grupo",
        "sk": "Vyberte učiteľov v skupine",
        "th": "เลือกครูในกลุ่ม"
    },
    "admin-role-required": {
        "de": "Administratorenrolle erforderlich",
        "en": "Admin Role Required",
        "es": "Rol de administrador requerido",
        "fr": "Rôle administrateur requis",
        "km": "ត្រូវការតួនាទីអ្នកគ្រប់គ្រង",
        "lv": "Nepieciešama administratora loma",
        "nl": "Beheerdersrol vereist",
        "pl": "Wymagana rola administratora",
        "pt": "Função de administrador necessária",
        "sk": "Vyžaduje sa rola administrátora",
        "th": "จำเป็นมีตำแหน่งเป็นแอดมิน"
    },
    "create-edit-class": {
        "de": "Klasse erstellen/bearbeiten",
        "en": "Create / Edit Class",
        "es": "Crear / Editar Clase",
        "fr": "Créer / Modifier une classe",
        "km": "បង្កើត / កែប្រែថ្នាក់",
        "lv": "Izveidot/rediģēt klasi",
        "nl": "Klasse aanmaken/bewerken",
        "pl": "Utwórz / Edytuj klasę",
        "pt": "Criar/Editar aula",
        "sk": "Vytvoriť / upraviť triedu",
        "th": "สร้าง / แก้ไขชั้นเรียน"
    },
    "per-the-pila-personal-data-protection-notice-or": {
        "de": "Aktivieren Sie bitte dieses Kästchen gemäß der PILA-Richtlinie zum Schutz personenbezogener Daten oder den spezifischen Einwilligungsanforderungen, wenn Sie an einer Forschungsstudie über PILA teilnehmen, um zu bestätigen, dass Sie die Einwilligung der Eltern/Erziehungsberechtigten und der Schülerinnen und Schüler gemäß Ihren lokalen oder nationalen Gesetzen eingeholt haben.",
        "en": "Per the PILA Personal Data Protection Notice or the specific consent requirements if you are participating in a research study through PILA, please check this box to confirm you have collected parental/guardian and student consent as required by your local or national laws.",
        "es": "Según el Aviso de protección de datos personales de PILA o los requisitos de consentimiento específicos, si participa en un estudio de investigación a través de PILA, marque esta casilla para confirmar que ha obtenido el consentimiento de los padres/tutores y del estudiante según lo exigen las leyes locales o nacionales.",
        "fr": "Conformément à l’Avis de protection des données personnelles de PILA, ainsi qu’aux exigences relatives au consentement implicite sur la base légale de mission d’intérêt public, veuillez cocher cette case afin de confirmer que vous ne créez des profils que pour les élèves dont les parents ou représentants légaux, après avoir reçu la note d’information, n’ont pas exprimé de refus de participation à cette étude.",
        "km": "យោងតាមសេចក្តីជូនដំណឹងការពារទិន្នន័យផ្ទាល់ខ្លួន PILA ឬតាមលក្ខខណ្ឌការយល់ព្រមបច្ចេកទេស ប្រសិនបើអ្នកចូលរួមក្នុងការស្រាវជ្រាវតាម PILA សូមត្រួតពិនិត្យប្រអប់នេះដើម្បីបញ្ជាក់ថាអ្នកបានប្រមូលការយល់ព្រមពីមាតា/ឪពុក និងសិស្ស ដូចដែលតម្រូវដោយច្បាប់ក្នុងស្រុក ឬជាតិនៃអ្នក។",
        "lv": "Saskaņā ar PILA personas datu aizsardzības paziņojumu vai īpašajām piekrišanas prasībām, ja piedalāties pētnieciskajā pētījumā, izmantojot PILA, lūdzu, atzīmējiet šo izvēles rūtiņu, lai apstiprinātu, ka esat savācis vecāku/aizbildņu un skolēnu piekrišanu, kā to pieprasa jūsu vietējie vai valsts tiesību akti.",
        "nl": "In overeenstemming met de PILA-kennisgeving inzake de bescherming van persoonsgegevens of de specifieke toestemmingsvereisten als u deelneemt aan een onderzoek via PILA, vinkt u dit vakje aan om te bevestigen dat u de toestemming van ouders/voogd en studenten heeft verzameld, zoals vereist door uw lokale of nationale wetgeving.",
        "pl": "Zgodnie z informacją o ochronie danych osobowych PILA lub konkretnymi wymaganiami zgody, jeśli bierzesz udział w badaniu za pośrednictwem PILA, zaznacz to pole, aby potwierdzić, że uzyskałeś zgodę rodzica/opiekuna i ucznia zgodnie z lokalnymi lub krajowymi przepisami.",
        "pt": "De acordo com o Aviso de Proteção de Dados Pessoais do PILA ou com os requisitos de consentimento específicos, se você estiver participando de um estudo de pesquisa por meio do PILA, marque esta caixa para confirmar que você obteve o consentimento dos pais/responsáveis e do aluno, conforme exigido pelas leis locais ou nacionais.",
        "sk": "Ak sa zúčastňujete štúdie Sila spätnej väzby na platforme PILA, riaďte sa pokynmi koordinačného tímu. Všetci zapojení žiaci/žiačky musia mať platný Informovaný súhlas so zapojením sa do štúdie a Súhlas so spracovaním osobných údajov, ktorý udelil ich rodič alebo zákonný zástupca.",
        "th": "ตามประกาศคุ้มครองข้อมูลส่วนบุคคลของ PILA หรือข้อกำหนดการให้ความยินยอมเฉพาะกรณีที่ท่านเข้าร่วมการศึกษาวิจัยผ่านทาง PILA กรุณาติ๊กเครื่องหมายในช่องนี้เพื่อยืนยันว่าท่านได้รับความยินยอมจากผู้ปกครอง/ผู้ดูแล และนักเรียน ตามที่กฎหมายท้องถิ่นหรือกฎหมายระดับชาติของท่านกำหนดเรียบร้อยแล้ว"
    },
    "new-group": {
        "de": "Neue Gruppe",
        "en": "New group",
        "es": "Nuevo grupo",
        "fr": "Nouveau groupe",
        "km": "ក្រុមថ្មី",
        "lv": "Jauna grupa",
        "nl": "Nieuwe groep",
        "pl": "Nowa grupa",
        "pt": "Novo grupo",
        "sk": "Nová skupina",
        "th": "กลุ่มใหม่"
    },
    "matching": {
        "de": "Passend",
        "en": "Matching",
        "es": "Pareo",
        "fr": "Association",
        "km": "ការចំរូងគ្នា",
        "lv": "Atbilstība",
        "nl": "Passend",
        "pl": "Dopasowywanie",
        "pt": "Correspondência",
        "sk": "Zhoda",
        "th": "โยงเส้นจับคู่"
    },
    "live-monitoring-dashboard": {
        "de": "Live-Überwachungs-Dashboard",
        "en": "Live-monitoring dashboard",
        "es": "Panel de control en vivo",
        "fr": "Tableau de bord",
        "km": "ផ្ទាំងត្រួតពិនិត្យផ្ទាល់",
        "lv": "Tiešraides monitoringa panelis",
        "nl": "Live-monitoringdashboard",
        "pl": "Panel monitorowania na żywo",
        "pt": "Painel de monitoramento ao vivo",
        "sk": "Informačný panel s monitorovaním v reálnom čase",
        "th": "แดชบอร์ดติดตามแบบถ่ายทอดสด"
    },
    "you-currently-have-no-students": {
        "de": "Sie haben derzeit keine Schülerinnen und Schüler",
        "en": "You currently have no students",
        "es": "Actualmente no tienes estudiantes",
        "fr": "Vous n’avez actuellement aucun élève.",
        "km": "សព្វថ្ងៃអ្នកមិនមានសិស្សទេ",
        "lv": "Jums pašlaik nav skolēnu",
        "nl": "Je hebt momenteel geen studenten",
        "pl": "Obecnie nie masz żadnych uczniów",
        "pt": "Você não tem alunos no momento",
        "sk": "Momentálne nemáte žiadnych žiakov",
        "th": "คุณยังไม่มีนักเรียนในขณะนี้"
    },
    "role": {
        "de": "Rolle",
        "en": "Role",
        "es": "Rol",
        "fr": "Rôle",
        "km": "តួនាទី",
        "lv": "Loma",
        "nl": "Rol",
        "pl": "Rola",
        "pt": "Papel",
        "sk": "Rola",
        "th": "ตำแหน่ง"
    },
    "give-your-group-a-name": {
        "de": "Geben Sie Ihrer Gruppe einen Namen",
        "en": "Give your group a name",
        "es": "Dale un nombre a tu grupo",
        "fr": "Donnez un nom à votre groupe",
        "km": "ផ្តល់ឈ្មោះក្រុមរបស់អ្នក",
        "lv": "Piešķiriet savai grupai nosaukumu",
        "nl": "Geef je groep een naam",
        "pl": "Nadaj swojej grupie nazwę",
        "pt": "Dê um nome ao seu grupo",
        "sk": "Pomenujte svoju skupinu",
        "th": "ตั้งชื่อกลุ่ม"
    },
    "there-is-an-issue-with-your-assignment-please-as": {
        "de": "Es gibt ein Problem mit Deiner Aufgabe. Bitte Deine Lehrkraft sicherzustellen, dass sie den beabsichtigten Inhalt zugewiesen hat.",
        "en": "There is an issue with your assignment. Please ask your teacher to ensure they have assigned the intended content.",
        "es": "Hay un problema con tu tarea. Pídale a su maestro que se asegure de haber asignado el contenido previsto.",
        "fr": "Un problème est survenu avec votre activité. Veuillez demander à votre enseignant de vérifier qu’il a bien attribué le contenu prévu.",
        "km": "មានបញ្ហាជាមួយការងារដាក់តួនាទីរបស់អ្នក សូមស្នើឲ្យគ្រូរបស់អ្នកប្រាកដថាពួកគេបានចាត់តាំងមាតិកាដែលចង់បាន។",
        "lv": "Radās problēma ar tavu uzdevumu. Lūdz savam skolotājam pārliecināties, ka viņš ir piešķīris paredzēto saturu.",
        "nl": "Er is een probleem met uw opdracht. Vraag je docent om er zeker van te zijn dat hij of zij de beoogde inhoud heeft toegewezen.",
        "pl": "Wystąpił problem z Twoim zadaniem. Poproś nauczyciela, aby upewnił się, że przypisał właściwą treść.",
        "pt": "Há um problema com sua tarefa. Por favor, peça ao seu professor para garantir que ele atribuiu o conteúdo pretendido.",
        "sk": "Vyskytol sa problém s tvojou úlohou. Požiadaj svojho učiteľa, aby sa ubezpečil, že pridelil zvolený obsah.",
        "th": "กิจกรรมของท่านที่ได้รับมอบหมายมามีข้อผิดพลาด กรุณาสอบถามครูว่าได้มอบหมายงานหรือกิจกรรมให้คุณแล้วหรือไม่"
    },
    "no-tags-available": {
        "de": "Keine Schlagworte verfügbar",
        "en": "No Tags Available",
        "es": "No hay etiquetas disponibles",
        "fr": "Aucune étiquette disponible",
        "km": "គ្មានស្លាកទេ",
        "lv": "Nav pieejamu tagu",
        "nl": "Geen labels beschikbaar",
        "pl": "Brak dostępnych tagów",
        "pt": "Nenhuma etiqueta disponível",
        "sk": "Nie sú dostupné žiadne tagy",
        "th": "ขณะนี้ไม่มีแท็กที่พร้อมใช้งาน"
    },
    "no-competencies-selected-yet": {
        "de": "Noch keine Kompetenzen ausgewählt",
        "en": "No Competencies Selected Yet",
        "es": "Aún no se han seleccionado competencias",
        "fr": "Aucune compétence sélectionnée pour le moment",
        "km": "មិនទាន់បានជ្រើសរើសជំនាញនៅឡើយទេ",
        "lv": "Vēl nav atlasīta neviena kompetence",
        "nl": "Nog geen competenties geselecteerd",
        "pl": "Nie wybrano jeszcze żadnych kompetencji",
        "pt": "Nenhuma competência selecionada ainda",
        "sk": "Zatiaľ nie sú vybrané žiadne kompetencie",
        "th": "ยังไม่ได้เลือกสมรรถนะ"
    },
    "in-class": {
        "de": "Im Unterricht",
        "en": "In Class",
        "es": "en clase",
        "fr": "En classe",
        "km": "នៅក្នុងថ្នាក់",
        "lv": "Klasē",
        "nl": "In de klas",
        "pl": "W klasie",
        "pt": "Na aula",
        "sk": "V triede",
        "th": "นักเรียนในชั้น"
    },
    "it-looks-like-you-do-not-have-any-assignments": {
        "de": "Es sieht so aus, als hättest du keine Aufgaben!",
        "en": "It looks like you do not have any assignments!",
        "es": "¡Parece que no tienes ninguna tarea!",
        "fr": "Il semble que tu n'aies aucune activité à faire !",
        "km": "មើលទៅដូចជាអ្នកមិនមានកិច្ចការណាមួយទេ!",
        "lv": "Šķiet, ka jums nav neviena uzdevuma!",
        "nl": "Het lijkt erop dat je geen opdrachten hebt!",
        "pl": "Wygląda na to, że nie masz żadnych zadań!",
        "pt": "Parece que você não tem nenhuma tarefa!",
        "sk": "Zdá sa, že nemáte žiadne úlohy!",
        "th": "ดูเหมือนว่าคุณจะไม่มีงานที่ได้รับมอบหมาย!"
    },
    "assignment-details": {
        "de": "AUFGABENDETAILS",
        "en": "ASSIGNMENT DETAILS",
        "es": "DETALLES DE LA ASIGNACIÓN",
        "fr": "Détails du devoir",
        "km": "ព័ត៌មានលម្អិតការងារ",
        "lv": "UZDEVUMU KOPUMA INFORMĀCIJA",
        "nl": "OPDRACHTGEGEVENS",
        "pl": "SZCZEGÓŁY ZADANIA",
        "pt": "DETALHES DA ATRIBUIÇÃO",
        "sk": "PODROBNOSTI ÚLOHY",
        "th": "รายละเอียดกิจกรรมที่ได้รับมอบหมาย"
    },
    "you-are-about-to-create-a-student-account-on-pil": {
        "de": "Du bist dabei, ein „Schülerin/Schüler“-Konto auf PILA (der Plattform für innovative Lernbewertungen) zu erstellen. Das bedeutet, dass du damit einverstanden bist, dass Know Learning, die PILA-Entwicklerinnen und -Entwickler, Daten über deine Aktivitäten sammeln und speichern können. Du stimmst außerdem zu, dass einige der Aktivitätsdaten von Google Analytics, Google Cloud Platform und OpenAI verarbeitet (aber niemals gespeichert) werden dürfen, damit die Plattform funktioniert. OpenAI wird beispielsweise NIEMALS deine Antworten auf Fragebögen erhalten.",
        "en": "You are about to create a “student” account on PILA (the Platform for Innovative Learning Assessments). ​  This means you agree that Know Learning, the PILA developers, can collect and store data about your activity.​ You also agree that some of the activity data may be processed (but never stored) by Google Cloud Platform and OpenAI, to make the platform work. For example, OpenAI will NEVER receive your responses to questionnaires.",
        "es": "Está a punto de crear una cuenta de \"estudiante\" en PILA (la Plataforma para evaluaciones de aprendizaje innovadoras). ​ Esto significa que acepta que Know Learning, los desarrolladores de PILA, pueden recopilar y almacenar datos sobre su actividad. También acepta que algunos de los datos de la actividad pueden ser procesados ​​(pero nunca almacenados) por Google Analytics, Google Cloud Platform y OpenAI, para que la plataforma funcione. Por ejemplo, OpenAI NUNCA recibirá sus respuestas a los cuestionarios.",
        "fr": "Tu es sur le point de créer un compte élève sur PILA. Cela signifie que tu acceptes que KnowLearning (les développeurs de PILA) puisse collecter et garder des données sur ce que tu fais. Tu acceptes aussi que certaines de ces données puissent être traitées (mais jamais stockées) par Google Cloud Platform et OpenAI pour que la plateforme fonctionne. Par exemple, OpenAI ne recevra JAMAIS tes réponses aux questionnaires.",
        "km": "ដោយបង្កើតគណនី និងប្រើវេទិកាសម្រាប់ការវាយតម្លៃការសិក្សានិងច្នៃប្រឌិត (PILA) អ្នកយល់ព្រមថា KnowLearning អាចប្រមូល និងរក្សាទិន្នន័យអំពីសកម្មភាពរបស់អ្នក ហើយ Google Analytics និង Google Cloud Platform អាចដំណើរការទិន្នន័យនេះ។",
        "lv": "Tu gatavojaties izveidot “skolēna” kontu PILA (Innovative Learning Assessments) platformā. ​Tas nozīmē, ka piekrīti, ka Know Learning, PILA izstrādātāji, var vākt un uzglabāt datus par tavām darbībām.​ Tu arī piekrīti, ka Google Analytics, Google Cloud Platform un OpenAI var apstrādāt (bet nekad nesaglabāt) dažus aktivitāšu datus, lai platforma darbotos. Piemēram, OpenAI NEKAD nesaņems tavas anketu atbildes.",
        "nl": "Je staat op het punt een “studenten”-account aan te maken op PILA (het Platform voor Innovatieve Leertoetsen). Dit betekent dat u ermee akkoord gaat dat Know Learning, de PILA-ontwikkelaars, gegevens over uw activiteit kan verzamelen en opslaan. U gaat er ook mee akkoord dat sommige activiteitsgegevens kunnen worden verwerkt (maar nooit opgeslagen) door Google Analytics, Google Cloud Platform en OpenAI, om het platform te laten werken. OpenAI zal bijvoorbeeld NOOIT uw antwoorden op vragenlijsten ontvangen.",
        "pl": "Masz zamiar utworzyć konto „ucznia” na PILA (Platforma Innowacyjnych Oceniania Nauki). Oznacza to, że zgadzasz się, aby Know Learning, twórcy PILA, mogli gromadzić i przechowywać dane o Twojej aktywności. Zgadzasz się również, że niektóre dane dotyczące aktywności mogą być przetwarzane (ale nigdy przechowywane) przez Google Analytics, Google Cloud Platform i OpenAI, aby platforma działała poprawnie. Na przykład OpenAI NIGDY nie otrzyma Twoich odpowiedzi na ankiety.",
        "pt": "Você está prestes a criar uma conta de “estudante” no PILA (a Plataforma para Avaliações de Aprendizagem Inovadoras). ​ Isso significa que você concorda que a Know Learning, os desenvolvedores do PILA, podem coletar e armazenar dados sobre sua atividade.​ Você também concorda que alguns dos dados da atividade podem ser processados ​​(mas nunca armazenados) pelo Google Analytics, Google Cloud Platform e OpenAI, para fazer a plataforma funcionar. Por exemplo, a OpenAI NUNCA receberá suas respostas aos questionários.",
        "sk": "Práve sa prihlasuješ do žiackeho účtu na stránke PILA (internetová aplikácia na podporu učenia sa). Pri práci na platforme sa budú zaznamenávať niektoré údaje o tom, ako ju používaš.",
        "th": "คุณกำลังจะสร้างบัญชี “นักเรียน” บน PILA (แพลตฟอร์มการประเมินการเรียนรู้เชิงนวัตกรรม) ซึ่งหมายความว่าคุณยอมรับว่า Know Learning ผู้พัฒนา PILA สามารถเก็บและจัดเก็บข้อมูลเกี่ยวกับกิจกรรมของคุณได้ นอกจากนี้คุณยังยอมรับว่าข้อมูลบางส่วนของกิจกรรมอาจถูกประมวลผล (แต่จะไม่ถูกจัดเก็บ) โดย Google Analytics, Google Cloud Platform และ OpenAI เพื่อให้แพลตฟอร์มทำงานได้ อย่างเช่น OpenAI จะไม่เคยรับคำตอบของคุณจากแบบสอบถาม"
    },
    "manage-data": {
        "de": "Daten verwalten",
        "en": "Manage Data",
        "es": "Administrar datos",
        "fr": "Gérer les données",
        "km": "គ្រប់គ្រងទិន្នន័យ",
        "lv": "Pārvaldīt datus",
        "nl": "Beheer gegevens",
        "pl": "Zarządzaj danymi",
        "pt": "Gerenciar dados",
        "sk": "Spravovať údaje",
        "th": "จัดการข้อมูล"
    },
    "teachers": {
        "de": "Lehrkräfte",
        "en": "Teachers",
        "es": "Maestras",
        "fr": "Enseignants",
        "km": "គ្រូ",
        "lv": "Skolotāji",
        "nl": "Leraren",
        "pl": "Nauczyciele",
        "pt": "Professoras",
        "sk": "Učitelia",
        "th": "ครู"
    },
    "results": {
        "de": "Ergebnisse",
        "en": "Results",
        "es": "Resultados",
        "fr": "Résultats",
        "km": "លទ្ធផល",
        "lv": "Rezultāti",
        "nl": "Resultaten",
        "pl": "Wyniki",
        "pt": "Resultados",
        "sk": "Výsledky",
        "th": "ผลลัพธ์"
    },
    "description-is-required": {
        "de": "Beschreibung ist erforderlich",
        "en": "Description is Required",
        "es": "Se requiere descripción",
        "fr": "Une description est requise",
        "km": "តម្រូវឱ្យមានការពិពណ៌នា",
        "lv": "Nepieciešams apraksts",
        "nl": "Beschrijving is vereist",
        "pl": "Wymagany jest opis",
        "pt": "A descrição é obrigatória",
        "sk": "Popis je povinný",
        "th": "จำเป็นต้องมีคำอธิบาย"
    },
    "you-currently-have-no-active-groups": {
        "de": "Sie haben derzeit keine aktiven Gruppen.",
        "en": "You currently have no active groups.",
        "es": "Actualmente no tienes grupos activos.",
        "fr": "Vous n’avez actuellement aucun groupe actif.",
        "km": "សព្វថ្ងៃអ្នកមិនមានក្រុមសកម្មទេ។",
        "lv": "Jums pašlaik nav aktīvu grupu.",
        "nl": "Je hebt momenteel geen actieve groepen.",
        "pl": "Obecnie nie masz aktywnych grup.",
        "pt": "Atualmente você não tem grupos ativos.",
        "sk": "Momentálne nemáte žiadne aktívne skupiny.",
        "th": "ท่านไม่มีกลุ่มที่กำลังดำเนินการอยู่ในขณะนี้"
    },
    "download": {
        "de": "Herunterladen",
        "en": "Download",
        "es": "Descargar",
        "fr": "Télécharger",
        "km": "ទាញយក",
        "lv": "Lejupielādēt",
        "nl": "Downloaden",
        "pl": "Pobierz",
        "pt": "Download",
        "sk": "Stiahnuť",
        "th": "ดาวน์โหลด"
    },
    "pila-sequences": {
        "de": "PILA-SEQUENZEN",
        "en": "PILA SEQUENCES",
        "es": "SECUENCIAS DE PILA",
        "fr": "SÉQUENCES PILA",
        "km": "លំដាប់ PILA",
        "lv": "PILA UZDEVUMU GRUPA",
        "nl": "PILA-REEKS",
        "pl": "SEKWENCJE PILA",
        "pt": "SEQUÊNCIAS DE PILA",
        "sk": "SEKVENCIE PILA",
        "th": "ลำดับเนื้อหาของ PILA"
    },
    "working": {
        "de": "Wird bearbeitet",
        "en": "Working",
        "es": "Procesando",
        "fr": "Traitement en cours",
        "km": "កំពុងដំណើរការ",
        "lv": "Notiek darbs",
        "nl": "Bezig",
        "pl": "Przetwarzanie",
        "pt": "Processando",
        "sk": "Prebieha spracovanie",
        "th": "กำลังดำเนินการ"
    },
    "other-classes": {
        "de": "Andere Klassen",
        "en": "Other Classes",
        "es": "Otras clases",
        "fr": "Autres classes",
        "km": "ថ្នាក់ទៀត",
        "lv": "Citas klases",
        "nl": "Andere klassen",
        "pl": "Inne klasy",
        "pt": "Outras aulas",
        "sk": "Iné triedy",
        "th": "ชั้นเรียนอื่น ๆ"
    },
    "by-creating-my-teacher-account-i-agree-to-the-pr": {
        "de": "Mit der Erstellung meines Lehrerkontos erkläre ich mich mit der Verarbeitung meiner personenbezogenen Daten einverstanden, wie sie in der Datenschutzerklärung beschrieben ist.",
        "en": "By creating this PILA teacher account, I agree to the processing of my personal data as described in the Data Protection Notice.",
        "es": "Al crear mi cuenta de profesor, acepto el tratamiento de mis datos personales tal como se describe en el Aviso de Protección de Datos.",
        "fr": "En créant mon compte enseignant, j'accepte le traitement de mes données personnelles tel qu'il est décrit dans l'Avis de protection des données.",
        "km": "តាមរយៈការបង្កើតគណនីគ្រូរបស់ខ្ញុំ ខ្ញុំយល់ព្រមឱ្យដំណើរការទិន្នន័យផ្ទាល់ខ្លួនរបស់ខ្ញុំ ដូចដែលបានពិពណ៌នានៅក្នុងសេចក្តីជូនដំណឹងស្តីពីការការពារទិន្នន័យ។",
        "lv": "Izveidojot savu skolotāja kontu, es piekrītu manu personas datu apstrādei, kā aprakstīts Datu aizsardzības paziņojumā.",
        "nl": "Door mijn docentaccount aan te maken, ga ik akkoord met de verwerking van mijn persoonsgegevens zoals beschreven in de Privacyverklaring.",
        "pl": "Tworząc moje konto nauczyciela, wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z opisem zawartym w Informacji o ochronie danych.",
        "pt": "Ao criar a minha conta de professor, concordo com o tratamento dos meus dados pessoais conforme descrito no Aviso de Proteção de Dados.",
        "sk": "Vytvorením svojho učiteľského účtu súhlasím so spracúvaním osobných údajov tak, ako je to opísané v Súhlase učiteľa/učiteľky so spracovaním osobných údajov.",
        "th": "การสร้างบัญชีครูของฉันถือว่าฉันยินยอมให้มีการประมวลผลข้อมูลส่วนบุคคลของฉันตามที่อธิบายไว้ในประกาศการคุ้มครองข้อมูลส่วนบุคคล"
    },
    "you-currently-have-no-teachers": {
        "de": "Sie haben derzeit keine Lehrkräfte.",
        "en": "You currently have no teachers.",
        "es": "Actualmente no tienes maestras.",
        "fr": "Vous n’avez actuellement aucun enseignant.",
        "km": "សព្វថ្ងៃអ្នកមិនមានគ្រូទេ។",
        "lv": "Jums pašlaik nav skolotāju.",
        "nl": "Je hebt momenteel geen docenten.",
        "pl": "Obecnie nie masz nauczycieli.",
        "pt": "Atualmente você não tem professores.",
        "sk": "Momentálne nemáte žiadnych učiteľov.",
        "th": "ท่านไม่มีครูผู้สอนที่กำลังดำเนินการอยู่ในขณะนี้"
    },
    "leave": {
        "de": "Verlassen",
        "en": "Leave",
        "es": "Dejar",
        "fr": "Quitter",
        "km": "ចាកចេញ",
        "lv": "Iziet",
        "nl": "Vertrekken",
        "pl": "Wyjdź",
        "pt": "Deixar",
        "sk": "Odísť",
        "th": "ออก"
    },
    "new-class": {
        "de": "Neue Klasse",
        "en": "New Class",
        "es": "Nueva clase",
        "fr": "Créer une nouvelle classe",
        "km": "ថ្នាក់ថ្មី",
        "lv": "Jauna klase",
        "nl": "Nieuwe klasse",
        "pl": "Nowa klasa",
        "pt": "Nova Classe",
        "sk": "Nová trieda",
        "th": "สร้างชั้นเรียนใหม่"
    },
    "terms-and-conditions": {
        "de": "Geschäftsbedingungen",
        "en": "Terms and Conditions",
        "es": "Términos y condiciones",
        "fr": "Conditions générales",
        "km": "លក្ខខណ្ឌ និងនីតិវិធី",
        "lv": "Noteikumi",
        "nl": "Algemene voorwaarden",
        "pl": "Regulamin",
        "pt": "Termos e Condições",
        "sk": "Zmluvné podmienky",
        "th": "ข้อกำหนดและเงื่อนไข"
    },
    "description": {
        "de": "Beschreibung",
        "en": "Description",
        "es": "Descripción",
        "fr": "Description",
        "km": "ការពិពណ៌នា",
        "lv": "Apraksts",
        "nl": "Beschrijving",
        "pl": "Opis",
        "pt": "Descrição",
        "sk": "Popis",
        "th": "คำอธิบาย"
    },
    "available-languages": {
        "de": "Verfügbare Sprachen",
        "en": "Available languages",
        "es": "Idiomas disponibles",
        "fr": "Langues disponibles",
        "km": "ភាសាដែលមាន",
        "lv": "Pieejamās valodas",
        "nl": "Beschikbare talen",
        "pl": "Dostępne języki",
        "pt": "Idiomas disponíveis",
        "sk": "Dostupné jazyky",
        "th": "ภาษาที่ใช้งานได้"
    },
    "you-can-request-to-opt-back-in-later-by-contacti": {
        "de": "Sie können die erneute Anmeldung später beantragen, indem Sie den Support kontaktieren oder das Abmelden-Tag entfernen",
        "en": "You can request to opt back in later by contacting support or removing the opt-out tag",
        "es": "Puede solicitar volver a participar más tarde comunicándose con el soporte o eliminando la etiqueta de exclusión voluntaria.",
        "fr": "Vous pouvez demander à réintégrer plus tard en contactant le support ou en supprimant l’étiquette de retrait",
        "km": "អ្នកអាចស្នើសុំចូលរួមវិញនៅពេលក្រោយដោយទាក់ទងជាមួយជំនួយ ឬលុបស្លាកបោះបង់ចេញ",
        "lv": "Varat pieprasīt atteikšanos vēlāk, sazinoties ar atbalsta dienestu vai noņemot atteikšanās atzīmi",
        "nl": "U kunt later een verzoek indienen om u weer aan te melden door contact op te nemen met de ondersteuning of door de opt-out-tag te verwijderen",
        "pl": "Możesz poprosić o ponowne dołączenie później, kontaktując się z pomocą techniczną lub usuwając znacznik rezygnacji",
        "pt": "Você pode solicitar o retorno mais tarde entrando em contato com o suporte ou removendo a tag de cancelamento",
        "sk": "Ak sa budete chcieť neskôr znova prihlásiť, môžete kontaktovať podporu alebo odstrániť označenie odhlásenia.",
        "th": "คุณสามารถร้องขอให้กลับเข้าร่วมอีกครั้งได้ในภายหลังโดยติดต่อฝ่ายสนับสนุนหรือลบแท็กการยกเลิกออก"
    },
    "teachers-in-group": {
        "de": "Lehrkräfte in der Gruppe",
        "en": "Teachers in Group",
        "es": "Maestras en grupo",
        "fr": "Enseignants dans le groupe",
        "km": "គ្រូនៅក្នុងក្រុម",
        "lv": "Skolotāji grupā",
        "nl": "Leraren in groep",
        "pl": "Nauczyciele w grupie",
        "pt": "Professores em grupo",
        "sk": "Učitelia v skupine",
        "th": "ครูในกลุ่ม"
    },
    "please-send-your-full-name-school-institution-an": {
        "de": "Bitte senden Sie Ihren vollständigen Namen, Ihre Schule/Institution und diese anonyme ID an koordination.power.feedback@uni-rostock.de, um Zugang zu PILA zu erhalten.",
        "en": "Please send your full name, school/institution and this anonymous ID to edu.pila@oecd.org in order to obtain access to PILA.",
        "es": "Envíe su nombre completo, escuela/institución y esta identificación anónima a edu.pila@oecd.org para obtener acceso a PILA.",
        "fr": "Afin de confirmer la création de votre compte PILA et votre participation à l’étude « Power of Feedback », merci d’envoyer un e-mail à l’adresse suivante : pila_france@povertyactionlab.org, en indiquant : 1) votre nom complet ; 2) votre identifiant utilisateur (indiqué ci-dessous) ; 3) la phrase suivante (que vous pouvez copier-coller) afin de confirmer votre consentement : « Le temps de l’étude, je consens à ce que l’équipe de recherche conserve et utilise mon adresse e-mail afin de me contacter dans le cadre de la coordination du projet. »\nNous vous invitons également à conserver votre identifiant utilisateur dans un endroit sûr, afin de pouvoir le communiquer en cas de besoin (par exemple en cas de problème ou de demande relative à vos données).",
        "km": "សូមផ្ញើឈ្មោះពេញរបស់អ្នក សាលា/ស្ថាប័ន និង ID អនាមិកនេះទៅ edu.pila@oecd.org ដើម្បីទទួលបានការចូលប្រើ PILA។",
        "lv": "Lūdzu, nosūtiet savu pilnu vārdu, uzvārdu, skolu/iestādi un šo anonīmo ID uz laine.bluma@lu.lv, lai iegūtu piekļuvi PILA.",
        "nl": "Stuur uw volledige naam, school/instelling en dit anonieme ID naar edu.pila@oecd.org om toegang te krijgen tot PILA.",
        "pl": "Prosimy o przesłanie pełnego imienia i nazwiska, szkoły/instytucji oraz anonimowego identyfikatora na adres edu.pila@oecd.org w celu uzyskania dostępu do PILA.",
        "pt": "Por favor, envie seu nome completo, escola/instituição e esta identificação anônima para edu.pila@oecd.org para obter acesso ao PILA.",
        "sk": "Prosím, pošlite svoje celé meno, školu a toto anonymné ID na aitutor@minedu.sk, aby ste získali prístup do PILA.",
        "th": "กรุณาส่งชื่อเต็มของคุณ, ชื่อโรงเรียน/สถาบัน และไอดีนิรนามนี้ไปที่ edu.pila@oecd.org เพื่อขอรับสิทธิ์ในการเข้า PILA"
    },
    "link-students-to-you": {
        "de": "Verbinden Sie Schülerinnen und Schüler mit sich",
        "en": "Link students to you",
        "es": "Vincula a los estudiantes contigo",
        "fr": "Lier des élèves à vous",
        "km": "ភ្ជាប់សិស្សទៅអ្នក",
        "lv": "Pievienojiet skolēnus sev",
        "nl": "Koppel studenten aan jou",
        "pl": "Połącz uczniów ze sobą",
        "pt": "Vincule alunos a você",
        "sk": "Prepojte žiakov s vami",
        "th": "เพิ่มนักเรียนเข้าสู่ระบบ"
    },
    "my-assignments": {
        "de": "MEINE AUFGABEN",
        "en": "My Assignments",
        "es": "MIS TAREAS",
        "fr": "MES ACTIVITES",
        "km": "ការងាររបស់ខ្ញុំ",
        "lv": "MANI UZDEVUMI KOPUMI",
        "nl": "MIJN OPDRACHTEN",
        "pl": "MOJE ZADANIA",
        "pt": "MINHAS ATRIBUIÇÕES",
        "sk": "MOJE ÚLOHY",
        "th": "ระบบมอบหมายงานและติดตามผล"
    },
    "required": {
        "de": "Erforderlich",
        "en": "Required",
        "es": "Obligatorio",
        "fr": "Obligatoire",
        "km": "ចាំបាច់",
        "lv": "Nepieciešams",
        "nl": "Vereist",
        "pl": "Wymagane",
        "pt": "Obrigatório",
        "sk": "Povinné",
        "th": "จำเป็น"
    },
    "teacher-name": {
        "de": "Name der Lehrkraft",
        "en": "Teacher Name",
        "es": "Nombre del maestro",
        "fr": "Nom de l’enseignant",
        "km": "ឈ្មោះគ្រូ",
        "lv": "Skolotāja vārds",
        "nl": "Naam van de leraar",
        "pl": "Imię i nazwisko nauczyciela",
        "pt": "Nome do professor",
        "sk": "Meno učiteľa",
        "th": "ชื่อครู"
    },
    "opt-out-of-treatment-group": {
        "de": "Aus der Behandlungsgruppe abmelden",
        "en": "Opt out of treatment group",
        "es": "Optar por no participar en el grupo de tratamiento",
        "fr": "Se retirer du groupe de traitement",
        "km": "បោះបង់ការចូលរួមក្នុងក្រុមព្យាបាល",
        "lv": "Atteikties no pētījuma grupas",
        "nl": "Afmelden voor behandelgroep",
        "pl": "Zrezygnuj z grupy leczenia",
        "pt": "Desativar o grupo de tratamento",
        "sk": "Odhlásiť sa z experimentálnej skupiny",
        "th": "ยกเลิกการเข้าร่วมกลุ่มการรักษา"
    },
    "join": {
        "de": "Beitreten",
        "en": "Join",
        "es": "Unirse",
        "fr": "Rejoindre",
        "km": "ចូលរួម",
        "lv": "Pievienojies",
        "nl": "Meedoen",
        "pl": "Dołącz",
        "pt": "Juntar",
        "sk": "Pripoj sa",
        "th": "เข้าร่วม"
    },
    "explore": {
        "de": "Erkunden",
        "en": "Explore",
        "es": "Explorar",
        "fr": "Explorer",
        "km": "ស្វែងយល់",
        "lv": "Izpētīt",
        "nl": "Ontdekken",
        "pl": "Eksploruj",
        "pt": "Explorar",
        "sk": "Preskúmajte",
        "th": "ตรวจสอบกิจกรรมที่มีอยู่"
    },
    "visit": {
        "de": "Besuchen",
        "en": "Visit",
        "es": "Visita",
        "fr": "Visiter",
        "km": "ទៅកាន់",
        "lv": "Apmeklē",
        "nl": "Bezoek",
        "pl": "Odwiedź",
        "pt": "Visita",
        "sk": "Navštíviť",
        "th": "เข้าดู"
    },
    "my-teacher-groups": {
        "de": "MEINE LEHRKRÄFTEGRUPPEN",
        "en": "MY TEACHER GROUPS",
        "es": "Mis grupos de maestras",
        "fr": "MES GROUPES D’ENSEIGNANTS",
        "km": "ក្រុមគ្រូរបស់ខ្ញុំ",
        "lv": "MANAS SKOLOTĀJU GRUPAS",
        "nl": "MIJN LERAARGROEPEN",
        "pl": "MOJE GRUPY NAUCZYCIELI",
        "pt": "MEUS GRUPOS DE PROFESSORES",
        "sk": "MOJE SKUPINY UČITEĽOV",
        "th": "กลุ่มครู"
    },
    "you-will-be-excluded-from-future-experiments-for": {
        "de": "Sie werden von zukünftigen Experimenten für diese Partition ausgeschlossen",
        "en": "You will be excluded from future experiments for this partition",
        "es": "Serás excluido de futuros experimentos para esta partición.",
        "fr": "Vous serez exclu des futures expériences pour cette partition",
        "km": "អ្នកនឹងត្រូវបានដកចេញពីការពិសោធន៍អនាគតសម្រាប់ភាគនេះ",
        "lv": "Jūs netiksiet iekļauts turpmākajos šīs sadaļas pētījumos",
        "nl": "U wordt uitgesloten van toekomstige experimenten voor deze partitie",
        "pl": "Zostaniesz wyłączony z przyszłych eksperymentów dla tej partycji",
        "pt": "Você será excluído de experiências futuras nesta partição",
        "sk": "Budete vylúčený/á z budúcich experimentov v tejto oblasti",
        "th": "คุณจะถูกตัดออกจากการทดลองในอนาคตสำหรับพาร์ทิชันนี้"
    },
    "by-creating-my-teacher-account-i-agree-to-the-te": {
        "de": "Durch die Erstellung meines Lehrkräftekontos stimme ich den Nutzungsbedingungen und der Verarbeitung meiner personenbezogenen Daten, wie in der Datenschutzerklärung beschrieben, zu.",
        "en": "By creating this PILA teacher account, I agree to the Terms of Service and the processing of my personal data as described in the Data Protection Notice.",
        "es": "Al crear mi cuenta de profesor, acepto los Términos de servicio y el procesamiento de mis datos personales como se describe en el Aviso de protección de datos.",
        "fr": "En créant mon compte enseignant, j’accepte les Conditions d’utilisation et le traitement de mes données personnelles tel que décrit dans l’Avis de protection des données.",
        "km": "ដោយបង្កើតគណនីគ្រូរបស់ខ្ញុំ ខ្ញុំយល់ព្រមលក្ខខណ្ឌនៃសេវា និងការដំណើរការទិន្នន័យផ្ទាល់ខ្លួនរបស់ខ្ញុំដូចបានពិពណ៌នានៅក្នុងសេចក្តីជូនដំណឹងការពារទិន្នន័យ។",
        "lv": "Izveidojot savu skolotāja kontu, es piekrītu pakalpojumu sniegšanas noteikumiem un savu personas datu apstrādei, kā aprakstīts Paziņojumā par datu aizsardzību.",
        "nl": "Door mijn docentenaccount aan te maken, ga ik akkoord met de Servicevoorwaarden en de verwerking van mijn persoonlijke gegevens zoals beschreven in de Gegevensbeschermingsverklaring.",
        "pl": "Tworząc konto nauczyciela, zgadzam się z Regulaminem oraz przetwarzaniem moich danych osobowych opisanym w Informacji o ochronie danych.",
        "pt": "Ao criar minha conta de professor, concordo com os Termos de Serviço e com o processamento dos meus dados pessoais conforme descrito no Aviso de Proteção de Dados.",
        "sk": "Vytvorením svojho učiteľského účtu súhlasím so Zmluvnými podmienkami a so spracovaním mojich osobných údajov, ako je popísané v Oznámení o ochrane osobných údajov.",
        "th": "ในการสร้างบัญชีสำหรับครู ข้าพเจ้ายอมรับเงื่อนไขและข้อตกลงในการให้บริการและการประมวลผลข้อมูลส่วนบุคคล ซึ่งระบุไว้ในประกาศ เรื่อง การรักษาความปลอดภัยของข้อมูล (Data Protection Notice)"
    },
    "select-the-content-to-assign": {
        "de": "Inhalt auswählen, der zugewiesen werden soll",
        "en": "Select the content to assign",
        "es": "Selecciona el contenido a asignar",
        "fr": "Sélectionner le contenu à attribuer.",
        "km": "ជ្រើសរើសមាតិកាដើម្បីចាត់តាំង",
        "lv": "Atlasiet piešķiramo saturu",
        "nl": "Selecteer de inhoud die u wilt toewijzen",
        "pl": "Wybierz treść do przypisania",
        "pt": "Selecione o conteúdo a ser atribuído",
        "sk": "Vyberte obsah, ktorý chcete priradiť",
        "th": "เลือกกิจกรรมที่จะมอบหมาย"
    },
    "create-modify-assignment": {
        "de": "Aufgabe erstellen/ändern",
        "en": "Create/Modify Assignment",
        "es": "Crear/modificar tarea",
        "fr": "Créer/Modifier une activité",
        "km": "បង្កើត/កែប្រែការងារ",
        "lv": "Izveidot/mainīt uzdevumu",
        "nl": "Opdracht maken/wijzigen",
        "pl": "Utwórz/zmodyfikuj zadanie",
        "pt": "Criar/Modificar Atribuição",
        "sk": "Vytvoriť/upraviť úlohu",
        "th": "มอบหมายหรือปรับเปลี่ยนกิจกรรม"
    },
    "previewing": {
        "de": "Vorschau",
        "en": "Previewing",
        "es": "Vista previa",
        "fr": "Aperçu",
        "km": "កំពុងមើលជាមុន",
        "lv": "Priekšskatījums",
        "nl": "Voorbeeld bekijken",
        "pl": "Podgląd",
        "pt": "Pré-visualização",
        "sk": "Ukážka",
        "th": "ตัวอย่างกิจกรรม"
    },
    "generative-ai-module-dashboard": {
        "de": "Generatives KI-Modul-Dashboard",
        "en": "Generative AI Module Dashboard",
        "es": "Panel de control del módulo de IA generativa",
        "fr": "Tableau de bord du module d’IA générative",
        "km": "ផ្ទាំងគ្រប់គ្រងម៉ូឌុល AI បង្កើត",
        "lv": "Ģeneratīvā AI moduļa informācijas panelis",
        "nl": "Generatief AI-moduledashboard",
        "pl": "Panel modułu Generative AI",
        "pt": "Painel do módulo IA generativo",
        "sk": "Panel generatívneho modulu AI",
        "th": "แดชบอร์ดโมดูลเอไอเชิงสร้างสรรค์"
    },
    "assigned-by": {
        "de": "Zugewiesen von",
        "en": "Assigned By",
        "es": "Asignado por",
        "fr": "Attribué par",
        "km": "បានចាត់តាំងដោយ",
        "lv": "Piešķīris",
        "nl": "Toegewezen door",
        "pl": "Przypisane przez",
        "pt": "Atribuído por",
        "sk": "Pridelil",
        "th": "มอบหมายโดย"
    },
    "user": {
        "de": "Benutzerin/Benutzer",
        "en": "User",
        "es": "Usuaria",
        "fr": "Utilisateur",
        "km": "អ្នកប្រើ",
        "lv": "Lietotājs",
        "nl": "Gebruiker",
        "pl": "Użytkownik",
        "pt": "Usuária",
        "sk": "Používateľ",
        "th": "ผู้ใช้งาน"
    },
    "your-tasks": {
        "de": "Ihre Fragebögen",
        "en": "Your Tasks",
        "es": "Tus Tareas",
        "fr": "Vos questionnaires",
        "km": "កិច្ចការរបស់អ្នក",
        "lv": "Tavi uzdevumi",
        "nl": "Jouw taken",
        "pl": "Twoje Zadania",
        "pt": "As Suas Tarefas",
        "sk": "Vaše dotazníky ",
        "th": "งานของคุณ"
    },
    "role-requests": {
        "de": "Rollenanfragen",
        "en": "Role Requests",
        "es": "Solicitudes de roles",
        "fr": "Demandes de rôle",
        "km": "ស្នើសុំតួនាទី",
        "lv": "Lomu pieprasījumi",
        "nl": "Rolverzoeken",
        "pl": "Prośby o rolę",
        "pt": "Solicitações de função",
        "sk": "Žiadosti o rolu",
        "th": "ยื่นคำขอตำแหน่ง"
    },
    "opt-out": {
        "de": "Abmelden",
        "en": "Opt Out",
        "es": "Optar por no participar",
        "fr": "Se retirer",
        "km": "បោះបង់ចេញ",
        "lv": "Atteikties",
        "nl": "Afmelden",
        "pl": "Zrezygnować",
        "pt": "Excluir",
        "sk": "Odhlásiť sa",
        "th": "ยกเลิกการเข้าร่วม"
    },
    "admin": {
        "de": "Administratorin/Administrator",
        "en": "Admin",
        "es": "Administradora",
        "fr": "Administrateur",
        "km": "អ្នកគ្រប់គ្រង",
        "lv": "Administrators",
        "nl": "Beheerder",
        "pl": "Administrator",
        "pt": "Administrador",
        "sk": "Administrátor",
        "th": "จัดการข้อมูล"
    },
    "all-teachers": {
        "de": "Alle Lehrkräfte",
        "en": "All Teachers",
        "es": "Todas las maestras",
        "fr": "Tous les enseignants",
        "km": "គ្រូទាំងអស់",
        "lv": "Visi Skolotāji",
        "nl": "Alle docenten",
        "pl": "Wszyscy nauczyciele",
        "pt": "Todos os professores",
        "sk": "Všetci učitelia",
        "th": "ครูทั้งหมด"
    },
    "add-student": {
        "de": "Schülerin/Schüler hinzufügen",
        "en": "Add student",
        "es": "Agregar estudiante",
        "fr": "Ajouter un élève",
        "km": "បន្ថែមសិស្ស",
        "lv": "Pievienot skolēnu",
        "nl": "Leerling toevoegen",
        "pl": "Dodaj ucznia",
        "pt": "Adicionar aluno",
        "sk": "Pridať žiaka",
        "th": "เพิ่มนักเรียน"
    },
    "game-design": {
        "de": "Spieldesign",
        "en": "Game Design",
        "es": "Diseño de juegos",
        "fr": "Conception de jeux",
        "km": "រចនាហ្គេម",
        "lv": "Spēles dizains",
        "nl": "Spelontwerp",
        "pl": "Projektowanie gier",
        "pt": "Design de jogos",
        "sk": "Herný dizajn",
        "th": "การออกแบบเกม"
    },
    "cancel": {
        "de": "abbrechen",
        "en": "Cancel",
        "es": "Cancelar",
        "fr": "annuler",
        "km": "បោះបង់",
        "lv": "atcelt",
        "nl": "annuleren",
        "pl": "anuluj",
        "pt": "cancelar",
        "sk": "zrušiť",
        "th": "ยกเลิก"
    },
    "play": {
        "de": "starten",
        "en": "play",
        "es": "jugar",
        "fr": "démarrer",
        "km": "លេង",
        "lv": "sākt",
        "nl": "toneelstuk",
        "pl": "odtwórz",
        "pt": "jogar",
        "sk": "spustiť",
        "th": "เล่น"
    },
    "give-your-class-a-name": {
        "de": "Geben Sie Ihrer Klasse einen Namen",
        "en": "Give your class a name",
        "es": "Dale un nombre a tu clase",
        "fr": "Donnez un nom à votre classe",
        "km": "ផ្តល់ឈ្មោះថ្នាក់របស់អ្នក",
        "lv": "Piešķiriet savai klasei nosaukumu",
        "nl": "Geef je klas een naam",
        "pl": "Nadaj swojej klasie nazwę",
        "pt": "Dê um nome à sua classe",
        "sk": "Pomenujte svoju triedu",
        "th": "กรุณาระบุชื่อชั้นเรียน"
    },
    "terms-of-service-and-data-protection-notice": {
        "de": "Nutzungsbedingungen und Datenschutzhinweise",
        "en": "Terms of Service and Data Protection Notice",
        "es": "Términos de Servicio y Aviso de Protección de Datos",
        "fr": "Conditions d’utilisation et Avis de protection des données",
        "km": "លក្ខខណ្ឌសេវា និងសេចក្តីជូនដំណឹងការពារទិន្នន័យ",
        "lv": "Pakalpojuma noteikumi un datu aizsardzības paziņojums",
        "nl": "Servicevoorwaarden en mededeling over gegevensbescherming",
        "pl": "Regulamin i Informacja o ochronie danych",
        "pt": "Termos de Serviço e Aviso de Proteção de Dados",
        "sk": "Oznámenie o ochrane osobných údajov",
        "th": "ประกาศ เรื่อง ข้อกำหนดในการให้บริการและการรักษาความปลอดภัยของข้อมูล"
    },
    "share-this-link-with-your-students": {
        "de": "Teilen Sie diesen Link mit Ihren Schülerinnen und Schülern:",
        "en": "Share this link with your students",
        "es": "Comparte este enlace con tus alumnas:",
        "fr": "Partagez ce lien avec vos élèves :",
        "km": "ចែករំលែកតំណនេះជាមួយសិស្សរបស់អ្នក:",
        "lv": "Kopīgojiet šo saiti ar saviem skolēniem:",
        "nl": "Deel deze link met uw leerlingen:",
        "pl": "Udostępnij ten link swoim uczniom:",
        "pt": "Compartilhe este link com seus alunos:",
        "sk": "Zdieľajte tento odkaz so svojimi žiakmi:",
        "th": "กรุณาส่งลิงก์นี้ให้กับนักเรียนของท่าน เพื่อเพิ่มนักเรียนเข้าสู่ระบบ: "
    },
    "class-assigned": {
        "de": "Klasse zugewiesen",
        "en": "Class Assigned",
        "es": "Clase asignada",
        "fr": "Classe attribuée",
        "km": "ថ្នាក់បានចាត់តាំង",
        "lv": "Piešķirta klase",
        "nl": "Klasse toegewezen",
        "pl": "Przypisana klasa",
        "pt": "Classe atribuída",
        "sk": "Priradená trieda",
        "th": "ชั้นเรียนที่ได้รับมอบหมาย"
    },
    "click-here-to-reload-once-you-receive-approval-c": {
        "de": "Klicken Sie hier, um erneut zu laden, sobald Sie die Genehmigungsbestätigung erhalten haben",
        "en": "Click here to reload once you receive approval confirmation",
        "es": "Haga clic aquí para recargar una vez que reciba la confirmación de aprobación",
        "fr": "Cliquez ici pour recharger une fois que vous avez reçu la confirmation d’approbation",
        "km": "ចុចទីនេះដើម្បីបង្ហាញឡើងវិញបន្ទាប់ពីទទួលការបញ្ជាក់អនុម័ត",
        "lv": "Noklikšķiniet šeit, lai atkārtoti ielādētu, tiklīdz esat saņēmis apstiprinājuma apstiprinājumu",
        "nl": "Klik hier om opnieuw te laden zodra u een goedkeuringsbevestiging ontvangt",
        "pl": "Kliknij tutaj, aby odświeżyć po otrzymaniu potwierdzenia",
        "pt": "Clique aqui para recarregar assim que receber a confirmação de aprovação",
        "sk": "Po potvrdení o schválení Vášho účtu znovu načítajte stránku, aby ste sa prihlásili.",
        "th": "คลิ๊กที่นี่เพื่อโหลดอีกครั้ง หลังจากที่คุณได้รับการยืนยันคำอนุมัติ"
    },
    "you-have-joined-this-teacher": {
        "de": "Du bist dieser Lehrkraft beigetreten.",
        "en": "You have joined this teacher.",
        "es": "Te has unido a esta profesora.",
        "fr": "Tu as rejoint cet enseignant.",
        "km": "អ្នកបានចូលរួមជាមួយគ្រូនេះ។",
        "lv": "Tu esi pievienojies šim skolotājam.",
        "nl": "Je bent lid geworden van deze leraar.",
        "pl": "Dołączyłeś do tego nauczyciela.",
        "pt": "Você se juntou a este professor.",
        "sk": "Pripojil si sa k tomuto/tejto učiteľovi/ke.",
        "th": "คุณเข้าร่วมชั้นเรียนเรียบร้อยแล้ว"
    },
    "copy-link": {
        "de": "Link kopieren",
        "en": "Copy link",
        "es": "Copiar enlace",
        "fr": "Copier le lien",
        "km": "ចម្លងតំណ",
        "lv": "Kopēt saiti",
        "nl": "Kopieer link",
        "pl": "Kopiuj link",
        "pt": "Copiar link",
        "sk": "Kopírovať odkaz",
        "th": "คัดลอกลิงก์"
    },
    "resources": {
        "de": "Ressourcen",
        "en": "Resources",
        "es": "Recursos",
        "fr": "Ressources",
        "km": "ធនធាន",
        "lv": "Resursi",
        "nl": "Bronnen",
        "pl": "Zasoby",
        "pt": "Recursos",
        "sk": "Zdroje",
        "th": "ทรัพยากร"
    },
    "students-in-class": {
        "de": "Schülerinnen und Schüler in der Klasse:",
        "en": "Students in Class:",
        "es": "Alumnas en clase:",
        "fr": "Élèves dans la classe :",
        "km": "សិស្សនៅក្នុងថ្នាក់:",
        "lv": "Skolēni klasē:",
        "nl": "Studenten in de klas:",
        "pl": "Uczniowie w klasie:",
        "pt": "Alunos em aula:",
        "sk": "Žiaci v triede:",
        "th": "รายชื่อนักเรียนในชั้นเรียน:"
    },
    "unable-to-load-your-tasks": {
        "de": "Ihre Fragebögen konnten nicht geladen werden.",
        "en": "Unable to load your tasks.",
        "es": "No se pudieron cargar tus tareas.",
        "fr": "Impossible de charger vos questionnaires.",
        "km": "មិនអាចផ្ទុកកិច្ចការរបស់អ្នកបានទេ។",
        "lv": "Neizdevās ielādēt tavus uzdevumus.",
        "nl": "Je taken konden niet worden geladen.",
        "pl": "Nie udało się załadować Twoich zadań.",
        "pt": "Não foi possível carregar suas tarefas.",
        "sk": "Vaše úlohy sa nepodarilo načítať.",
        "th": "ไม่สามารถโหลดงานของคุณได้"
    },
    "my-classes": {
        "de": "MEINE KLASSEN",
        "en": "MY CLASSES",
        "es": "MIS CLASES",
        "fr": "MES CLASSES",
        "km": "ថ្នាក់របស់ខ្ញុំ",
        "lv": "MANAS NODARBĪBAS",
        "nl": "MIJN KLASSEN",
        "pl": "MOJE KLASY",
        "pt": "MINHAS AULAS",
        "sk": "MOJE TRIEDY",
        "th": "ชั้นเรียน"
    },
    "you-are-currently-included-in-the-treatment-grou": {
        "de": "Sie sind derzeit in der Behandlungsgruppe enthalten. Sie können Sich jederzeit abmelden.",
        "en": "You are currently included in the treatment group. You can opt out at any time.",
        "es": "Actualmente está incluido en el grupo de tratamiento. Puede optar por no participar en cualquier momento.",
        "fr": "Vous faites actuellement partie du groupe de traitement. Vous pouvez vous retirer à tout moment.",
        "km": "បច្ចុប្បន្នអ្នកត្រូវបានរួមបញ្ចូលនៅក្នុងក្រុមព្យាបាល។ អ្នកអាចបោះបង់ចេញពេលណាក៏បាន។",
        "lv": "Pašlaik esat iekļauts pētījuma grupā. Varat jebkurā laikā atteikties.",
        "nl": "U maakt momenteel deel uit van de behandelgroep. U kunt zich op elk moment afmelden.",
        "pl": "Obecnie jesteś w grupie leczenia. Możesz zrezygnować w dowolnym momencie.",
        "pt": "Você está atualmente incluído no grupo de tratamento. Você pode cancelar a qualquer momento.",
        "sk": "Momentálne ste zaradení do experimentálnej skupiny. Kedykoľvek sa môžete odhlásiť.",
        "th": "ขณะนี้คุณถูกรวมอยู่ในกลุ่มการรักษา คุณสามารถยกเลิกได้ทุกเมื่อ"
    },
    "activity-dashboard": {
        "de": "Aktivitäts-Dashboard",
        "en": "Activity dashboard",
        "es": "Panel de actividad",
        "fr": "ableau de Bord des Activités",
        "km": "ផ្ទាំងគ្រប់គ្រងសកម្មភាព",
        "lv": "Darbību informācijas panelis",
        "nl": "Activiteitendashboard",
        "pl": "Panel Aktywności",
        "pt": "Painel de atividades",
        "sk": "Panel aktivity",
        "th": "แดชบอร์ดกิจกรรม"
    },
    "bug-report": {
        "de": "Fehlerbericht",
        "en": "Bug Report",
        "es": "Informe de error",
        "fr": "Rapport de dysfonctionnement",
        "km": "រាយការណ៍បញ្ហា",
        "lv": "Kļūdu ziņojums",
        "nl": "Bugrapport",
        "pl": "Raport błędu",
        "pt": "Relatório de erros",
        "sk": "Nahlásenie chyby",
        "th": "รายงานข้อบกพร่อง"
    },
    "publish-to-explore": {
        "de": "In „Entdecken“ veröffentlichen",
        "en": "Publish to Explore",
        "es": "Publicar en Explorar",
        "fr": "Publier dans Explorer",
        "km": "ផ្សព្វផ្សាយទៅ Explore",
        "lv": "Publicēt sadaļā Izpētīt",
        "nl": "Publiceren naar Ontdekken",
        "pl": "Opublikuj w sekcji Odkrywaj",
        "pt": "Publicar em Explorar",
        "sk": "Publikovať do sekcie Preskúmať",
        "th": "เผยแพร่ไปยังหน้าสำรวจ"
    },
    "request-another-feature": {
        "de": "Eine weitere Funktion anfordern",
        "en": "Request Another Feature",
        "es": "Solicitar otra característica",
        "fr": "Demander une autre fonctionnalité",
        "km": "ស្នើសុំមុខងារផ្សេងទៀត",
        "lv": "Pieprasīt citu funkciju",
        "nl": "Vraag een andere functie aan",
        "pl": "Poproś o kolejną funkcję",
        "pt": "Solicite outro recurso",
        "sk": "Požiadať o ďalšiu funkciu",
        "th": "ขอคุณสมบัติอีกอัน"
    },
    "done": {
        "de": "Erledigt",
        "en": "Done",
        "es": "Hecho",
        "fr": "Terminer",
        "km": "បញ្ចប់",
        "lv": "Gatavs",
        "nl": "Klaar",
        "pl": "Gotowe",
        "pt": "Concluído",
        "sk": "Hotovo",
        "th": "เสร็จสิ้น"
    },
    "what-opting-out-means": {
        "de": "Was Abmelden bedeutet",
        "en": "What Opting Out Means",
        "es": "Qué significa optar por no participar",
        "fr": "Que signifie se retirer",
        "km": "អត្ថន័យនៃការបោះបង់ចេញ",
        "lv": "Ko nozīmē atteikšanās",
        "nl": "Wat opt-out betekent",
        "pl": "Co oznacza rezygnacja",
        "pt": "O que significa cancelar",
        "sk": "Čo znamená odhlásenie",
        "th": "ความหมายของการยกเลิก"
    },
    "creative-thinking": {
        "de": "Kreatives Denken",
        "en": "Creative Thinking",
        "es": "Pensamiento creativo",
        "fr": "Pensée créative",
        "km": "ការគិតច្នៃប្រឌិត",
        "lv": "Radoša domāšana",
        "nl": "Creatief denken",
        "pl": "Kreatywne myślenie",
        "pt": "Pensamento Criativo",
        "sk": "Kreatívne myslenie",
        "th": "ความคิดสร้างสรรค์"
    },
    "total-time-seconds": {
        "de": "Gesamtzeit (Sekunden)",
        "en": "Total Time (seconds)",
        "es": "Tiempo total (segundos)",
        "fr": "Temps total (secondes)",
        "km": "ពេលសរុប (វិនាទី)",
        "lv": "Kopējais laiks (sekundēs)",
        "nl": "Totale tijd (seconden)",
        "pl": "Łączny czas (sekundy)",
        "pt": "Tempo total (segundos)",
        "sk": "Celkový čas (sekundy)",
        "th": "เวลาทั้งหมด (วินาที)"
    },
    "teacher-groups": {
        "de": "LEHRKRÄFTEGRUPPEN",
        "en": "TEACHER GROUPS",
        "es": "GRUPOS DE PROFESORES",
        "fr": "GROUPES D’ENSEIGNANTS",
        "km": "ក្រុមគ្រូ",
        "lv": "SKOLOTĀJU GRUPAS",
        "nl": "LERAARGROEPEN",
        "pl": "GRUPY NAUCZYCIELI",
        "pt": "GRUPOS DE PROFESSORES",
        "sk": "SKUPINY UČITEĽA",
        "th": "กลุ่มครู"
    },
    "yes-opt-me-out": {
        "de": "Ja, melde mich ab",
        "en": "Yes, opt me out",
        "es": "Sí, excluyeme",
        "fr": "Oui, me retirer",
        "km": "បាទ/ចាស បោះបង់ខ្ញុំចេញ",
        "lv": "Jā, atteikties no manis",
        "nl": "Ja, meld mij af",
        "pl": "Tak, zrezygnuj mnie",
        "pt": "Sim, desative-me",
        "sk": "Áno, odhláste ma",
        "th": "ใช่ ยกเลิกฉัน"
    },
    "teacher-login": {
        "de": "Lehrkräfte-Anmeldung",
        "en": "Teacher Login",
        "es": "Inicio de sesión de profesor",
        "fr": "Se connecter en tant qu'enseignant",
        "km": "ចូលប្រើគ្រូ",
        "lv": "Skolotāja pieteikšanās/Login",
        "nl": "Inloggen voor docenten",
        "pl": "Logowanie nauczyciela",
        "pt": "Login do professor",
        "sk": "Prihlásenie učiteľa",
        "th": "เข้าสู่ระบบครู"
    },
    "no-classes-assigned": {
        "de": "keine Klassen zugewiesen",
        "en": "no classes assigned",
        "es": "no hay clases asignadas",
        "fr": "aucune classe attribuée",
        "km": "គ្មានថ្នាក់បានចាត់តាំង",
        "lv": "nav piešķirtas nodarbības",
        "nl": "geen lessen toegewezen",
        "pl": "Brak przypisanych klas",
        "pt": "nenhuma aula atribuída",
        "sk": "nie sú priradené žiadne triedy",
        "th": "ไม่มีชั้นเรียนที่ได้รับมอบหมาย"
    },
    "new-assignment": {
        "de": "Neue Aufgabe",
        "en": "New Assignment",
        "es": "Nueva tarea",
        "fr": "Nouvelle activité",
        "km": "ការងារថ្មី",
        "lv": "Jauns uzdevumu kopums",
        "nl": "Nieuwe opdracht",
        "pl": "Nowe zadanie",
        "pt": "Nova tarefa",
        "sk": "Nová úloha",
        "th": "มอบหมายกิจกรรมใหม่"
    },
    "no-data-available": {
        "de": "Keine Daten verfügbar",
        "en": "No Data Available",
        "es": "No hay datos disponibles",
        "fr": "Aucune donnée disponible",
        "km": "គ្មានទិន្នន័យ",
        "lv": "Dati nav pieejami",
        "nl": "Geen gegevens beschikbaar",
        "pl": "Brak dostępnych danych",
        "pt": "Nenhum dado disponível",
        "sk": "Nie sú k dispozícii žiadne údaje",
        "th": "ไม่มีข้อมูล"
    },
    "assignment": {
        "de": "Aufgabe",
        "en": "Assignment",
        "es": "Asignación",
        "fr": "Activité",
        "km": "ការងារ",
        "lv": "Izvēlētais kopums",
        "nl": "Opdracht",
        "pl": "Zadanie",
        "pt": "Atribuição",
        "sk": "Úloha",
        "th": "กิจกรรม"
    },
    "join-teacher": {
        "de": "Lehrkraft beitreten",
        "en": "Join Teacher",
        "es": "Únase al maestro",
        "fr": "Rejoindre l’enseignant",
        "km": "ចូលរួមគ្រូ",
        "lv": "Pievienojieties skolotājam",
        "nl": "Sluit je aan bij Leraar",
        "pl": "Dołącz do nauczyciela",
        "pt": "Junte-se ao professor",
        "sk": "Pridaj sa k učiteľovi/ke",
        "th": "เข้าร่วมชั้นเรียน"
    },
    "select-classes-for-the-assignment": {
        "de": "Klassen für die Aufgabe auswählen",
        "en": "Select Classes for the Assignment",
        "es": "Seleccione clases para la tarea",
        "fr": "Sélectionner des classes pour l'activité",
        "km": "ជ្រើសរើសថ្នាក់សម្រាប់ការងារ",
        "lv": "Izēlēties klasi uzdevumu kopumam",
        "nl": "Selecteer Klassen voor de opdracht",
        "pl": "Wybierz klasy dla zadania",
        "pt": "Selecione turmas para a tarefa",
        "sk": "Vyberte triedy pre úlohy",
        "th": "เลือกชั้นเรียนเพื่อมอบหมายกิจกรรม"
    },
    "self-regulated-learning": {
        "de": "Selbstreguliertes Lernen",
        "en": "Self-Regulated Learning",
        "es": "Aprendizaje autorregulado",
        "fr": "Apprentissage autorégulé",
        "km": "ការសិក្សាដោយគ្រប់គ្រងខ្លួនឯង",
        "lv": "Pašregulēta mācīšanās",
        "nl": "Zelfregulerend leren",
        "pl": "Uczenie samodzielne",
        "pt": "Aprendizagem Autorregulada",
        "sk": "Samoregulované učenie",
        "th": "การเรียนรู้แบบกำกับตนเอง"
    },
    "all-saved-versions-of-your-answers-solutions-inc": {
        "de": "alle gespeicherten Versionen deiner Antworten/Lösungen, einschließlich deiner Gespräche mit KI-Chatbots (falls zutreffend)",
        "en": "all saved versions of your answers/solutions, including your conversations with AI chatbots (if applicable)",
        "es": "todas las versiones guardadas de sus respuestas/soluciones, incluidas sus conversaciones con chatbots de IA (si corresponde)",
        "fr": "Toutes les versions de tes réponses et solutions",
        "km": "ចម្លើយ/ដំណោះស្រាយដែលបានរក្សាទុកទាំងអស់",
        "lv": "visas tavas saglabātās atbilžu/risinājumu versijas, tostarp sarunas ar MI tērzēšanas robotiem (ja piemērojams)",
        "nl": "alle opgeslagen versies van uw antwoorden/oplossingen, inclusief uw gesprekken met AI-chatbots (indien van toepassing)",
        "pl": "wszystkie zapisane wersje Twoich odpowiedzi/rozwiązań",
        "pt": "todas as versões salvas de suas respostas/soluções, incluindo suas conversas com chatbots de IA (se aplicável)",
        "sk": "všetky uložené verzie tvojich odpovedí a riešení vrátane tvojich rozhovorov s AI četbotom (ak ho máš k dispozícii)",
        "th": "คำตอบ/วิธีการแก้ปัญหาทั้งหมดของท่านที่ได้ทำการบันทึกไว้"
    },
    "publishing": {
        "de": "Wird veröffentlicht",
        "en": "Publishing",
        "es": "Publicando",
        "fr": "Publication en cours",
        "km": "កំពុងផ្សព្វផ្សាយ",
        "lv": "Notiek publicēšana",
        "nl": "Publiceren",
        "pl": "Publikowanie",
        "pt": "Publicando",
        "sk": "Prebieha publikovanie",
        "th": "กำลังเผยแพร่"
    },
    "no-role-requests-yet": {
        "de": "Noch keine Rollenanfragen",
        "en": "No Role Requests Yet",
        "es": "Aún no hay solicitudes de roles",
        "fr": "Aucune demande de rôle pour l’instant",
        "km": "មិនមានស្នើសុំតួនាទីនៅឡើយទេ",
        "lv": "Vēl nav neviena lomas pieprasījuma",
        "nl": "Nog geen rolverzoeken",
        "pl": "Brak próśb o rolę",
        "pt": "Nenhuma solicitação de função ainda",
        "sk": "Zatiaľ žiadne žiadosti o rolu",
        "th": "ยังไม่มีการยื่นขอตำแหน่ง"
    },
    "to-request-deletion-of-data-please-email-data-re": {
        "de": "Um die Löschung von Daten zu beantragen, senden Sie bitte eine E-Mail an data-requests@knowlearning.org",
        "en": "To request deletion of data, please email data-requests@knowlearning.org",
        "es": "Para solicitar la eliminación de datos, envíe un correo electrónico a data-requests@knowlearning.org",
        "fr": "Pour demander la suppression de données, veuillez envoyer un e-mail à data-requests@knowlearning.org",
        "km": "ដើម្បីស្នើសុំលុបទិន្នន័យ សូមផ្ញើអ៊ីមែលទៅ data-requests@knowlearning.org",
        "lv": "Lai pieprasītu datu dzēšanu, lūdzu, rakstiet uz e-pastu data-requests@knowlearning.org",
        "nl": "Om verwijdering van gegevens aan te vragen, kunt u een e-mail sturen naar data-requests@knowlearning.org",
        "pl": "Aby poprosić o usunięcie danych, wyślij e-mail na adres data-requests@knowlearning.org",
        "pt": "Para solicitar a exclusão de dados, envie um e-mail para data-requests@knowlearning.org",
        "sk": "Ak chcete požiadať o vymazanie údajov, pošlite e-mail na adresu aitutor@minedu.sk",
        "th": "การร้องขอสำหรับการลบข้อมูล โปรดส่งอีเมล์ไปที่ data-requests@knowlearning.org"
    },
    "upload": {
        "de": "Hochladen",
        "en": "Upload",
        "es": "Subir",
        "fr": "Téléverser",
        "km": "ផ្ទុកឡើង",
        "lv": "Augšupielādēt",
        "nl": "Uploaden",
        "pl": "Prześlij",
        "pt": "Carregar",
        "sk": "Nahrať",
        "th": "อัพโหลด"
    },
    "your-suggestion": {
        "de": "Ihr Vorschlag",
        "en": "Your Suggestion",
        "es": "Tu sugerencia",
        "fr": "Votre suggestion",
        "km": "សំណើរបស់អ្នក",
        "lv": "Jūsu ieteikums",
        "nl": "Jouw suggestie",
        "pl": "Twoja sugestia",
        "pt": "Sua sugestão",
        "sk": "Váš návrh",
        "th": "ข้อเสนอแนะของคุณ"
    },
    "pila-create": {
        "de": "PILA ERSTELLEN",
        "en": "PILA CREATE",
        "es": "PILA CREAR",
        "fr": "PILA CRÉER",
        "km": "បង្កើត PILA",
        "lv": "PILA \"RADĪT\"",
        "nl": "PILA CREËREN",
        "pl": "TWÓRZ WŁASNĄ TREŚĆ",
        "pt": "PILA CRIAR",
        "sk": "PILA VYTVORIŤ",
        "th": "PILA คริเอท"
    },
    "select": {
        "de": "Auswählen",
        "en": "Select",
        "es": "Seleccionar",
        "fr": "Sélectionner",
        "km": "ជ្រើសរើស",
        "lv": "Izvēlieties",
        "nl": "Selecteer",
        "pl": "Wybierz",
        "pt": "Selecione",
        "sk": "Vyberte",
        "th": "เลือก"
    },
    "create-your-own-content": {
        "de": "ERSTELLEN SIE IHRE EIGENEN INHALTE",
        "en": "CREATE YOUR OWN CONTENT",
        "es": "CREA TU PROPIO CONTENIDO",
        "fr": "CRÉEZ VOTRE PROPRE CONTENU",
        "km": "បង្កើតមាតិការបស់អ្នក",
        "lv": "IZVEIDOJIET SAVU SATURU",
        "nl": "MAAK JE EIGEN INHOUD",
        "pl": "UTWÓRZ WŁASNĄ TREŚĆ",
        "pt": "CRIE SEU PRÓPRIO CONTEÚDO",
        "sk": "VYTVORTE SI VLASTNÝ OBSAH",
        "th": "สร้างบทเรียนด้วยตนเอง"
    },
    "login-report": {
        "de": "Anmeldebericht",
        "en": "Login Report",
        "es": "Informe de inicio de sesión",
        "fr": "Rapport de connexion",
        "km": "របាយការណ៍ចូលប្រើ",
        "lv": "Pieteikšanās ziņojums",
        "nl": "Inloggen rapport",
        "pl": "Raport logowania",
        "pt": "Relatório de login",
        "sk": "Správa o prihlásení",
        "th": "รายงานการเข้าสู่ระบบ"
    },
    "name": {
        "de": "Name",
        "en": "Name",
        "es": "Nombre",
        "fr": "Nom",
        "km": "ឈ្មោះ",
        "lv": "Vārds",
        "nl": "Naam",
        "pl": "Imię i nazwisko",
        "pt": "Nome",
        "sk": "Meno",
        "th": "ชื่อ"
    },
    "select-students-in-the-class": {
        "de": "Wählen Sie die Schülerinnen und Schüler der Klasse aus",
        "en": "Select students in the class",
        "es": "Seleccionar estudiantes en la clase.",
        "fr": "Sélectionner des élèves dans la classe",
        "km": "ជ្រើសរើសសិស្សនៅក្នុងថ្នាក់",
        "lv": "Izvēlieties skolēnus klasē",
        "nl": "Selecteer leerlingen in de klas",
        "pl": "Wybierz uczniów w klasie",
        "pt": "Selecione os alunos da turma",
        "sk": "Vyberte žiakov v triede",
        "th": "เลือกนักเรียนในชั้นเรียน"
    },
    "teacher-view": {
        "de": "Lehrkräfteansicht",
        "en": "Teacher View",
        "es": "Vista del profesor",
        "fr": "Vue enseignant",
        "km": "មើលគ្រូ",
        "lv": "Skolotāja skats",
        "nl": "Leraarweergave",
        "pl": "Widok nauczyciela",
        "pt": "Visão do professor",
        "sk": "Pohľad učiteľa",
        "th": "มุมมองครู"
    },
    "unarchive": {
        "de": "Dearchivieren",
        "en": "Unarchive",
        "es": "Desarchivar",
        "fr": "Désarchiver",
        "km": "ដកពីឯកសារចាស់",
        "lv": "Atarhivēt",
        "nl": "Uit het archief halen",
        "pl": "Przywróć z archiwum",
        "pt": "Desarquivar",
        "sk": "Zrušiť archiváciu",
        "th": "ยกเลิกการจัดเก็บ"
    },
    "loading": {
        "de": "Laden",
        "en": "loading",
        "es": "cargando",
        "fr": "chargement",
        "km": "កំពុងផ្ទុក",
        "lv": "iekraušana",
        "nl": "laden",
        "pl": "Ładowanie",
        "pt": "carregando",
        "sk": "načítava sa",
        "th": "กำลังโหลด"
    },
    "bettys-brain": {
        "de": "BETTY'S GEHIRN",
        "en": "BETTY'S BRAIN",
        "es": "EL CEREBRO DE BETTY",
        "fr": "LE CERVEAU DE BETTY",
        "km": "ខួរក្បាល BETTY",
        "lv": "BETIJAS PRĀTS",
        "nl": "BETTY'S HERSENEN",
        "pl": "MÓZG BETTY",
        "pt": "CÉREBRO DE BETTY",
        "sk": "BETTYIN MOZOG",
        "th": "BETTY'S BRAIN"
    },
    "select-new": {
        "de": "Neu wählen",
        "en": "Select New",
        "es": "Seleccione Nuevo",
        "fr": "Sélectionner nouveau",
        "km": "ជ្រើសរើសថ្មី",
        "lv": "Atlasiet Jauns",
        "nl": "Selecteer Nieuw",
        "pl": "Wybierz nowy",
        "pt": "Selecione Novo",
        "sk": "Vyberte novú položku",
        "th": "คลิกที่นี่! เพื่อเลือกกิจกรรม"
    },
    "customised-items": {
        "de": "Angepasste Items",
        "en": "Customised Items",
        "es": "Artículos personalizados",
        "fr": "Éléments personnalisés",
        "km": "ធាតុផ្ទាល់ខ្លួន",
        "lv": "Pielāgoti uzdevumi",
        "nl": "Aangepaste artikelen",
        "pl": "Elementy spersonalizowane",
        "pt": "Itens personalizados",
        "sk": "Prispôsobené položky",
        "th": "รายการที่ปรับแต่งเอง"
    },
    "secondary": {
        "de": "Sekundär",
        "en": "Secondary",
        "es": "Secundaria",
        "fr": "Secondaire",
        "km": "ប្រភេទទី២",
        "lv": "Sekundārais",
        "nl": "Secundair",
        "pl": "Średniozaawansowany",
        "pt": "Secundária",
        "sk": "Sekundárne",
        "th": "ระดับมัธยมศึกษา"
    },
    "give-your-assignment-a-description": {
        "de": "Geben Sie Ihrer Aufgabe eine Beschreibung",
        "en": "Give your assignment a description",
        "es": "Dale una descripción a tu tarea",
        "fr": "Description de votre activité",
        "km": "ផ្តល់ការពិពណ៌នាអំពីការងាររបស់អ្នក",
        "lv": "Sniedziet aprakstu savam uzdevumu kopumam",
        "nl": "Geef uw opdracht een omschrijving",
        "pl": "Nadaj swojemu zadaniu opis",
        "pt": "Dê uma descrição à sua tarefa",
        "sk": "Popíšte svoju úlohu",
        "th": "คำบรรยายเกี่ยวกับกิจกรรม"
    },
    "data-protection-notice-for-teachers": {
        "de": "Datenschutzhinweis für Lehrkräfte",
        "en": "Data Protection Notice for Teachers",
        "es": "Aviso de Protección de Datos para Profesores",
        "fr": "Avis de protection des données pour les enseignants",
        "km": "សេចក្តីជូនដំណឹងការពារទិន្នន័យសម្រាប់គ្រូ",
        "lv": "Paziņojums par datu aizsardzību skolotājiem",
        "nl": "Kennisgeving over gegevensbescherming voor docenten",
        "pl": "Informacja o ochronie danych dla nauczycieli",
        "pt": "Aviso de proteção de dados para professores",
        "sk": "Súhlas učiteľa/učiteľky so spracovaním osobných údajov",
        "th": "ประกาศ เรื่อง การรักษาความปลอดภัยของข้อมูล (Data Protection Notice) สำหรับครู"
    },
    "supervisor": {
        "de": "Supervisorin/Supervisor",
        "en": "Supervisor",
        "es": "Supervisora",
        "fr": "Superviseur",
        "km": "អ្នកត្រួតពិនិត្យ",
        "lv": "Palīgs",
        "nl": "Toezichthouder",
        "pl": "Opiekun",
        "pt": "Supervisora",
        "sk": "Supervízor",
        "th": "ผู้ควบคุมงาน"
    },
    "num-groups-assigned": {
        "de": "Anzahl zugewiesener Gruppen",
        "en": "Num Groups Assigned",
        "es": "Número de grupos asignados",
        "fr": "Nombre de groupes attribués",
        "km": "ចំនួនក្រុមដែលបានចាត់តាំង",
        "lv": "Piešķirto grupu skaits",
        "nl": "Aantal groepen toegewezen",
        "pl": "Liczba przypisanych grup",
        "pt": "Num grupos atribuídos",
        "sk": "Počet priradených skupín",
        "th": "กลุ่มหมายเลขที่กำหนด"
    },
    "youre-currently-opted-out-of-the-treatment-group": {
        "de": "Sie sind derzeit von der Behandlungsgruppe für diesen Abschnitt abgemeldet.",
        "en": "You’re currently opted out of the treatment group for this partition.",
        "es": "Actualmente ha optado por no participar en el grupo de tratamiento de esta partición.",
        "fr": "Vous êtes actuellement retiré du groupe de traitement pour cette partition.",
        "km": "បច្ចុប្បន្នអ្នកបានបោះបង់ចេញពីក្រុមព្យាបាលសម្រាប់ភាគនេះ។",
        "lv": "Jūs pašlaik esat atteicies no šī pētījuma datu apstrādes grupas.",
        "nl": "U bent momenteel afgemeld voor de behandelgroep voor deze partitie.",
        "pl": "Obecnie jesteś wyłączony z grupy leczenia dla tej partycji.",
        "pt": "No momento, você optou por não participar do grupo de tratamento desta partição.",
        "sk": "Momentálne ste odhlásení z experimentálnej skupiny pre túto oblasť.",
        "th": "ขณะนี้คุณได้ยกเลิกการเข้าร่วมกลุ่มการรักษาสำหรับพาร์ทิชันนี้แล้ว"
    },
    "give-your-assignment-a-name": {
        "de": "Geben Sie Ihrer Aufgabe einen Namen",
        "en": "Give your assignment a name",
        "es": "Dale un nombre a tu tarea",
        "fr": "Nom de votre activité",
        "km": "ផ្តល់ឈ្មោះការងាររបស់អ្នក",
        "lv": "Piešķiriet savam uzdevumam nosaukumu",
        "nl": "Geef je opdracht een naam",
        "pl": "Nadaj swojemu zadaniu nazwę",
        "pt": "Dê um nome à sua tarefa",
        "sk": "Pomenujte svoju úlohu",
        "th": "โปรดระบุชื่อกิจรรมที่จะมอบหมาย"
    },
    "you-can-revert-later-by-clearing-your-opt-out-ta": {
        "de": "Sie können dies später rückgängig machen, indem Sie Ihr Abmelde-Tag löschen. Fortfahren?",
        "en": "You can revert later by clearing your opt-out tag. Continue?",
        "es": "Puede revertir más tarde borrando su etiqueta de exclusión voluntaria. ¿Continuar?",
        "fr": "Vous pouvez revenir plus tard en supprimant votre étiquette de retrait. Continuer?",
        "km": "អ្នកអាចត្រឡប់ចូលវិញនៅពេលក្រោយដោយលុបស្លាកបោះបង់ចេញ។ បន្តទេ?",
        "lv": "Varat atgriezties vēlāk, noņemot atteikšanās atzīmi. Vai turpināt?",
        "nl": "U kunt later terugkeren door uw opt-out-tag te wissen. Doorgaan?",
        "pl": "Możesz wrócić później, usuwając znacznik rezygnacji. Kontynuować?",
        "pt": "Você pode reverter mais tarde limpando sua etiqueta de cancelamento. Continuar?",
        "sk": "Neskôr sa môžete vrátiť späť vymazaním značky odhlásenia. Pokračovať?",
        "th": "คุณสามารถกลับเข้าร่วมได้ในภายหลังโดยการลบแท็กการยกเลิก ต้องการดำเนินการต่อหรือไม่?"
    },
    "save": {
        "de": "Speichern",
        "en": "Save",
        "es": "Ahorrar",
        "fr": "Enregistrer",
        "km": "រក្សាទុក",
        "lv": "Saglabāt",
        "nl": "Redden",
        "pl": "Zapisz",
        "pt": "Salvar",
        "sk": "Uložiť",
        "th": "บันทึก"
    },
    "log-out": {
        "de": "abmelden",
        "en": "log out",
        "es": "finalizar la sesión",
        "fr": "se déconnecter",
        "km": "ចេញពីប្រព័ន្ធ",
        "lv": "iziet",
        "nl": "uitloggen",
        "pl": "Wyloguj się",
        "pt": "sair",
        "sk": "odhlásiť sa",
        "th": "ออกจากระบบ"
    },
    "student-name": {
        "de": "Name der Schülerin/Schüler",
        "en": "Student Name",
        "es": "Nombre del estudiante",
        "fr": "Nom de l’élève",
        "km": "ឈ្មោះសិស្ស",
        "lv": "Skolēna vārds",
        "nl": "Naam van student",
        "pl": "Imię i nazwisko ucznia",
        "pt": "Nome do Aluno",
        "sk": "Meno žiaka",
        "th": "ชื่อนักเรียน"
    },
    "print-login-codes": {
        "de": "Anmeldecodes ausdrucken",
        "en": "Print login codes",
        "es": "Imprimir códigos de inicio de sesión",
        "fr": "Imprimer les codes de connexion",
        "km": "បោះពុម្ពកូដចូលប្រើ",
        "lv": "Drukāt pieteikšanās kodus",
        "nl": "Inlogcodes afdrukken",
        "pl": "Drukuj kody logowania",
        "pt": "Imprimir códigos de login",
        "sk": "Vytlačiť prihlasovacie kódy",
        "th": "พิมพ์รหัสเข้าสู่ระบบ"
    },
    "access-code": {
        "de": "Zugangscode:",
        "en": "Access Code:",
        "es": "Código de acceso:",
        "fr": "Code d’accès :",
        "km": "កូដចូលប្រើ:",
        "lv": "Piekļuves kods:",
        "nl": "Toegangscode:",
        "pl": "Kod dostępu:",
        "pt": "Código de Acesso:",
        "sk": "Prístupový kód:",
        "th": "รหัสการเข้าถึง:"
    },
    "assignments": {
        "de": "AUFGABEN",
        "en": "Assignments",
        "es": "ASIGNACIONES",
        "fr": "ACTIVITES",
        "km": "ការងារ",
        "lv": "UZDEVUMU KOPUMS",
        "nl": "OPDRACHTEN",
        "pl": "ZADANIA",
        "pt": "ATRIBUIÇÕES",
        "sk": "ÚLOHY",
        "th": "กิจกรรม"
    },
    "contact-us": {
        "de": "Kontaktieren Sie uns",
        "en": "Contact Us",
        "es": "Contacta con nosotras",
        "fr": "Contactez-nous",
        "km": "ទំនាក់ទំនងយើង",
        "lv": "Sazinieties ar mums",
        "nl": "Neem contact met ons op",
        "pl": "Kontakt",
        "pt": "Contate-nos",
        "sk": "Kontaktujte nás",
        "th": "ติดต่อสอบถาม"
    },
    "add-all": {
        "de": "Alle hinzufügen",
        "en": "Add All",
        "es": "Agregar todo",
        "fr": "Tout ajouter",
        "km": "បន្ថែមទាំងអស់",
        "lv": "Pievienot visu",
        "nl": "Alles toevoegen",
        "pl": "Dodaj wszystko",
        "pt": "Adicionar tudo",
        "sk": "Pridať všetko",
        "th": "เพิ่มทั้งหมด"
    },
    "user-id": {
        "de": "Benutzerin-/Benutzer-ID",
        "en": "User Id",
        "es": "Identificación de usuario",
        "fr": "Identifiant utilisateur",
        "km": "លេខសម្គាល់អ្នកប្រើ",
        "lv": "Lietotāja ID",
        "nl": "Gebruikers-ID",
        "pl": "Identyfikator użytkownika",
        "pt": "ID do usuário",
        "sk": "ID používateľa",
        "th": "ไอดีผู้ใช้"
    },
    "archive": {
        "de": "Archiv",
        "en": "Archive",
        "es": "Archivo",
        "fr": "Archiver",
        "km": "បញ្ចូលឯកសារ",
        "lv": "Arhīvs",
        "nl": "Archief",
        "pl": "Archiwizuj",
        "pt": "Arquivo",
        "sk": "Archív",
        "th": "จัดเก็บ"
    },
    "content": {
        "de": "INHALT",
        "en": "CONTENT",
        "es": "CONTENIDO",
        "fr": "CONTENU",
        "km": "មាតិកា",
        "lv": "SATURS",
        "nl": "INHOUD",
        "pl": "TREŚĆ",
        "pt": "CONTENTE",
        "sk": "OBSAH",
        "th": "บทเรียน"
    },
    "class-name": {
        "de": "Klassenname",
        "en": "Class Name",
        "es": "Nombre de clase",
        "fr": "NOM DE LA CLASSE",
        "km": "ឈ្មោះថ្នាក់",
        "lv": "Klases nosaukums",
        "nl": "Naam van de klas",
        "pl": "Nazwa klasy",
        "pt": "Nome da classe",
        "sk": "Názov triedy",
        "th": "ชื่อชั้นเรียน"
    },
    "selected-trainer-for-role-request": {
        "de": "Ausgewählte Trainerin/Trainer für Rollenanfrage",
        "en": "Selected Trainer for Role Request",
        "es": "Entrenador seleccionado para solicitud de rol",
        "fr": "Formateur sélectionné pour la demande de rôle",
        "km": "អ្នកបណ្តុះដែលបានជ្រើសសម្រាប់ស្នើសុំតួនាទី",
        "lv": "Izvēlētais treneris lomas pieprasījumam",
        "nl": "Geselecteerde trainer voor rolverzoek",
        "pl": "Wybrany trener dla prośby o rolę",
        "pt": "Instrutor selecionado para solicitação de função",
        "sk": "Vybraný školiteľ pre túto žiadosť o rolu",
        "th": "ผู้ฝึกสอนที่เลือกสำหรับคำขอบทบาท"
    },
    "assigner": {
        "de": "Absenderin/Absender",
        "en": "Assigner",
        "es": "Asignadora",
        "fr": "Attribuant",
        "km": "អ្នកចាត់តាំង",
        "lv": "Piešķīrējs",
        "nl": "Overdrager",
        "pl": "Przypisujący",
        "pt": "Atribuidora",
        "sk": "Zadávateľ",
        "th": "ผู้มอบหมาย"
    },
    "undo": {
        "de": "Rückgängig machen",
        "en": "Undo",
        "es": "Deshacer",
        "fr": "Annuler",
        "km": "ដកសកម្មភាព",
        "lv": "Atcelt",
        "nl": "Ongedaan maken",
        "pl": "Cofnij",
        "pt": "Desfazer",
        "sk": "Vrátiť späť",
        "th": "ยกเลิก"
    },
    "create-account": {
        "de": "Benutzerin/Benutzerkonto erstellen",
        "en": "Create account",
        "es": "Crear una cuenta",
        "fr": "Créer un compte",
        "km": "បង្កើតគណនី",
        "lv": "Izveidot kontu",
        "nl": "Account aanmaken",
        "pl": "Utwórz konto",
        "pt": "Criar Conta",
        "sk": "Vstúpiť",
        "th": "สร้างบัญชี"
    },
    "beginner": {
        "de": "Anfängerin/Anfänger",
        "en": "Beginner",
        "es": "Principiante",
        "fr": "Débutant",
        "km": "អ្នកចាប់ផ្តើម",
        "lv": "Iesācējs",
        "nl": "Beginner",
        "pl": "Początkujący",
        "pt": "Novata",
        "sk": "Začiatočník",
        "th": "ระดับเริ่มต้น"
    },
    "thai-teacher-label": {
        "de": "Thai Lehrkraft Label",
        "en": "Thai Teacher Label",
        "es": "Etiqueta de profesor tailandés",
        "fr": "Étiquette enseignant thaï",
        "km": "ស្លាកគ្រូថៃ",
        "lv": "Taizemes skolotāja paraugs",
        "nl": "Thais lerarenlabel",
        "pl": "Etykieta nauczyciela tajskiego",
        "pt": "Etiqueta de professor tailandês",
        "sk": "Označenie thajského učiteľa",
        "th": "ป้ายชื่อครูภาษาไทย"
    },
    "non-members": {
        "de": "Nichtmitgliederinnen/-mitglieder",
        "en": "Non-Members",
        "es": "No miembros",
        "fr": "Non-membres",
        "km": "មិនមែនសមាជិក",
        "lv": "Ne-dalībnieki",
        "nl": "Niet-leden",
        "pl": "Nie członkowie",
        "pt": "Não membros",
        "sk": "Nečlenovia",
        "th": "นักเรียนที่ไม่ได้อยู่ในชั้นเรียน"
    },
    "preview": {
        "de": "Vorschau",
        "en": "Preview",
        "es": "Avance",
        "fr": "Aperçu",
        "km": "មើលជាមុន",
        "lv": "Priekšskatījums",
        "nl": "Voorbeeld",
        "pl": "Podgląd",
        "pt": "Visualização",
        "sk": "Ukážka",
        "th": "ตัวอย่าง"
    },
    "you-currently-have-no-active-classes": {
        "de": "Sie haben derzeit keine aktiven Klassen",
        "en": "You currently have no active classes",
        "es": "Actualmente no tienes clases activas",
        "fr": "Vous n’avez actuellement aucune classe active.",
        "km": "សព្វថ្ងៃអ្នកមិនមានថ្នាក់សកម្មទេ",
        "lv": "Jums pašlaik nav aktīvu mācību aktivitāšu",
        "nl": "Je hebt momenteel geen actieve lessen",
        "pl": "Obecnie nie masz aktywnych klas",
        "pt": "Você não tem aulas ativas no momento",
        "sk": "Momentálne nemáte žiadne aktívne triedy",
        "th": "ท่านไม่มีชั้นเรียนที่ดำเนินการอยู่ในขณะนี้"
    },
    "request-role": {
        "de": "Rolle anfordern",
        "en": "Request Role",
        "es": "Solicitar rol",
        "fr": "Demander un rôle",
        "km": "ស្នើសុំតួនាទី",
        "lv": "Pieprasīt lomu",
        "nl": "Rol aanvragen",
        "pl": "Poproś o rolę",
        "pt": "Função de solicitação",
        "sk": "Požiadať o rolu",
        "th": "ขอบทบาท"
    },
    "files": {
        "de": "DATEIEN",
        "en": "FILES",
        "es": "ARCHIVOS",
        "fr": "FICHIERS",
        "km": "ឯកសារ",
        "lv": "FAILI",
        "nl": "BESTANDEN",
        "pl": "Pliki",
        "pt": "ARQUIVOS",
        "sk": "SÚBORY",
        "th": "ไฟล์"
    },
    "know-learning-will-keep-this-data-safe-and-wont": {
        "de": "Know Learning verwahrt diese Daten sicher und gibt sie nicht an Dritte weiter, außer an zugelassene Forscherinnen und Forscher. Deine Lehrkraft sieht einige Informationen über deinen Fortschritt in ihrem „Lehrkraft“-Konto. Sie wird deine Gespräche mit KI-fähigen Chatbots NICHT sehen. Bitte gib in den Chatbot KEINE Informationen ein, die jemandem helfen könnten, dich zu identifizieren, wie z. B. deinen Namen oder Standort. Deine Lehrkraft ist die Einzige, die sehen kann, wer du bist. Wenn du mit irgendetwas hier Geschriebenem nicht einverstanden bist, sprich bitte mit deiner Lehrkraft und erstelle KEIN Schülerinnen-/Schülerkonto auf PILA.",
        "en": "Know Learning will keep this data safe and won’t share it with anyone outside, except for approved researchers.  Your teacher will see some information about your progress in their “teacher” account.  They will NOT see your conversations with AI-enabled chatbots.  Please DO NOT input into the chatbot any information that could help someone identify who you are, such as your name or location. Your teacher is the only one who will be able to see who you are.  If you do not agree with anything written here, please speak with your teacher and DO NOT create a student account on PILA.",
        "es": "Know Learning mantendrá estos datos seguros y no los compartirá con nadie externo, excepto con investigadores aprobados. Su maestro verá información sobre su progreso en su cuenta de \"maestro\". NO verán sus conversaciones con chatbots habilitados para IA. NO ingrese en el chatbot ninguna información que pueda ayudar a alguien a identificar quién es usted, como su nombre o ubicación. Tu profesor es el único que podrá ver quién eres. Si no está de acuerdo con algo escrito aquí, hable con su maestro y NO cree una cuenta de estudiante en PILA.",
        "fr": "KnowLearning va garder ces données en sécurité et ne les partagera avec personne, sauf avec des chercheurs approuvés. Ton enseignant verra certaines informations sur tes progrès dans son compte enseignant. Mais il ne verra PAS tes conversations avec le tuteur IA, les chatbots alimentés par l'IA. IMPORTANT : Ne donne PAS tes informations personnelles (comme ton nom ou le lieu où tu te trouves) au tuteur IA. Ton enseignant est la seule personne qui sait qui tu es. Si tu ne comprends pas ou tu n'es pas d'accord avec ce qui est écrit ici, parle avec ton enseignant et ne crée pas de compte élève sur PILA.",
        "km": "KnowLearning នឹងរក្សាទិន្នន័យនេះឲ្យសុវត្ថិ ហើយមិនចែករំលែកក្រៅប្រព័ន្ធទេ",
        "lv": "Know Learning nodrošinās šo datu drošību un nekopīgos tos ar citiem, izņemot apstiprinātus pētniekus. Tavs skolotājs savā “skolotāja” kontā redzēs informāciju par tavu progresu. Viņš neredzēs tavas sarunas ar AI iespējotiem tērzēšanas robotiem. Lūdzu, NEIEVIETO tērzēšanas robotā nekādu informāciju, kas varētu palīdzēt kādam atpazīt, kas tu esi, piemēram, savu vārdu vai atrašanās vietu. Tavs skolotājs ir vienīgais, kurš varēs redzēt, kas tu esi. Ja nepiekrīti kaut kam šeit rakstītajam, lūdzu, runā ar savu skolotāju un NEVEIDO skolēna kontu PILA.",
        "nl": "Know Learning bewaart deze gegevens veilig en deelt deze met niemand buiten de organisatie, behalve met goedgekeurde onderzoekers. Je docent ziet informatie over je voortgang in zijn ‘leraar’-account. Ze zullen uw gesprekken met AI-compatibele chatbots NIET zien. Voer GEEN informatie in de chatbot in waarmee iemand kan identificeren wie u bent, zoals uw naam of locatie. Jouw leraar is de enige die kan zien wie je bent. Als je het niet eens bent met wat hier geschreven staat, neem dan contact op met je docent en maak GEEN studentenaccount aan op PILA.",
        "pl": "Know Learning będzie przechowywać te dane w bezpieczny sposób i nie udostępnia ich nikomu na zewnątrz, z wyjątkiem zatwierdzonych badaczy. Twój nauczyciel zobaczy niektóre informacje o Twoich postępach w swoim koncie „nauczyciela”. NIE będzie widział Twoich rozmów z chatbotami obsługiwanymi przez AI. Proszę NIE wprowadzać do chatbota żadnych informacji, które mogłyby pomóc komuś zidentyfikować Twoją osobę, takich jak imię lub lokalizacja. Tylko Twój nauczyciel będzie mógł zobaczyć, kim jesteś. Jeśli nie zgadzasz się z czymkolwiek, co tu napisano, porozmawiaj ze swoim nauczycielem i NIE twórz konta ucznia na PILA.",
        "pt": "A Know Learning manterá esses dados seguros e não os compartilhará com ninguém de fora, exceto pesquisadores aprovados. Seu professor verá algumas informações sobre seu progresso na conta de “professor”. Eles NÃO verão suas conversas com chatbots habilitados para IA. NÃO insira no chatbot nenhuma informação que possa ajudar alguém a identificar quem você é, como seu nome ou localização. Seu professor é o único que poderá ver quem você é. Se você não concorda com nada escrito aqui, fale com seu professor e NÃO crie uma conta de estudante no PILA.",
        "sk": "Spoločnosť Know Learning, ktorá aplikáciu vytvorila a spravuje, bude tieto údaje uchovávať v bezpečí a bude ich zdieľať len s výskumníkmi z Ministerstva školstva a Organizácie pre hospodársku spoluprácu a rozvoj.\n\nTvoj/a učiteľ/ka uvidí ako sa ti darí v jednotlivých cvičeniach vo svojom učiteľskom účte.\n\nAk más AI četbota, učiteľ/ka neuvidí tvoje konverzácie s AI četbotom. Prosím, NEVKLADAJ do četbota žiadne informácie o tom ako sa voláš, kde bývaš alebo kam chodíš do školy. V platforme PILA tvoje meno vidí iba tvoj/a učiteľ/ka.\n\nAk niečomu v tomto texte nerozumieš alebo ti niečo nie je príjemné, povedz to učiteľke/učiteľovi skôr, ako začneš aplikáciu používať.",
        "th": "Know Learning จะเก็บข้อมูลนี้อย่างปลอดภัยและจะไม่แชร์กับใครภายนอก ยกเว้นนักวิจัยที่ได้รับอนุมัติ ครูของคุณจะเห็นข้อมูลบางอย่างเกี่ยวกับความก้าวหน้าของคุณในบัญชี “ครู” ของพวกเขา แต่พวกเขาจะไม่เห็นการสนทนาของคุณกับแชทบอทที่ใช้ AI โปรดอย่าใส่ข้อมูลใดๆ ลงในแชทบอทที่อาจช่วยให้ใครบางคนระบุตัวตนของคุณ เช่น ชื่อหรือที่อยู่ ครูของคุณเท่านั้นที่จะสามารถเห็นว่าคุณเป็นใคร หากคุณไม่เห็นด้วยกับสิ่งใดที่เขียนไว้ที่นี่ โปรดปรึกษาครูของคุณและอย่าสร้างบัญชีผู้เรียนบน PILA"
    },
    "num-logins": {
        "de": "Anzahl Anmeldungen",
        "en": "Num Logins",
        "es": "Núm. de inicios de sesión",
        "fr": "Nombre de connexions",
        "km": "ចំនួនចូលប្រើ",
        "lv": "Pieteikumu skaits",
        "nl": "Aantal aanmeldingen",
        "pl": "Liczba logowań",
        "pt": "Número de logins",
        "sk": "Počet prihlásení",
        "th": "จำนวนการเข้าสู่ระบบ"
    },
    "send-feedback": {
        "de": "Feedback senden",
        "en": "Send Feedback",
        "es": "Enviar comentarios",
        "fr": "Faire un retour",
        "km": "ផ្ញើមតិយោបល់",
        "lv": "Sūtīt atsauksmes",
        "nl": "Feedback verzenden",
        "pl": "Wyślij opinię",
        "pt": "Enviar comentários",
        "sk": "Odoslať spätnú väzbu",
        "th": "ส่งความคิดเห็น"
    },
    "if-you": {
        "de": "Wenn Du",
        "en": "If you",
        "es": "Si usted",
        "fr": "Si tu",
        "km": "ប្រសិនបើអ្នក",
        "lv": "Ja tu",
        "nl": "Als jij",
        "pl": "Jeśli ty",
        "pt": "Se você",
        "sk": "Ak si",
        "th": "หากท่าน"
    },
    "add-to-favorites": {
        "de": "Zu Favoriten hinzufügen",
        "en": "Add to favorites",
        "es": "Añadir a favoritos",
        "fr": "Ajouter aux favoris",
        "km": "បន្ថែមទៅសំណព្វ",
        "lv": "Pievienot izlasei",
        "nl": "Toevoegen aan favorieten",
        "pl": "Dodaj do ulubionych",
        "pt": "Adicionar aos favoritos",
        "sk": "Pridať do obľúbených",
        "th": "เพิ่มในรายการโปรด"
    },
    "close": {
        "de": "Schließen",
        "en": "Close",
        "es": "Cerca",
        "fr": "Fermer",
        "km": "បិទ",
        "lv": "Aizvērt",
        "nl": "Dichtbij",
        "pl": "Zamknij",
        "pt": "Fechar",
        "sk": "Zavrieť",
        "th": "ปิด"
    },
    "requested": {
        "de": "Angefragt",
        "en": "Requested",
        "es": "Solicitada",
        "fr": "Demandé",
        "km": "បានស្នើសុំ",
        "lv": "Pieprasīts",
        "nl": "Gevraagd",
        "pl": "Zażądano",
        "pt": "Solicitada",
        "sk": "Požadované",
        "th": "ยื่นขอเรียบร้อยแล้ว"
    },
    "login": {
        "de": "Anmeldung",
        "en": "Login",
        "es": "Acceso",
        "fr": "Se connecter",
        "km": "ចូលប្រើ",
        "lv": "Pieteikties",
        "nl": "Login",
        "pl": "Zaloguj się",
        "pt": "Conecte-se",
        "sk": "Prihlásenie",
        "th": "เข้าสู่ระบบ"
    },
    "members": {
        "de": "Mitgliederinnen/Mitglieder",
        "en": "Members",
        "es": "Miembros",
        "fr": "Membres",
        "km": "សមាជិក",
        "lv": "Dalībnieki",
        "nl": "Leden",
        "pl": "Członkowie",
        "pt": "Membros",
        "sk": "Členovia",
        "th": "นักเรียนในชั้นเรียน"
    },
    "data-protection": {
        "de": "Datenschutz",
        "en": "Data Protection",
        "es": "Protección de datos",
        "fr": "Protection des données",
        "km": "ការពារទិន្នន័យ",
        "lv": "Datu aizsardzība",
        "nl": "Gegevensbescherming",
        "pl": "Ochrona danych",
        "pt": "Proteção de Dados",
        "sk": "Ochrana osobných údajov",
        "th": "การปกป้องข้อมูล"
    },
    "trainer": {
        "de": "Trainerin/Trainer",
        "en": "Trainer",
        "es": "Entrenadora",
        "fr": "Formateur",
        "km": "អ្នកបណ្តុះ",
        "lv": "Treneris",
        "nl": "Trainer",
        "pl": "Trener",
        "pt": "Treinadora",
        "sk": "Školiteľ",
        "th": "ผู้ฝึกสอน"
    },
    "add-content": {
        "de": "Inhalt hinzufügen",
        "en": "Add Content",
        "es": "Agregar contenido",
        "fr": "Ajouter du contenu",
        "km": "បន្ថែមមាតិកា",
        "lv": "Pievienot saturu",
        "nl": "Inhoud toevoegen",
        "pl": "Dodaj zawartość",
        "pt": "Adicionar conteúdo",
        "sk": "Pridať obsah",
        "th": "เพิ่มบทเรียน"
    },
    "invalid-access-code": {
        "de": "Ungültiger Zugangscode",
        "en": "Invalid Access Code",
        "es": "Código de acceso no válido",
        "fr": "Code d’accès invalide",
        "km": "កូដចូលប្រើមិនត្រឹមត្រូវ",
        "lv": "Nederīgs piekļuves kods",
        "nl": "Ongeldige toegangscode",
        "pl": "Nieprawidłowy kod dostępu",
        "pt": "Código de acesso inválido",
        "sk": "Neplatný prístupový kód",
        "th": "รหัสการเข้าถึงไม่ถูกต้อง"
    },
    "add": {
        "de": "hinzufügen",
        "en": "add",
        "es": "agregar",
        "fr": "ajouter",
        "km": "បន្ថែម",
        "lv": "pievienot",
        "nl": "toevoegen",
        "pl": "dodaj",
        "pt": "adicionar",
        "sk": "pridať",
        "th": "เพิ่ม"
    },
    "other-groups": {
        "de": "Andere Gruppen",
        "en": "Other Groups",
        "es": "Otros grupos",
        "fr": "Autres groupes",
        "km": "ក្រុមផ្សេងទៀត",
        "lv": "Citas grupas",
        "nl": "Andere groepen",
        "pl": "Inne grupy",
        "pt": "Outros grupos",
        "sk": "Iné skupiny",
        "th": "กลุ่มอื่น"
    },
    "assignment-date": {
        "de": "Zuweisungsdatum",
        "en": "Assignment Date",
        "es": "Fecha de asignación",
        "fr": "Date de l'activité",
        "km": "កាលបរិច្ឆេទការងារ",
        "lv": "Piešķiršanas datums",
        "nl": "Datum van toewijzing",
        "pl": "Data zadania",
        "pt": "Data da Atribuição",
        "sk": "Dátum pridelenia úlohy",
        "th": "วันที่มอบหมาย"
    },
    "your-teachers": {
        "de": "Ihre Lehrkräfte",
        "en": "Your Teachers",
        "es": "Tus maestras",
        "fr": "Ton enseignant",
        "km": "គ្រូរបស់អ្នក",
        "lv": "Jūsu Skolotāji",
        "nl": "Jouw leraren",
        "pl": "Twoi nauczyciele",
        "pt": "Seus professores",
        "sk": "Vaši učitelia",
        "th": "ครูของท่าน"
    },
    "math-invaders": {
        "de": "MATHE-INVASOREN",
        "en": "MATH INVADERS",
        "es": "INVASORES MATEMÁTICOS",
        "fr": "ENVAHISSEURS DES MATHÉMATIQUES",
        "km": "អ្នកលុកលុយគណិតវិទ្យា",
        "lv": "MATEMĀTIKAS ATKLĀJĒJI",
        "nl": "WISKUNDE-INDRINGERS",
        "pl": "NAJEŹDŹCY MATEMATYCZNI",
        "pt": "INVASORES DA MATEMÁTICA",
        "sk": "MATEMATICKÍ VOTRELCI",
        "th": "คณิตศาสตร์"
    },
    "publish-content": {
        "de": "Inhalt veröffentlichen",
        "en": "Publish Content",
        "es": "Publicar contenido",
        "fr": "Publier le contenu",
        "km": "ផ្សព្វផ្សាយមាតិកា",
        "lv": "Publicēt saturu",
        "nl": "Inhoud publiceren",
        "pl": "Opublikuj treść",
        "pt": "Publicar conteúdo",
        "sk": "Publikovať obsah",
        "th": "เผยแพร่เนื้อหา"
    },
    "karel-the-turtle": {
        "de": "KAREL DIE SCHILDKRÖTE",
        "en": "KAREL THE TURTLE",
        "es": "KAREL LA TORTUGA",
        "fr": "KAREL LA TORTUE",
        "km": "KAREL ជាប្រុសទឹកដោះ",
        "lv": "Bruņurupucis KARELS",
        "nl": "KAREL DE SCHILDPAD",
        "pl": "KAREL ŻÓŁW",
        "pt": "KAREL A TARTARUGA",
        "sk": "KORYTNAČKA KAROL",
        "th": "เจ้าเต่าคาเรล"
    },
    "the-kinds-of-activity-data-include": {
        "de": "Zu den Arten von Aktivitätsdaten gehören:",
        "en": "The kinds of activity data include:",
        "es": "Los tipos de datos de actividad incluyen:",
        "fr": "Les types de données qu'on va enregistrer :",
        "km": "ប្រភេទទិន្នន័យសកម្មភាពរួមមាន:",
        "lv": "Aktivitāšu datu veidi ietver:",
        "nl": "De soorten activiteitsgegevens omvatten:",
        "pl": "Rodzaje danych aktywności obejmują:",
        "pt": "Os tipos de dados de atividade incluem:",
        "sk": "Medzi typy údajov o aktivitách patria:",
        "th": "ข้อมูลที่จะดำเนินการเก็บรวบรวม ประกอบด้วย:"
    },
    "show-archived": {
        "de": "Archiviert anzeigen",
        "en": "Show Archived",
        "es": "Mostrar Archivado",
        "fr": "Afficher les éléments archivés",
        "km": "បង្ហាញឯកសារចាស់",
        "lv": "Rādīt arhivēto",
        "nl": "Gearchiveerd weergeven",
        "pl": "Pokaż archiwum",
        "pt": "Mostrar arquivado",
        "sk": "Zobraziť archivované",
        "th": " แสดงชั้นเรียนที่ถูกจัดเก็บไว้"
    },
    "core-facilitator": {
        "de": "Kernmoderatorin/-moderator",
        "en": "Core Facilitator",
        "es": "Facilitador principal",
        "fr": "Facilitateur principal",
        "km": "អ្នកសម្របសម្រួលមូលដ្ឋាន",
        "lv": "Atbalsts",
        "nl": "Kern Facilitator",
        "pl": "Główny prowadzący",
        "pt": "Facilitador Central",
        "sk": "Hlavný facilitátor",
        "th": "ผู้อำนวยความสะดวกหลัก"
    },
    "competency-dashboard": {
        "de": "Kompetenz-Dashboard",
        "en": "Competency dashboard",
        "es": "Panel de competencias",
        "fr": "Tableau de bord des compétences",
        "km": "ផ្ទាំងគ្រប់គ្រងជំនាញ",
        "lv": "Kompetences informācijas panelis",
        "nl": "Competentiedashboard",
        "pl": "Panel kompetencji",
        "pt": "Painel de Competências",
        "sk": "Prehľad kompetencií",
        "th": "แดชบอร์ดสมรรถนะ"
    },
    "pila-studies": {
        "de": "PILA-STUDIEN",
        "en": "PILA STUDIES",
        "es": "ESTUDIOS PILA",
        "fr": "ÉTUDES PILA",
        "km": "ការសិក្សា PILA",
        "lv": "PILA PĒTĪJUMS",
        "nl": "PILA-STUDIES",
        "pl": "BADANIA PILA",
        "pt": "ESTUDOS PILA",
        "sk": "PILA ŠTÚDIE",
        "th": "การศึกษาของ PILA"
    },
    "go-to-assignments": {
        "de": "Zu den Aufgaben gehen",
        "en": "Go to Assignments",
        "es": "Ir a Tareas",
        "fr": "Aller aux activités",
        "km": "ទៅការងារ",
        "lv": "Dodies uz uzdevumu kopumu",
        "nl": "Ga naar Opdrachten",
        "pl": "Przejdź do zadań",
        "pt": "Vá para Tarefas",
        "sk": "Prejdi na Úlohy",
        "th": "ไปยังกิจกรรมที่ได้รับมอบหมาย"
    },
    "selected-competencies": {
        "de": "Ausgewählte Kompetenzen",
        "en": "Selected Competencies",
        "es": "Competencias seleccionadas",
        "fr": "Compétences sélectionnées",
        "km": "ជំនាញដែលបានជ្រើសរើស",
        "lv": "Atlasītās kompetences",
        "nl": "Geselecteerde competenties",
        "pl": "Wybrane kompetencje",
        "pt": "Competências selecionadas",
        "sk": "Vybrané kompetencie",
        "th": "สมรรถนะที่เลือก"
    },
    "select-your-trainer": {
        "de": "Wählen Sie Ihre Trainerin/Trainer aus",
        "en": "Select Your Trainer",
        "es": "Selecciona tu entrenador",
        "fr": "Sélectionnez votre formateur",
        "km": "ជ្រើសអ្នកបណ្តុះរបស់អ្នក",
        "lv": "Izvēlieties savu treneri",
        "nl": "Selecteer uw trainer",
        "pl": "Wybierz swojego trenera",
        "pt": "Selecione seu treinador",
        "sk": "Vyberte svojho školiteľa",
        "th": "เลือกผู้ฝึกสอนของท่าน"
    },
    "assigner-id": {
        "de": "Zuweisungs-ID",
        "en": "Assigner Id",
        "es": "ID del asignante",
        "fr": "Identifiant de l’attribuant",
        "km": "ID អ្នកចាត់តាំង",
        "lv": "Piešķīrēja ID",
        "nl": "Toewijzer-ID",
        "pl": "Identyfikator przypisującego",
        "pt": "ID do atribuidor",
        "sk": "ID priraďovateľa",
        "th": "รหัสผู้มอบหมาย"
    },
    "archived": {
        "de": "Archiviert",
        "en": "Archived",
        "es": "Archivada",
        "fr": "Archivé",
        "km": "បានផ្ទុកឯកសារ",
        "lv": "Arhivēts",
        "nl": "Gearchiveerd",
        "pl": "Archiwum",
        "pt": "Arquivada",
        "sk": "Archivované",
        "th": "ชั้นเรียนที่ถูกจัดเก็บไว้"
    },
    "report-bug": {
        "de": "Fehler melden",
        "en": "Report Bug",
        "es": "Informar error",
        "fr": "Signaler un dysfonctionnement",
        "km": "រាយការណ៍បញ្ហា",
        "lv": "Ziņot par kļūdu",
        "nl": "Rapporteer bug",
        "pl": "Zgłoś błąd",
        "pt": "Reportar bug",
        "sk": "Nahlásiť chybu",
        "th": "รายงานข้อผิดพลาด"
    },
    "no-results-found-for-your-filter": {
        "de": "Für Ihren Filter wurden keine Ergebnisse gefunden.",
        "en": "No results found for this filter.",
        "es": "No se encontraron resultados para su filtro.",
        "fr": "Aucun résultat trouvé pour votre filtre.",
        "km": "មិនមានលទ្ធផលសម្រាប់តម្រងរបស់អ្នក។",
        "lv": "Jūsu filtram nav atrasts neviens rezultāts.",
        "nl": "Er zijn geen resultaten gevonden voor uw filter.",
        "pl": "Nie znaleziono wyników dla twojego filtra",
        "pt": "Nenhum resultado encontrado para seu filtro.",
        "sk": "Pre váš filter sa nenašli žiadne výsledky.",
        "th": "ไม่พบผลลัพธ์จากการค้นหา"
    },
    "teacher": {
        "de": "Lehrkraft",
        "en": "Teacher",
        "es": "Maestra",
        "fr": "Enseignant",
        "km": "គ្រូ",
        "lv": "Skolotājs",
        "nl": "Docent",
        "pl": "Nauczyciel",
        "pt": "Professora",
        "sk": "Učiteľ/ka",
        "th": "ครู"
    },
    "owner": {
        "de": "Eigentümerin/Eigentümer",
        "en": "Owner",
        "es": "Dueña",
        "fr": "Propriétaire",
        "km": "ម្ចាស់",
        "lv": "Īpašnieks",
        "nl": "Eigenaar",
        "pl": "Właściciel",
        "pt": "Proprietária",
        "sk": "Vlastník",
        "th": "เจ้าของ"
    },
    "success": {
        "de": "Erfolg",
        "en": "Success",
        "es": "Éxito",
        "fr": "Succès",
        "km": "ជោគជ័យ",
        "lv": "Panākumi",
        "nl": "Succes",
        "pl": "Sukces",
        "pt": "Sucesso",
        "sk": "Úspešné",
        "th": "สำเร็จ"
    },
    "computational-problem-solving": {
        "de": "Computergestützte Problemlösung",
        "en": "Computational Problem Solving",
        "es": "Resolución de problemas computacionales",
        "fr": "Résolution de problèmes computationnels",
        "km": "ដោះស្រាយបញ្ហាគណនា",
        "lv": "Skaitļošanas problēmu risināšana",
        "nl": "Computationele problemen oplossen",
        "pl": "Rozwiązywanie problemów obliczeniowych",
        "pt": "Resolução de problemas computacionais",
        "sk": "Výpočtové riešenie problémov",
        "th": "การแก้ปัญหาโดยอาศัยการคิดเชิงคำนวน"
    },
    "sequence": {
        "de": "Sequenz",
        "en": "Sequence",
        "es": "Secuencia",
        "fr": "Séquence",
        "km": "លំដាប់",
        "lv": "Uzdevumu grupa",
        "nl": "Reeks",
        "pl": "Sekwencja",
        "pt": "Sequência",
        "sk": "Sekvencia",
        "th": "เรียงลำดับกิจกรรม"
    },
    "updated": {
        "de": "Aktualisiert",
        "en": "Updated",
        "es": "Actualizada",
        "fr": "Mis à jour",
        "km": "បានធ្វើបច្ចុប្បន្នភាព",
        "lv": "Atjaunināts",
        "nl": "Bijgewerkt",
        "pl": "Zaktualizowano",
        "pt": "Atualizada",
        "sk": "Aktualizované",
        "th": "อัพเดทเมื่อ"
    },
    "add-content-by-id-or-url": {
        "de": "Inhalte nach ID oder URL hinzufügen",
        "en": "Add Content by Id or URL",
        "es": "Agregar contenido por ID o URL",
        "fr": "Ajouter du contenu par ID ou URL",
        "km": "បន្ថែមមាតិកាតាម ID ឬ URL",
        "lv": "Pievienojiet saturu pēc ID vai URL",
        "nl": "Voeg inhoud toe op ID of URL",
        "pl": "Dodaj zawartość za pomocą Id lub URL",
        "pt": "Adicione conteúdo por ID ou URL",
        "sk": "Pridajte obsah podľa ID alebo adresy URL",
        "th": "เพิ่มบทเรียนด้วยไอดีหรือ URL"
    },
    "mark-this-content-as-a-favorite-for-quick-access": {
        "de": "Markieren Sie diesen Inhalt als Favorit für schnellen Zugriff",
        "en": "Mark this content as a favorite for quick access",
        "es": "Marca este contenido como favorito para acceder rápidamente",
        "fr": "Marquez ce contenu comme favori pour un accès rapide",
        "km": "សម្គាល់មាតិកានេះជាសំណព្វសម្រាប់ការចូលប្រើរហ័ស",
        "lv": "Atzīmējiet šo saturu kā izlasi ātrai piekļuvei",
        "nl": "Markeer deze inhoud als favoriet voor snelle toegang",
        "pl": "Oznacz tę treść jako ulubioną, aby uzyskać szybki dostęp",
        "pt": "Marque este conteúdo como favorito para acesso rápido",
        "sk": "Označte tento obsah ako obľúbený pre rýchly prístup",
        "th": "เพิ่มเนื้อหานี้ไปยังรายการโปรดเพื่อการเข้าถึงอย่างรวดเร็ว"
    },
    "steps-to-reproduce": {
        "de": "Schritte zur Reproduktion",
        "en": "Steps to Reproduce",
        "es": "Pasos para reproducirse",
        "fr": "Étapes à reproduire",
        "km": "ជំហានដើម្បីធ្វើឡើងម្ដងទៀត",
        "lv": "Reproducēšanas soļi",
        "nl": "Stappen om te reproduceren",
        "pl": "Kroki do odtworzenia",
        "pt": "Etapas para reproduzir",
        "sk": "Popíšte, kedy sa chyba objavila (čo jej predchádzalo, čo ste práve robili)",
        "th": "ขั้นตอนในการทำซ้ำ"
    },
    "created": {
        "de": "Erstellt",
        "en": "Created",
        "es": "Creada",
        "fr": "Créé",
        "km": "បានបង្កើត",
        "lv": "Izveidots",
        "nl": "Gemaakt",
        "pl": "Utworzono",
        "pt": "Criada",
        "sk": "Vytvorené",
        "th": "สร้างเมื่อ"
    },
    "all-students": {
        "de": "Alle Schülerinnen/Schüler",
        "en": "All Students",
        "es": "Todas las estudiantes",
        "fr": "Tous les élèves",
        "km": "សិស្សទាំងអស់",
        "lv": "Visi skolēni",
        "nl": "Alle studenten",
        "pl": "Wszyscy uczniowie",
        "pt": "Todos os alunos",
        "sk": "Všetci žiaci",
        "th": "นักเรียนทั้งหมด"
    },
    "modify": {
        "de": "Ändern",
        "en": "Modify",
        "es": "Modificar",
        "fr": "Modifier",
        "km": "កែប្រែ",
        "lv": "Modificēt",
        "nl": "Bewerken",
        "pl": "Modyfikuj",
        "pt": "Modificar",
        "sk": "Upraviť",
        "th": "แก้ไข"
    },
    "dont-have-an-access-code-contact-edu-pila-oecd-o": {
        "de": "Sie haben keinen Zugangscode? Kontaktieren Sie edu.pila@oecd.org, um Interesse an der Verwendung von PILA in Ihrem Unterricht oder für Ihre Forschung zu bekunden.",
        "en": "Don't have an access code? Contact edu.pila@oecd.org to express interest in using PILA in your classroom or for your research.",
        "es": "¿No tienes un código de acceso? Comuníquese con edu.pila@oecd.org para expresar interés en utilizar PILA en su salón de clases o para su investigación.",
        "fr": "Vous n’avez pas de code d’accès ? Contactez edu.pila@oecd.org pour exprimer votre intérêt à utiliser PILA dans votre classe ou pour votre recherche.",
        "km": "មិនមានកូដចូលប្រើទេ? ទំនាក់ទំនង edu.pila@oecd.org ដើម្បីបង្ហាញការចាប់អារម្មណ៍ប្រើ PILA នៅថ្នាក់របស់អ្នក ឬសម្រាប់ការស្រាវជ្រាវ។",
        "lv": "Vai jums nav piekļuves koda? Sazinieties ar edu.pila@oecd.org, lai izteiktu interesi par PILA izmantošanu savā klasē vai pētījumiem.",
        "nl": "Heeft u geen toegangscode? Neem contact op met edu.pila@oecd.org om interesse te tonen in het gebruik van PILA in uw klaslokaal of voor uw onderzoek.",
        "pl": "Nie masz kodu dostępu? Skontaktuj się z edu.pila@oecd.org, aby wyrazić zainteresowanie używaniem PILA w swojej klasie lub w badaniach.",
        "pt": "Não possui um código de acesso? Entre em contato com edu.pila@oecd.org para manifestar interesse em usar o PILA na sua sala de aula ou em sua pesquisa.",
        "sk": "Nemáte prístupový kód? Kontaktujte aitutor@minedu.sk v prípade záujmu o používanie PILA vo Vašej triede alebo pre Váš výskum.",
        "th": "ไม่มีรหัสการเข้าถึงหรือติดต่อ edu.pila@oecd.org เพื่อแสดงความสนใจในการใช้ PILA ในห้องเรียนหรือในงานวิจัยของคุณ"
    },
    "items-per-page": {
        "de": "Items pro Seite",
        "en": "Items per Page",
        "es": "Artículos por página",
        "fr": "Éléments par page",
        "km": "ធាតុក្នុងមួយទំព័រ",
        "lv": "Uzdevumu skaits vienā lapā",
        "nl": "Artikelen per pagina",
        "pl": "Elementów na stronę",
        "pt": "Itens por página",
        "sk": "Položky na stránku",
        "th": "รายการต่อหน้า"
    },
    "challenge": {
        "de": "Herausforderung",
        "en": "Challenge",
        "es": "Desafío",
        "fr": "Défi",
        "km": "បញ្ហា",
        "lv": "Izaicinājums",
        "nl": "Uitdaging",
        "pl": "Wyzwanie",
        "pt": "Desafio",
        "sk": "Výzva",
        "th": "ความท้าทาย"
    },
    "datawise-activities": {
        "de": "DATENBASIERTE AKTIVITÄTEN",
        "en": "DATAWISE ACTIVITIES",
        "es": "ACTIVIDADES DE DATOS",
        "fr": "ACTIVITÉS DATAWISE",
        "km": "សកម្មភាព Datawise",
        "lv": "DATU PRATĪBA",
        "nl": "DATAWISE-ACTIVITEITEN",
        "pl": "DZIAŁANIA DATAWISE",
        "pt": "ATIVIDADES DE DADOS",
        "sk": "DÁTOVO ORIENTOVANÉ AKTIVITY",
        "th": "กิจกรรม Datawise"
    },
    "enter": {
        "de": "Eingeben",
        "en": "Enter",
        "es": "Ingresar",
        "fr": "Entrer",
        "km": "បញ្ចូល",
        "lv": "Ievadiet",
        "nl": "Binnenkomen",
        "pl": "Wprowadź",
        "pt": "Entrar",
        "sk": "Zadajte",
        "th": "เข้าสู่ระบบ"
    },
    "class-details": {
        "de": "KLASSENDETAILS",
        "en": "CLASS DETAILS",
        "es": "DETALLES DE LA CLASE",
        "fr": "Détails de la classe",
        "km": "ព័ត៌មានលម្អិតថ្នាក់",
        "lv": "KLASES INFORMĀCIJA",
        "nl": "KLASSEDETAILS",
        "pl": "SZCZEGÓŁY KLASY",
        "pt": "DETALHES DA AULA",
        "sk": "PODROBNOSTI TRIEDY",
        "th": "รายละเอียดชั้นเรียน"
    },
    "in-group": {
        "de": "In der Gruppe",
        "en": "In Group",
        "es": "En grupo",
        "fr": "Dans le groupe",
        "km": "នៅក្នុងក្រុម",
        "lv": "Grupā",
        "nl": "In groep",
        "pl": "W grupie",
        "pt": "Em grupo",
        "sk": "V skupine",
        "th": "ในกลุ่ม"
    },
    "anonymous": {
        "de": "Anonym",
        "en": "Anonymous",
        "es": "Anónima",
        "fr": "Anonyme",
        "km": "អនាមិក",
        "lv": "Anonīms",
        "nl": "Anoniem",
        "pl": "Anonimowy",
        "pt": "Anônima",
        "sk": "Anonymný",
        "th": "ไม่ระบุตัวตน"
    },
    "my-teachers": {
        "de": "MEINE LEHRKRÄFTE",
        "en": "MY TEACHERS",
        "es": "Mis maestras",
        "fr": "MES ENSEIGNANTS",
        "km": "គ្រូរបស់ខ្ញុំ",
        "lv": "MANI SKOLOTĀJI",
        "nl": "MIJN LERAREN",
        "pl": "MOI NAUCZYCIELE",
        "pt": "MEUS PROFESSORES",
        "sk": "MOJI UČITELIA",
        "th": "ครูของฉัน"
    },
    "systems-thinking": {
        "de": "Systemdenken",
        "en": "Systems Thinking",
        "es": "Pensamiento sistémico",
        "fr": "Pensée systémique",
        "km": "គិតបែបប្រព័ន្ធ",
        "lv": "Sistēmiskā domāšana",
        "nl": "Systeemdenken",
        "pl": "Myślenie systemowe",
        "pt": "Pensamento Sistêmico",
        "sk": "Systémové myslenie",
        "th": "การคิดเชิงระบบ"
    },
    "thank-you-your-feedback-has-been-sent-our-team-w": {
        "de": "Dankeschön! Ihr Feedback wurde gesendet. Unser Team wird es überprüfen \nund sich bei Bedarf melden.",
        "en": "Thank you! Your feedback has been sent. Our team will review it\nand follow up if needed.",
        "es": "¡Gracias! Tus comentarios han sido enviados. Nuestro equipo lo revisará \ny realizar un seguimiento si es necesario.",
        "fr": "Merci ! Votre retour a été envoyé. Notre équipe l’examinera et vous contactera si nécessaire.",
        "km": "អរគុណ! មតិយោបល់របស់អ្នកត្រូវបានផ្ញើរួចហើយ។ ក្រុមការងាររបស់យើងនឹងពិនិត្យ និងទំនាក់ទំនងវិញប្រសិនបើចាំបាច់។",
        "lv": "Paldies! Jūsu atsauksmes ir nosūtītas. Mūsu komanda to pārskatīs \nun sekojiet līdzi, ja nepieciešams.",
        "nl": "Bedankt! Uw feedback is verzonden. Ons team zal het beoordelen \nen opvolgen indien nodig.",
        "pl": "Dziękujemy! Twoja opinia została wysłana. Nasz zespół ją przeanalizuje i skontaktuje się z Tobą, jeśli będzie to potrzebne.",
        "pt": "Obrigado! Seu feedback foi enviado. Nossa equipe irá analisá-lo \ne faça o acompanhamento se necessário.",
        "sk": "Ďakujem! Vaša spätná väzba bola odoslaná. Náš tím to posúdi \na v prípade potreby bude ďalej sledovať.",
        "th": "ขอบคุณ! ข้อเสนอแนะของคุณถูกส่งแล้ว ทีมงานของเราจะตรวจสอบและติดต่อกลับหากจำเป็น"
    },
    "loading-tags": {
        "de": "Schlagworte werden geladen",
        "en": "Loading Tags",
        "es": "Cargando etiquetas",
        "fr": "Chargement des étiquettes",
        "km": "កំពុងផ្ទុកស្លាក",
        "lv": "Notiek tagu ielāde",
        "nl": "Labels laden",
        "pl": "Ładowanie tagów",
        "pt": "Carregando etiquetas",
        "sk": "Načítavajú sa tagy",
        "th": "กำลังโหลดแท็ก"
    },
    "you-have-requested-the-role-of": {
        "de": "Sie haben die Rolle angefordert von",
        "en": "You have requested the role of",
        "es": "Has solicitado el papel de",
        "fr": "Vous avez demandé le rôle de",
        "km": "អ្នកបានស្នើសុំតួនាទី",
        "lv": "Jūs esat pieprasījis lomu",
        "nl": "Je hebt gevraagd om de rol van",
        "pl": "Poprosiłeś o rolę",
        "pt": "Você solicitou o papel de",
        "sk": "Požiadali ste o rolu",
        "th": "คุณได้ยื่นคำขอบทบาทเป็น"
    },
    "link-copied": {
        "de": "Link kopiert",
        "en": "Link Copied",
        "es": "Enlace copiado",
        "fr": "Lien copié",
        "km": "បានចម្លងតំណ",
        "lv": "Saite nokopēta",
        "nl": "Link gekopieerd",
        "pl": "Link skopiowany",
        "pt": "Link copiado",
        "sk": "Odkaz bol skopírovaný",
        "th": "คัดลอกลิงก์เรียบร้อยแล้ว"
    },
    "my-students": {
        "de": "MEINE SCHÜLERINNEN UND SCHÜLER",
        "en": "MY STUDENTS",
        "es": "Mis alumnas",
        "fr": "MES ELEVES",
        "km": "សិស្សរបស់ខ្ញុំ",
        "lv": "MANI SKOLĒNI",
        "nl": "MIJN STUDENTEN",
        "pl": "MOI UCZNIOWIE",
        "pt": "MEUS ALUNOS",
        "sk": "MOJI ŽIACI",
        "th": "รายชื่อนักเรียน"
    },
    "unable-to-load-tags": {
        "de": "Schlagworte können nicht geladen werden",
        "en": "Unable to Load Tags",
        "es": "No se pueden cargar las etiquetas",
        "fr": "Impossible de charger les étiquettes",
        "km": "មិនអាចផ្ទុកស្លាកបានទេ",
        "lv": "Nevar ielādēt tagus",
        "nl": "Kan labels niet laden",
        "pl": "Nie można załadować tagów",
        "pt": "Não foi possível carregar as etiquetas",
        "sk": "Nie je možné načítať tagy",
        "th": "ไม่สามารถโหลดแท็กที่พร้อมใช้งานได้"
    },
    "bug-description": {
        "de": "Fehlerbeschreibung",
        "en": "Bug Description",
        "es": "Descripción del error",
        "fr": "Description du dysfonctionnement",
        "km": "សេចក្តីពិពណ៌នាបញ្ហា",
        "lv": "Kļūdas apraksts",
        "nl": "Foutbeschrijving",
        "pl": "Opis błędu",
        "pt": "Descrição do bug",
        "sk": "Popis chyby",
        "th": "คำอธิบายข้อบกพร่อง"
    },
    "are-you-sure": {
        "de": "Sind Sie sicher?",
        "en": "Are You Sure?",
        "es": "Estas segura",
        "fr": "Êtes-vous sûr ?",
        "km": "តើអ្នកប្រាកដទេ?",
        "lv": "Vai esi pārliecināts?",
        "nl": "Weet je het zeker?",
        "pl": "Czy na pewno?",
        "pt": "Tem certeza?",
        "sk": "Si si istý?",
        "th": "ท่านแน่ใจหรือไม่?"
    },
    "assign-relevant-competencies-to-make-this-conten": {
        "de": "Weisen Sie relevante Kompetenzen zu, um diesen Inhalt auffindbar zu machen",
        "en": "Assign Relevant Competencies to Make this Content Discoverable",
        "es": "Asigna competencias relevantes para que este contenido sea localizable",
        "fr": "Attribuez des compétences pertinentes pour rendre ce contenu découvrable",
        "km": "ចាត់តាំងជំនាញពាក់ព័ន្ធ ដើម្បីធ្វើឱ្យមាតិកានេះអាចស្វែងរកបាន",
        "lv": "Piešķiriet atbilstošās kompetences, lai šis saturs būtu atrodams",
        "nl": "Wijs relevante competenties toe om deze inhoud vindbaar te maken",
        "pl": "Przypisz odpowiednie kompetencje, aby ta treść była łatwa do znalezienia",
        "pt": "Atribua competências relevantes para tornar este conteúdo localizável",
        "sk": "Priraďte relevantné kompetencie, aby bol tento obsah vyhľadateľný",
        "th": "กำหนดสมรรถนะที่เกี่ยวข้องเพื่อให้ค้นพบเนื้อหานี้ได้"
    },
    "student-info": {
        "de": "Schülerinnen-/Schülerinfo",
        "en": "Student info",
        "es": "Información del estudiante",
        "fr": "Informations sur l’élève",
        "km": "ព័ត៌មានសិស្ស",
        "lv": "Informācija par skolēniem",
        "nl": "Studenteninformatie",
        "pl": "Informacje o uczniu",
        "pt": "Informações do aluno",
        "sk": "Informácie o žiakovi",
        "th": "ข้อมูลนักเรียน"
    },
    "search": {
        "de": "Suchen",
        "en": "Search",
        "es": "Buscar",
        "fr": "Rechercher",
        "km": "ស្វែងរក",
        "lv": "Meklēt",
        "nl": "Zoeken",
        "pl": "Szukaj",
        "pt": "Pesquisar",
        "sk": "Hľadať",
        "th": "ค้นหา"
    },
    "status": {
        "de": "Status",
        "en": "Status",
        "es": "Estado",
        "fr": "Statut",
        "km": "ស្ថានភាព",
        "lv": "Statuss",
        "nl": "Status",
        "pl": "Stan",
        "pt": "Estado",
        "sk": "Stav",
        "th": "สถานะ"
    },
    "group": {
        "de": "Gruppe",
        "en": "Group",
        "es": "grupo",
        "fr": "Groupe",
        "km": "ក្រុម",
        "lv": "Grupa",
        "nl": "Groep",
        "pl": "Grupa",
        "pt": "Grupo",
        "sk": "Skupina",
        "th": "กลุ่ม"
    },
    "groups": {
        "de": "Gruppen",
        "en": "Groups",
        "es": "Grupos",
        "fr": "Groupes",
        "km": "ក្រុម",
        "lv": "Grupas",
        "nl": "Groepen",
        "pl": "Grupy",
        "pt": "Grupos",
        "sk": "Skupiny",
        "th": "กลุ่ม"
    },
    "active": {
        "de": "Aktiv",
        "en": "Active",
        "es": "Activo",
        "fr": "Actif",
        "km": "សកម្ម",
        "lv": "Aktīvs",
        "nl": "Actief",
        "pl": "Aktywny",
        "pt": "Ativo",
        "sk": "Aktívne",
        "th": "ใช้งานอยู่"
    },
    "actions": {
        "de": "Aktionen",
        "en": "Actions",
        "es": "Acciones",
        "fr": "Actions",
        "km": "សកម្មភាព",
        "lv": "Darbības",
        "nl": "Acties",
        "pl": "Działania",
        "pt": "Ações",
        "sk": "Akcie",
        "th": "การดำเนินการ"
    },
    "unnamed": {
        "de": "Unbenannt",
        "en": "Unnamed",
        "es": "Sin nombre",
        "fr": "Sans nom",
        "km": "គ្មានឈ្មោះ",
        "lv": "Bez nosaukuma",
        "nl": "Naamloos",
        "pl": "Bezimienny",
        "pt": "Sem nome",
        "sk": "Bez názvu",
        "th": "ไม่มีชื่อ"
    },
    "students": {
        "de": "Studenten",
        "en": "Students",
        "es": "estudiantes",
        "fr": "Étudiants",
        "km": "សិស្ស",
        "lv": "Skolēni",
        "nl": "Studenten",
        "pl": "Studenci",
        "pt": "Alunos",
        "sk": "Žiaci",
        "th": "นักเรียน"
    },
    "edit": {
        "de": "Bearbeiten",
        "en": "Edit",
        "es": "Editar",
        "fr": "Modifier",
        "km": "កែសម្រួល",
        "lv": "Rediģēt",
        "nl": "Bewerken",
        "pl": "Edytuj",
        "pt": "Editar",
        "sk": "Upraviť",
        "th": "แก้ไข"
    },
    "admins": {
        "de": "Administratoren",
        "en": "Admins",
        "es": "Administradores",
        "fr": "Administrateurs",
        "km": "អ្នកគ្រប់គ្រង",
        "lv": "Administratori",
        "nl": "Beheerders",
        "pl": "Administratorzy",
        "pt": "Administradores",
        "sk": "Správcovia",
        "th": "ผู้ดูแลระบบ"
    },
    "no-one-has-been-assigned-this-role": {
        "de": "Diese Rolle wurde niemandem zugewiesen",
        "en": "No one has been assigned this role",
        "es": "A nadie se le ha asignado este rol.",
        "fr": "Personne n'a reçu ce rôle",
        "km": "គ្មាននរណាម្នាក់ត្រូវបានចាត់តាំងតួនាទីនេះទេ។",
        "lv": "Šī loma nevienam nav piešķirta",
        "nl": "Niemand heeft deze rol toegewezen gekregen",
        "pl": "Nikomu nie przydzielono tej roli",
        "pt": "Ninguém foi designado para esta função",
        "sk": "Táto rola nebola nikomu pridelená",
        "th": "ไม่มีใครได้รับมอบหมายบทบาทนี้"
    },
    "sort": {
        "de": "Sortieren",
        "en": "Sort",
        "es": "ordenar",
        "fr": "Trier",
        "km": "តម្រៀប",
        "lv": "Kārtot",
        "nl": "Sorteren",
        "pl": "Sortuj",
        "pt": "Classificar",
        "sk": "Zoradiť",
        "th": "จัดเรียง"
    },
    "filter": {
        "de": "Filtern",
        "en": "Filter",
        "es": "Filtrar",
        "fr": "Filtrer",
        "km": "តម្រង",
        "lv": "Filtrs",
        "nl": "Filteren",
        "pl": "Filtruj",
        "pt": "Filtro",
        "sk": "Filtrovať",
        "th": "ตัวกรอง"
    },
    "show": {
        "de": "Zeigen",
        "en": "Show",
        "es": "Mostrar",
        "fr": "Afficher",
        "km": "បង្ហាញ",
        "lv": "Rādīt",
        "nl": "Toon",
        "pl": "Pokaż",
        "pt": "Mostrar",
        "sk": "Zobraziť",
        "th": "แสดง"
    },
    "type": {
        "de": "Typ",
        "en": "Type",
        "es": "Tipo",
        "fr": "Tapez",
        "km": "ប្រភេទ",
        "lv": "Tips",
        "nl": "Typ",
        "pl": "Wpisz",
        "pt": "Tipo",
        "sk": "Typ",
        "th": "ประเภท"
    },
    "back": {
        "de": "Zurück",
        "en": "Back",
        "es": "Atrás",
        "fr": "Retour",
        "km": "ត្រឡប់មកវិញ",
        "lv": "Atpakaļ",
        "nl": "Terug",
        "pl": "Powrót",
        "pt": "Voltar",
        "sk": "Späť",
        "th": "กลับ"
    },
    "items": {
        "de": "Artikel",
        "en": "Items",
        "es": "Artículos",
        "fr": "Articles",
        "km": "ធាតុ",
        "lv": "Preces",
        "nl": "Artikelen",
        "pl": "Przedmioty",
        "pt": "Itens",
        "sk": "Položky",
        "th": "รายการ"
    },
    "item": {
        "de": "Artikel",
        "en": "Item",
        "es": "Artículo",
        "fr": "Article",
        "km": "ធាតុ",
        "lv": "Vienums",
        "nl": "Artikel",
        "pl": "Przedmiot",
        "pt": "Artigo",
        "sk": "Položka",
        "th": "รายการ"
    },
    "sequences": {
        "de": "Sequenzen",
        "en": "Sequences",
        "es": "Secuencias",
        "fr": "Séquences",
        "km": "លំដាប់",
        "lv": "Secības",
        "nl": "Reeksen",
        "pl": "Sekwencje",
        "pt": "Sequências",
        "sk": "Sekvencie",
        "th": "ลำดับ"
    },
    "delete": {
        "de": "Löschen",
        "en": "Delete",
        "es": "Eliminar",
        "fr": "Supprimer",
        "km": "លុប",
        "lv": "Dzēst",
        "nl": "Verwijderen",
        "pl": "Usuń",
        "pt": "Excluir",
        "sk": "Odstrániť",
        "th": "ลบ"
    },
    "my-content": {
        "de": "Mein Inhalt",
        "en": "My content",
        "es": "mi contenido",
        "fr": "Mon contenu",
        "km": "ខ្លឹមសាររបស់ខ្ញុំ",
        "lv": "Mans saturs",
        "nl": "Mijn inhoud",
        "pl": "Moja treść",
        "pt": "Meu conteúdo",
        "sk": "Môj obsah",
        "th": "เนื้อหาของฉัน"
    },
    "new": {
        "de": "Neu",
        "en": "New",
        "es": "Nuevo",
        "fr": "Nouveau",
        "km": "ថ្មី។",
        "lv": "Jauns",
        "nl": "Nieuw",
        "pl": "Nowy",
        "pt": "Novo",
        "sk": "Nové",
        "th": "ใหม่"
    },
    "expert": {
        "de": "Experte",
        "en": "Expert",
        "es": "Experto",
        "fr": "Expert",
        "km": "អ្នកជំនាញ",
        "lv": "Eksperts",
        "nl": "Deskundige",
        "pl": "Ekspert",
        "pt": "Especialista",
        "sk": "Expert",
        "th": "ผู้เชี่ยวชาญ"
    },
    "support": {
        "de": "Unterstützung",
        "en": "Support",
        "es": "Soporte",
        "fr": "Assistance",
        "km": "គាំទ្រ",
        "lv": "Atbalsts",
        "nl": "Ondersteuning",
        "pl": "Wsparcie",
        "pt": "Suporte",
        "sk": "Podpora",
        "th": "สนับสนุน"
    },
    "assignment-report": {
        "de": "Auftragsbericht",
        "en": "Assignment report",
        "es": "Informe de tarea",
        "fr": "Rapport de mission",
        "km": "របាយការណ៍ការងារ",
        "lv": "Uzdevuma atskaite",
        "nl": "Opdrachtrapport",
        "pl": "Raport przydziału",
        "pt": "Relatório de tarefa",
        "sk": "Prehľad úloh",
        "th": "รายงานการมอบหมายงาน"
    },
    "steps-to-reproduce-are-required": {
        "de": "Schritte zur Reproduktion sind erforderlich",
        "en": "Steps to reproduce are required",
        "es": "Se requieren pasos para reproducir",
        "fr": "Des étapes de reproduction sont nécessaires",
        "km": "ជំហានដើម្បីបង្កើតឡើងវិញគឺត្រូវបានទាមទារ",
        "lv": "Ir jāveic darbības, lai reproducētu",
        "nl": "Er zijn stappen nodig om te reproduceren",
        "pl": "Wymagane są kroki w celu odtworzenia",
        "pt": "As etapas para reproduzir são necessárias",
        "sk": "Je potrebné uviesť kroky na reprodukciu problému",
        "th": "ต้องมีขั้นตอนในการสืบพันธุ์"
    },
    "you-will-be-able-to-participate-in-research-stud": {
        "de": "Sie haben die Möglichkeit, an Forschungsstudien teilzunehmen",
        "en": "You will be able to participate in research studies",
        "es": "Podrás participar en estudios de investigación.",
        "fr": "Vous pourrez participer à des études de recherche",
        "km": "អ្នកនឹងអាចចូលរួមក្នុងការសិក្សាស្រាវជ្រាវ",
        "lv": "Jume ir iespēja piedalīties pētnieciskajos pētījumos",
        "nl": "U kunt deelnemen aan onderzoeken",
        "pl": "Będziesz mógł brać udział w badaniach naukowych",
        "pt": "Você poderá participar de pesquisas",
        "sk": "Budeš sa môcť zúčastniť výskumných štúdií",
        "th": "คุณจะสามารถเข้าร่วมการศึกษาวิจัยได้"
    },
    "filters": {
        "de": "Filter",
        "en": "Filters",
        "es": "Filtros",
        "fr": "Filtres",
        "km": "តម្រង",
        "lv": "Filtri",
        "nl": "Filters",
        "pl": "Filtry",
        "pt": "Filtros",
        "sk": "Filtre",
        "th": "ตัวกรอง"
    },
    "assigned-to": {
        "de": "Zugewiesen an",
        "en": "Assigned to",
        "es": "Asignado a",
        "fr": "Attribué à",
        "km": "ចាត់តាំងទៅ",
        "lv": "Piešķirts",
        "nl": "Toegewezen aan",
        "pl": "Przypisany do",
        "pt": "Atribuído a",
        "sk": "Pridelené k",
        "th": "มอบหมายให้"
    },
    "duplicate": {
        "de": "Duplizieren",
        "en": "Duplicate",
        "es": "Duplicar",
        "fr": "Dupliquer",
        "km": "ស្ទួន",
        "lv": "Dublikāts",
        "nl": "Duplicaat",
        "pl": "Duplikat",
        "pt": "Duplicar",
        "sk": "Duplikovať",
        "th": "ทำซ้ำ"
    },
    "of": {
        "de": "von",
        "en": "of",
        "es": "de",
        "fr": "de",
        "km": "នៃ",
        "lv": "no",
        "nl": "van",
        "pl": "z",
        "pt": "de",
        "sk": "z",
        "th": "ของ"
    },
    "previous": {
        "de": "Zurück",
        "en": "Previous",
        "es": "Anterior",
        "fr": "Précédent",
        "km": "មុន",
        "lv": "Iepriekšējais",
        "nl": "Vorige",
        "pl": "Poprzedni",
        "pt": "Anterior",
        "sk": "Predchádzajúce",
        "th": "ก่อนหน้า"
    },
    "next": {
        "de": "Als nächstes",
        "en": "Next",
        "es": "Siguiente",
        "fr": "Suivant",
        "km": "បន្ទាប់",
        "lv": "Nākamais",
        "nl": "Volgende",
        "pl": "Następny",
        "pt": "Próximo",
        "sk": "Nasledujúce",
        "th": "ถัดไป"
    },
    "draft": {
        "de": "Entwurf",
        "en": "Draft",
        "es": "Borrador",
        "fr": "Brouillon",
        "km": "សេចក្តីព្រាង",
        "lv": "Melnraksts",
        "nl": "Diepgang",
        "pl": "Wersja robocza",
        "pt": "Rascunho",
        "sk": "Návrh",
        "th": "ร่าง"
    },
    "project": {
        "de": "Projekt",
        "en": "Project",
        "es": "Proyecto",
        "fr": "Projet",
        "km": "គម្រោង",
        "lv": "Projekts",
        "nl": "Project",
        "pl": "Projekt",
        "pt": "Projeto",
        "sk": "Projekt",
        "th": "โครงการ"
    },
    "step": {
        "de": "Schritt",
        "en": "Step",
        "es": "paso",
        "fr": "Étape",
        "km": "ជំហាន",
        "lv": "Solis",
        "nl": "Stap",
        "pl": "Krok",
        "pt": "Passo",
        "sk": "Krok",
        "th": "ขั้นตอน"
    },
    "instructions": {
        "de": "Anweisungen",
        "en": "Instructions",
        "es": "Instrucciones",
        "fr": "Instructions",
        "km": "សេចក្តីណែនាំ",
        "lv": "Norādījumi",
        "nl": "Instructies",
        "pl": "Instrukcje",
        "pt": "Instruções",
        "sk": "Inštrukcie",
        "th": "คำแนะนำ"
    },
    "title": {
        "de": "Titel",
        "en": "Title",
        "es": "Título",
        "fr": "Titre",
        "km": "ចំណងជើង",
        "lv": "Nosaukums",
        "nl": "Titel",
        "pl": "Tytuł",
        "pt": "Título",
        "sk": "Názov",
        "th": "ชื่อเรื่อง"
    },
    "yes": {
        "de": "Ja",
        "en": "Yes",
        "es": "si",
        "fr": "Oui",
        "km": "បាទ",
        "lv": "Jā",
        "nl": "Ja",
        "pl": "Tak",
        "pt": "Sim",
        "sk": "Áno",
        "th": "ใช่"
    },
    "no": {
        "de": "Nein",
        "en": "No",
        "es": "No",
        "fr": "Non",
        "km": "ទេ",
        "lv": "Nē",
        "nl": "Nee",
        "pl": "Nie",
        "pt": "Não",
        "sk": "Nie",
        "th": "ไม่"
    },
    "student": {
        "de": "Student",
        "en": "Student",
        "es": "estudiante",
        "fr": "Étudiant",
        "km": "សិស្ស",
        "lv": "Skolēns",
        "nl": "Student",
        "pl": "Studenta",
        "pt": "Estudante",
        "sk": "Žiak",
        "th": "นักศึกษา"
    },
    "point": {
        "de": "Punkt",
        "en": "Point",
        "es": "Punto",
        "fr": "Point",
        "km": "ចំណុច",
        "lv": "Punkts",
        "nl": "Punt",
        "pl": "Punkt",
        "pt": "Ponto",
        "sk": "Bod",
        "th": "จุด"
    },
    "result": {
        "de": "Ergebnis",
        "en": "Result",
        "es": "Resultado",
        "fr": "Résultat",
        "km": "លទ្ធផល",
        "lv": "Rezultāts",
        "nl": "Resultaat",
        "pl": "Wynik",
        "pt": "Resultado",
        "sk": "Výsledok",
        "th": "ผลลัพธ์"
    },
    "correct": {
        "de": "Richtig",
        "en": "Correct",
        "es": "Correcto",
        "fr": "Correct",
        "km": "ត្រឹមត្រូវ។",
        "lv": "Pareizi",
        "nl": "Juist",
        "pl": "Poprawne",
        "pt": "Correto",
        "sk": "Správne",
        "th": "ถูกต้อง"
    },
    "details": {
        "de": "Einzelheiten",
        "en": "Details",
        "es": "Detalles",
        "fr": "Détails",
        "km": "ព័ត៌មានលម្អិត",
        "lv": "Sīkāka informācija",
        "nl": "Details",
        "pl": "Szczegóły",
        "pt": "Detalhes",
        "sk": "Podrobnosti",
        "th": "รายละเอียด"
    },
    "email": {
        "de": "E-Mail",
        "en": "Email",
        "es": "Correo electrónico",
        "fr": "Courriel",
        "km": "អ៊ីមែល",
        "lv": "E-pasts",
        "nl": "E-mail",
        "pl": "E-mail",
        "pt": "E-mail",
        "sk": "Email",
        "th": "อีเมล"
    },
    "submitted": {
        "de": "Eingereicht",
        "en": "Submitted",
        "es": "Enviado",
        "fr": "Soumis",
        "km": "បានដាក់ស្នើ",
        "lv": "Iesniegts",
        "nl": "Ingezonden",
        "pl": "Przesłane",
        "pt": "Enviado",
        "sk": "Odovzdané",
        "th": "ส่งแล้ว"
    },
    "page": {
        "de": "Seite",
        "en": "Page",
        "es": "Página",
        "fr": "Pages",
        "km": "ទំព័រ",
        "lv": "Lapa",
        "nl": "Pagina",
        "pl": "Strona",
        "pt": "Página",
        "sk": "Stránka",
        "th": "หน้า"
    },
    "all": {
        "de": "Alle",
        "en": "All",
        "es": "Todos",
        "fr": "Tout",
        "km": "ទាំងអស់។",
        "lv": "Visi",
        "nl": "Allemaal",
        "pl": "Wszystko",
        "pt": "Todos",
        "sk": "Všetko",
        "th": "ทั้งหมด"
    },
    "add-students": {
        "de": "Studenten hinzufügen",
        "en": "Add students",
        "es": "Agregar estudiantes",
        "fr": "Ajouter des étudiants",
        "km": "បន្ថែមសិស្ស",
        "lv": "Pievienojiet studentus",
        "nl": "Voeg studenten toe",
        "pl": "Dodaj uczniów",
        "pt": "Adicionar alunos",
        "sk": "Pridať žiakov",
        "th": "เพิ่มนักเรียน"
    },
    "primary": {
        "de": "Primär",
        "en": "Primary",
        "es": "Primaria",
        "fr": "Primaire",
        "km": "មូលដ្ឋាន",
        "lv": "Pamata",
        "nl": "Primair",
        "pl": "Podstawowy",
        "pt": "Primária",
        "sk": "Primárne",
        "th": "ระดับประถมศึกษา"
    },
    "add-new": {
        "de": "Neu hinzufügen",
        "en": "Add New",
        "es": "Agregar nuevo",
        "fr": "Ajouter nouveau",
        "km": "បន្ថែមថ្មី",
        "lv": "Pievienot jaunu",
        "nl": "Nieuw toevoegen",
        "pl": "Dodaj nowy",
        "pt": "Adicionar novo",
        "sk": "Pridať nový",
        "th": "เพิ่มใหม่"
    },
    "chirpys-adventure": {
        "de": "CHIRPYS ABENTEUER",
        "en": "CHIRPY'S ADVENTURE",
        "es": "LA AVENTURA DE CHIRPY",
        "fr": "L’AVENTURE DE CHIRPY",
        "km": "ដំណើរផ្សងព្រេងរបស់ CHIRPY",
        "lv": "ČIRPIJA PIEDZĪVOJUMS",
        "nl": "CHIRPY'S AVONTUUR",
        "pl": "PRZYGODA CHIRPY'EGO",
        "pt": "A AVENTURA DE CHIRPY",
        "sk": "CHIRPYHO DOBRODRUŽSTVO",
        "th": "การผจญภัยของเชอร์ปี้"
    },
    "submit": {
        "de": "Einreichen",
        "en": "Submit",
        "es": "Entregar",
        "fr": "Envoyer",
        "km": "បញ្ជូន",
        "lv": "Iesniegt",
        "nl": "Indienen",
        "pl": "Prześlij",
        "pt": "Enviar",
        "sk": "Odoslať",
        "th": "ส่ง"
    },
    "report-another-bug": {
        "de": "Einen weiteren Fehler melden",
        "en": "Report Another Bug",
        "es": "Informar otro error",
        "fr": "Signaler un autre dysfonctionnement",
        "km": "រាយការណ៍បញ្ហាផ្សេងទៀត",
        "lv": "Ziņot par citu kļūdu",
        "nl": "Rapporteer nog een bug",
        "pl": "Zgłoś inny błąd",
        "pt": "Reportar outro bug",
        "sk": "Nahlásiť ďalšiu chybu",
        "th": "รายงานข้อผิดพลาดอื่น"
    },
    "if-you-opt-out-you-will-no-longer-be-included-in": {
        "de": "Wenn Sie sich abmelden, werden Sie nicht mehr an experimentellen Funktionen oder A/B-Tests teilnehmen, die mit diesem Konto verknüpft sind. \n\nSie haben weiterhin normalen Zugriff, neue experimentelle Änderungen werden Ihnen jedoch möglicherweise nicht angezeigt.",
        "en": "If you opt out, you will no longer be included in experimental features or A/B tests tied to this account.\n\nYou will continue to have normal access, but new experimental changes may not be shown to you.",
        "es": "Si opta por no participar, ya no se le incluirá en las funciones experimentales ni en las pruebas A/B vinculadas a esta cuenta. \n\nContinuará teniendo acceso normal, pero es posible que no se le muestren nuevos cambios experimentales.",
        "fr": "Si vous vous retirez, vous ne serez plus inclus dans les fonctionnalités expérimentales ou les tests A/B liés à ce compte. Vous conserverez un accès normal, mais les nouvelles modifications expérimentales peuvent ne pas vous être affichées.",
        "km": "ប្រសិនបើអ្នកបោះបង់ អ្នកនឹងមិនត្រូវរួមបញ្ចូលក្នុងលក្ខណៈពិសោធន៍ ឬការធ្វើតេស្ត A/B ដែលភ្ជាប់ជាមួយគណនីនេះទៀតទេ។ អ្នកនៅតែអាចចូលប្រើតាមធម្មតាបាន ប៉ុន្តែការផ្លាស់ប្តូរពិសោធន៍ថ្មីៗអាចមិនត្រូវបង្ហាញឱ្យអ្នកឃើញទេ។",
        "lv": "Ja atteiksities, jūs vairs netiksiet iekļauts eksperimentālajās aktivitātēs vai A/B testos, kas ir saistīti ar šo kontu. \n\nJums joprojām būs parasta piekļuve, taču jaunas pētījuma izmaiņas var netikt rādītas.",
        "nl": "Als u zich afmeldt, wordt u niet langer opgenomen in experimentele functies of A/B-tests die aan dit account zijn gekoppeld. \n\nU behoudt de normale toegang, maar nieuwe experimentele wijzigingen worden mogelijk niet aan u getoond.",
        "pl": "Jeśli zrezygnujesz, nie będziesz już uwzględniany w funkcjach eksperymentalnych ani testach A/B powiązanych z tym kontem. Nadal będziesz mieć normalny dostęp, ale nowe eksperymentalne zmiany mogą nie być ci pokazywane.",
        "pt": "Se você cancelar, não será mais incluído em recursos experimentais ou testes A/B vinculados a esta conta. \n\nVocê continuará tendo acesso normal, mas novas alterações experimentais talvez não sejam mostradas para você.",
        "sk": "Ak sa odhlásite, už nebudete súčasťou experimentálnych funkcií ani A/B testov spojených s týmto účtom. \n\nNaďalej budete mať normálny prístup, ale nové experimentálne zmeny sa vám nemusia zobraziť.",
        "th": "หากคุณยกเลิก คุณจะไม่ถูกรวมอยู่ในคุณลักษณะทดลองหรือการทดสอบ A/B ที่เชื่อมโยงกับบัญชีนี้อีกต่อไป คุณยังคงสามารถเข้าถึงตามปกติได้ แต่การเปลี่ยนแปลงการทดลองใหม่อาจไม่แสดงให้คุณเห็น"
    },
    "create-edit-group": {
        "de": "Gruppe erstellen/bearbeiten",
        "en": "Create / Edit Group",
        "es": "Crear/Editar grupo",
        "fr": "Créer / Modifier un groupe",
        "km": "បង្កើត/កែប្រែក្រុម",
        "lv": "Izveidot/rediģēt grupu",
        "nl": "Groep maken/bewerken",
        "pl": "Utwórz / edytuj grupę",
        "pt": "Criar/editar grupo",
        "sk": "Vytvoriť / Upraviť skupinu",
        "th": "สร้าง / แก้ไขกลุ่ม"
    },
    "your-clicks": {
        "de": "deine Klicks",
        "en": "your clicks",
        "es": "tus clics",
        "fr": "Tes clics",
        "km": "ការចុចរបស់អ្នក",
        "lv": "tavi klikšķi",
        "nl": "uw klikken",
        "pl": "Twoje kliknięcia",
        "pt": "seus cliques",
        "sk": "kam klikáš",
        "th": "การคลิกของท่าน"
    },
    "reports": {
        "de": "Berichte",
        "en": "Reports",
        "es": "Informes",
        "fr": "Rapports",
        "km": "របាយការណ៍",
        "lv": "Pārskati",
        "nl": "Rapporten",
        "pl": "Raporty",
        "pt": "Relatórios",
        "sk": "Prehľady",
        "th": "รายงาน"
    },
    "studies": {
        "de": "Studien",
        "en": "Studies",
        "es": "Estudios",
        "fr": "Études",
        "km": "ការសិក្សា",
        "lv": "Mācības",
        "nl": "Studies",
        "pl": "Badania",
        "pt": "Estudos",
        "sk": "Štúdie",
        "th": "งานวิจัย"
    },
    "saving-changes": {
        "de": "Änderungen werden gespeichert",
        "en": "Saving Changes",
        "es": "Guardando cambios",
        "fr": "Enregistrement des modifications",
        "km": "កំពុងរក្សាទុកការផ្លាស់ប្ដូរ",
        "lv": "Notiek izmaiņu saglabāšana",
        "nl": "Wijzigingen opslaan",
        "pl": "Zapisywanie zmian",
        "pt": "Salvando alterações",
        "sk": "Ukladajú sa zmeny",
        "th": "กำลังบันทึกการเปลี่ยนแปลง..."
    },
    "import-content": {
        "de": "INHALTE IMPORTIEREN",
        "en": "IMPORT CONTENT",
        "es": "IMPORTAR CONTENIDO",
        "fr": "IMPORTER DU CONTENU",
        "km": "នាំចូលមាតិកា",
        "lv": "IMPORTĒT SATURU",
        "nl": "INHOUD IMPORTEREN",
        "pl": "IMPORTUJ ZAWARTOŚĆ",
        "pt": "IMPORTAR CONTEÚDO",
        "sk": "IMPORTOVAŤ OBSAH",
        "th": "นำเข้าบทเรียน"
    },
    "magical-mixology": {
        "de": "MAGISCHE MIXOLOGIE",
        "en": "MAGICAL MIXOLOGY",
        "es": "MEZCLA MÁGICA",
        "fr": "MIXOLOGIE MAGIQUE",
        "km": "ការលាយភេសជ្ជៈវេទមន្ត",
        "lv": "MAĢISKĀ JAUKŠANA",
        "nl": "MAGISCHE MIXOLOGIE",
        "pl": "MAGICZNA MIKSTURA",
        "pt": "MIXOLOGIA MAGICA",
        "sk": "MAGICKÁ MIXOLÓGIA",
        "th": "การผสมวิเศษ"
    },
    "enter-an-encryption-key-word-you-will-remember-t": {
        "de": "Geben Sie ein Verschlüsselungsschlüsselwort ein, das Sie sich merken können. Dieses Schlüsselwort wird verwendet, damit Sie die Namen Ihrer Schülerinnen und Schüler sehen können und gleichzeitig die Anonymität ihrer Daten für alle anderen Benutzerinnen und Benutzer gewahrt bleibt.",
        "en": "Enter an encryption key-word to memorise. This key-word will be used to allow you to see your students' names while preserving the anonymity of their data for all other users.",
        "es": "Ingrese una palabra clave de cifrado que recordará. Esta palabra clave se utilizará para permitirle ver los nombres de sus estudiantes preservando al mismo tiempo el anonimato de sus datos para todos los demás usuarios.",
        "fr": "Entrez un mot de passe dont vous vous souviendrez. Ce mot de passe sera utilisé pour vous permettre de voir les noms de vos élèves tout en préservant l’anonymat de leurs données pour tous les autres utilisateurs.",
        "km": "បញ្ចូលពាក្យសម្ងាត់ដែលអ្នកនឹងចាំ។ ពាក្យនេះនឹងត្រូវប្រើសម្រាប់ឲ្យអ្នកមើលឈ្មោះសិស្សរបស់អ្នក ខណៈដែលរក្សាអនាមិកភាពទិន្នន័យសម្រាប់អ្នកប្រើផ្សេងទៀត។",
        "lv": "Ievadiet šifrēšanas atslēgas vārdu, kuru atcerēsities. Šis atslēgas vārds tiks izmantots, lai jūs varētu redzēt savu skolēnu vārdus, vienlaikus saglabājot viņu datu anonimitāti visiem citiem lietotājiem.",
        "nl": "Voer een coderingssleutelwoord in dat u zich kunt herinneren. Dit trefwoord wordt gebruikt zodat u de namen van uw leerlingen kunt zien, terwijl de anonimiteit van hun gegevens voor alle andere gebruikers behouden blijft.",
        "pl": "Wprowadź słowo-klucz szyfrowania, które zapamiętasz. To słowo-klucz pozwoli Ci zobaczyć imiona uczniów przy zachowaniu anonimowości danych dla wszystkich innych użytkowników.",
        "pt": "Digite uma palavra-chave de criptografia que você lembrará. Esta palavra-chave será usada para permitir que você veja os nomes dos seus alunos, preservando o anonimato de seus dados para todos os outros usuários.",
        "sk": "Zadajte šifrovacie heslo, ktoré si zapamätáte. Toto heslo vám umožní vidieť mená vašich žiakov a zároveň zachovať anonymitu ich údajov pre všetkých ostatných používateľov.",
        "th": "กรุณาใส่รหัสที่ท่านสามารถจดจำได้ โดยรหัสนี้จะถูกใช้เพื่ออนุญาตให้ท่านเข้าถึงรายชื่อนักเรียน และรักษาความเป็นส่วนตัวของข้อมูลและป้องกันการเข้าถึงข้อมูลจากผู้ใช้งานอื่น"
    },
    "causal-reasoning": {
        "de": "Kausales Denken",
        "en": "Causal Reasoning",
        "es": "Razonamiento causal",
        "fr": "Raisonnement causal",
        "km": "ការយល់ដឹងមូលហេតុ",
        "lv": "Cēloņsakarības",
        "nl": "Causale redenering",
        "pl": "Wnioskowanie przyczynowe",
        "pt": "Raciocínio Causal",
        "sk": "Kauzálne uvažovanie",
        "th": "การให้เหตุผลโดยระบุเหตุปัจจัย"
    },
    "invalid-id-or-url": {
        "de": "Ungültige ID oder URL",
        "en": "Invalid Id or URL",
        "es": "ID o URL no válidos",
        "fr": "ID ou URL invalide",
        "km": "លេខសម្គាល់ ឬ URL មិនត្រឹមត្រូវ",
        "lv": "Nederīgs ID vai URL",
        "nl": "Ongeldige ID of URL",
        "pl": "Nieprawidłowe Id lub URL",
        "pt": "ID ou URL inválido",
        "sk": "Neplatné ID alebo URL",
        "th": "ไอดีหรือ URL ที่ไม่ถูกต้อง"
    },
    "files-alt": {
        "de": "Dateien",
        "en": "Files",
        "es": "Archivos",
        "fr": "Fichiers",
        "km": "ឯកសារ",
        "lv": "Faili",
        "nl": "Bestanden",
        "pl": "Pliki",
        "pt": "Arquivos",
        "sk": "Súbory",
        "th": "ไฟล์"
    },
    "joining-teacher": {
        "de": "... Lehrkraft beitreten...",
        "en": "... joining teacher...",
        "es": "...uniéndose al maestro...",
        "fr": "... rejoindre l’enseignant...",
        "km": "... កំពុងចូលរួមជាមួយគ្រូ...",
        "lv": "... pievienojos skolotājam...",
        "nl": "... aansluiten bij leraar...",
        "pl": "... dołączanie do nauczyciela ...",
        "pt": "... juntando-se ao professor...",
        "sk": "...pripájam sa k učiteľovi...",
        "th": "... กำลังเข้าร่วมชั้นเรียน ..."
    },
    "agree": {
        "de": "Zustimmen",
        "en": "Agree",
        "es": "Aceptar",
        "fr": "Accepter",
        "km": "យល់ព្រម",
        "lv": "Piekrītu",
        "nl": "Mee eens zijn",
        "pl": "Zgadzam się",
        "pt": "Concordar",
        "sk": "Súhlasím",
        "th": "ยอมรับ"
    },
    "enter-encryption-key-word": {
        "de": "Verschlüsselungsschlüsselwort eingeben",
        "en": "Enter encryption key-word",
        "es": "Introduzca la palabra clave de cifrado",
        "fr": "Saisir le mot de passe",
        "km": "បញ្ចូលពាក្យសម្ងាត់",
        "lv": "Ievadiet šifrēšanas atslēgas vārdu",
        "nl": "Voer het coderingssleutelwoord in",
        "pl": "Wprowadź słowo-klucz szyfrowania",
        "pt": "Insira a palavra-chave de criptografia",
        "sk": "Zadajte šifrovacie heslo",
        "th": "กรุณาใส่รหัสในการเข้าถึงข้อมูล"
    },
    "remove": {
        "de": "Entfernen",
        "en": "Remove",
        "es": "Eliminar",
        "fr": "Supprimer",
        "km": "ដកចេញ",
        "lv": "Noņemt",
        "nl": "Verwijderen",
        "pl": "Usuń",
        "pt": "Remover",
        "sk": "Odstrániť",
        "th": "ลบ"
    },
    "information-about-your-screen-and-device": {
        "de": "Informationen über deinen Bildschirm und dein Gerät",
        "en": "information about your screen and device",
        "es": "información sobre su pantalla y dispositivo",
        "fr": "Les informations sur ton écran et ton appareil",
        "km": "ព័ត៌មានអំពីអេក្រង់ និងឧបករណ៍របស់អ្នក",
        "lv": "informācija par tavu ekrānu un ierīci",
        "nl": "informatie over uw scherm en apparaat",
        "pl": "informacje o ekranie i urządzeniu",
        "pt": "informações sobre sua tela e dispositivo",
        "sk": " ",
        "th": "ข้อมูลเกี่ยวกับหน้าจอและอุปกรณ์ของท่าน"
    },
    "researcher": {
        "de": "Forscherin/Forscher",
        "en": "researcher",
        "es": "investigadora",
        "fr": "chercheur",
        "km": "អ្នកស្រាវជ្រាវ",
        "lv": "pētnieks",
        "nl": "onderzoeker",
        "pl": "badacz",
        "pt": "pesquisador",
        "sk": "výskumník",
        "th": "นักวิจัย"
    },
    "👉-quick-troubleshooting-checklist-please-make-s": {
        "de": "## 👉 Schnelle Checkliste zur Fehlerbehebung \n\nBitte stellen Sie sicher, dass Sie die folgenden Schritte ausprobiert haben, bevor Sie einen Bericht einreichen: \n\n- Verwenden Sie einen empfohlenen Browser (Chrome) \n- Aktualisieren Sie die Seite \n- Schließen Sie Ihren Browser und öffnen Sie ihn erneut \n- Löschen Sie Ihren Browserverlauf/Cache \n- Überprüfen Sie, ob Ihre Internetverbindung schnell ist",
        "en": "##  👉 Quick Troubleshooting Checklist\n\nPlease make sure you've tried these steps before submitting a report:\n\n- Use a recommended browser (Chrome)\n- Refresh the page\n- Close and reopen your browser\n- Clear your broswer history/cache\n- Check that your internet connection is speedy",
        "es": "## 👉 Lista de verificación rápida para solucionar problemas \n\nAsegúrese de haber probado estos pasos antes de enviar un informe: \n\n- Utilice un navegador recomendado (Chrome) \n- Actualizar la página \n- Cierra y vuelve a abrir tu navegador \n- Borra el historial/caché de tu navegador \n- Comprueba que tu conexión a Internet sea rápida.",
        "fr": "## 👉 Guide de dépannage\n\nVeuillez vous assurer d’avoir essayé ces étapes avant de soumettre un rapport :\n\n- Utilisez un navigateur recommandé (Chrome)  \n- Actualisez la page  \n- Fermez et rouvrez votre navigateur  \n- Effacez l’historique/le cache de votre navigateur  \n- Vérifiez que votre connexion Internet est rapide",
        "km": "## 👉 បញ្ជីត្រួតពិនិត្យដើម្បីដោះស្រាយបញ្ហាបន្ទាន់\n\nសូមធានាថាអ្នកបានសាកល្បងជំហានទាំងនេះមុនពេលផ្ញើរបាយការណ៍៖\n\n- ប្រើកម្មវិធីរុករកដែលបានផ្តល់អនុសាសន៍ (Chrome)  \n- ធ្វើឱ្យទំព័របានទាន់សម័យ  \n- បិទ និងបើកកម្មវិធីរុករករបស់អ្នកម្តងទៀត  \n- សម្អាតប្រវត្តិ/ឃ្លាំងសម្ងាត់របស់កម្មវិធីរុករក  \n- ពិនិត្យមើលថាការតភ្ជាប់អ៊ីនធឺណិតរបស់អ្នកលឿន",
        "lv": "## 👉 Ātrās problēmu novēršanas kontrolsaraksts \n\nPirms ziņojuma iesniegšanas, lūdzu, pārliecinieties, vai esat izmēģinājis šīs darbības: \n\n- Izmantojiet ieteicamo pārlūkprogrammu (Chrome) \n- Atsvaidziniet lapu \n- Aizveriet un atkārtoti atveriet pārlūkprogrammu \n- Notīriet pārlūkprogrammas vēsturi/kešatmiņu \n- Pārbaudiet, vai interneta savienojums ir ātrs",
        "nl": "## 👉Checklist voor snelle probleemoplossing \n\nZorg ervoor dat u deze stappen heeft geprobeerd voordat u een rapport indient: \n\n- Gebruik een aanbevolen browser (Chrome) \n- Vernieuw de pagina \n- Sluit en open uw browser opnieuw \n- Wis uw browsergeschiedenis/cache \n- Controleer of uw internetverbinding snel is",
        "pl": "## 👉 Szybka lista kontrolna rozwiązywania problemów\n\nUpewnij się, że wykonałeś te kroki przed wysłaniem zgłoszenia:\n\n- Użyj zalecanej przeglądarki (Chrome)  \n- Odśwież stronę  \n- Zamknij i ponownie otwórz przeglądarkę  \n- Wyczyść historię/pamięć podręczną przeglądarki  \n- Sprawdź, czy Twoje połączenie internetowe jest szybkie",
        "pt": "## 👉 Lista de verificação para solução rápida de problemas \n\nCertifique-se de ter tentado estas etapas antes de enviar um relatório: \n\n- Use um navegador recomendado (Chrome) \n- Atualize a página \n- Feche e reabra seu navegador \n- Limpe o histórico/cache do seu navegador \n- Verifique se sua conexão com a internet é rápida",
        "sk": "## 👉 Rýchly kontrolný zoznam na riešenie problémov \n\nPred odoslaním hlásenia sa uistite, že ste vyskúšali tieto kroky: \n\n- Použite odporúčaný prehliadač (Chrome) \n- Obnovte stránku \n- Zatvorte a znova otvorte prehliadač \n- Vymažte históriu / vyrovnávaciu pamäť prehliadača \n- Skontrolujte, či je vaše internetové pripojenie rýchle",
        "th": "## 👉 รายการตรวจสอบการแก้ไขปัญหาอย่างรวดเร็ว\n\nโปรดตรวจสอบให้แน่ใจว่าคุณได้ลองทำตามขั้นตอนเหล่านี้ก่อนที่จะส่งรายงาน:\n\n- ใช้เบราว์เซอร์ที่แนะนำ (Chrome)  \n- รีเฟรชหน้าเว็บ  \n- ปิดและเปิดเบราว์เซอร์ของคุณอีกครั้ง  \n- ล้างประวัติ/แคชของเบราว์เซอร์  \n- ตรวจสอบว่าการเชื่อมต่ออินเทอร์เน็ตของคุณรวดเร็ว"
    },
    "create": {
        "de": "Erstellen",
        "en": "Create",
        "es": "Crear",
        "fr": "Créer",
        "km": "បង្កើត",
        "lv": "Izveidot",
        "nl": "Creëren",
        "pl": "Utwórz",
        "pt": "Criar",
        "sk": "Vytvoriť",
        "th": "สร้างบทเรียนด้วยตนเอง"
    },
    "trainers": {
        "de": "Trainerinnen/Trainer",
        "en": "Trainers",
        "es": "Entrenadoras",
        "fr": "Formateurs",
        "km": "អ្នកបណ្តុះ",
        "lv": "Treneri",
        "nl": "Trainers",
        "pl": "Trenerzy",
        "pt": "Formadoras",
        "sk": "Školitelia",
        "th": "ผู้ฝึกสอน"
    },
    "confirm-opt-out": {
        "de": "Abmeldung bestätigen",
        "en": "Confirm opt out",
        "es": "Confirmar la exclusión voluntaria",
        "fr": "Confirmer le retrait",
        "km": "បញ្ជាក់ការបោះបង់ចេញ",
        "lv": "Apstipriniet atteikšanos",
        "nl": "Bevestig de opt-out",
        "pl": "Potwierdź rezygnację",
        "pt": "Confirmar desativação",
        "sk": "Potvrďte odhlásenie",
        "th": "ยืนยันการยกเลิก"
    },
    "grant": {
        "de": "Gewähren",
        "en": "Grant",
        "es": "Conceder",
        "fr": "Accorder",
        "km": "ផ្តល់",
        "lv": "Pieejas piešķiršana",
        "nl": "Studiebeurs",
        "pl": "Przyznaj",
        "pt": "Conceder",
        "sk": "Udeliť",
        "th": "อนุญาต"
    },
    "terms-of-service-for-teachers": {
        "de": "Nutzungsbedingungen für Lehrkräfte",
        "en": "Terms of Service for Teachers",
        "es": "Términos de servicio para profesores",
        "fr": "Conditions d’utilisation pour les enseignants",
        "km": "លក្ខខណ្ឌសេវាសម្រាប់គ្រូ",
        "lv": "Pakalpojuma noteikumi skolotājiem",
        "nl": "Servicevoorwaarden voor docenten",
        "pl": "Warunki świadczenia usług dla nauczycieli",
        "pt": "Termos de Serviço para Professores",
        "sk": "Zmluvné podmienky pre učiteľov",
        "th": "ข้อกำหนดในการให้บริการ (Terms of Service) สำหรับครู"
    },
    "feature-title": {
        "de": "Feature-Titel",
        "en": "Feature Title",
        "es": "Título de la característica",
        "fr": "Titre de la fonctionnalité",
        "km": "ខ្សែអក្សរថ្មីសម្រាប់បកប្រែ",
        "lv": "Funkcijas nosaukums",
        "nl": "Functietitel",
        "pl": "Tytuł funkcji",
        "pt": "Título do recurso",
        "sk": "Názov funkcie",
        "th": "ชื่อคุณสมบัติ"
    },
    "to-create-a-teacher-or-researcher-account-please": {
        "de": "Um ein Lehrkäfte- oder Forscherinnen-/Forscherkonto zu erstellen, geben Sie bitte unten Ihren Zugangscode ein:",
        "en": "To create a teacher or researcher account, please enter your access code below:",
        "es": "Para crear una cuenta de profesor o investigador, introduzca su código de acceso a continuación:",
        "fr": "Pour créer un compte enseignant ou chercheur, veuillez saisir votre code d’accès ci-dessous :",
        "km": "ដើម្បីបង្កើតគណនីគ្រូ ឬអ្នកស្រាវជ្រាវ សូមបញ្ចូលកូដចូលប្រើរបស់អ្នកខាងក្រោម៖",
        "lv": "Lai izveidotu skolotāja vai pētnieka kontu, lūdzu, ievadiet savu piekļuves kodu zemāk:",
        "nl": "Om een ​​docent- of onderzoekeraccount aan te maken, vult u hieronder uw toegangscode in:",
        "pl": "Aby utworzyć konto nauczyciela lub badacza, wprowadź poniżej kod dostępu:",
        "pt": "Para criar uma conta de professor ou pesquisador, por favor, insira o seu código de acesso abaixo:",
        "sk": "Ak chcete vytvoriť účet učiteľa/ky alebo výskumníka/čky, zadajte svoj prístupový kód nižšie:",
        "th": "เพื่อสร้างบัญชีของครูหรือนักวิจัย โปรดป้อนรหัสการเข้าถึงของคุณด้านล่าง:"
    },
    "leaving-teacher": {
        "de": "... Lehrkraft verlassen ...",
        "en": "... leaving teacher...",
        "es": "...dejando maestro...",
        "fr": "... quitter l’enseignant...",
        "km": "... កំពុងចាកចេញពីគ្រូ...",
        "lv": "... pamet skolotāju...",
        "nl": "... verlatende leraar...",
        "pl": "... opuszczanie nauczyciela ...",
        "pt": "...deixando professor...",
        "sk": "... odpájam sa od učiteľa...",
        "th": "... กำลังออกจากชั้นเรียน ..."
    },
    "your-data": {
        "de": "Deine Daten",
        "en": "Your Data",
        "es": "Tus datos",
        "fr": "Tes données",
        "km": "ទិន្នន័យរបស់អ្នក",
        "lv": "Tavi dati",
        "nl": "Uw gegevens",
        "pl": "Twoje dane",
        "pt": "Seus dados",
        "sk": "Informácie o spracovaní tvojich údajov",
        "th": "ประกาศชี้แจ้งเรื่องการเก็บรวบรวมข้อมูล"
    },
    "already-opted-out": {
        "de": "Bereits abgemeldet",
        "en": "Already opted out",
        "es": "Ya te has excluido",
        "fr": "Déjà retiré",
        "km": "បានបោះបង់ចេញរួចហើយ",
        "lv": "Jau atteicies",
        "nl": "Al afgemeld",
        "pl": "Już zrezygnowano",
        "pt": "Já desistiu",
        "sk": "Už odhlásený/á",
        "th": "ได้ยกเลิกแล้ว"
    },
    "unable-to-update-tag": {
        "de": "Schlagwort kann nicht aktualisiert werden",
        "en": "Unable to Update Tag",
        "es": "No se puede actualizar la etiqueta",
        "fr": "Impossible de mettre à jour l'étiquette",
        "km": "មិនអាចធ្វើបច្ចុប្បន្នភាពស្លាកបានទេ",
        "lv": "Nevar atjaunināt tagu",
        "nl": "Kan label niet bijwerken",
        "pl": "Nie można zaktualizować tagu",
        "pt": "Não foi possível atualizar a etiqueta",
        "sk": "Nie je možné aktualizovať tag",
        "th": "ไม่สามารถอัปเดตแท็กนี้ได้ โปรดลองอีกครั้ง"
    },
    "total": {
        "de": "Gesamt",
        "en": "Total",
        "es": "Total",
        "fr": "Total",
        "km": "សរុប",
        "lv": "Kopā",
        "nl": "Totaal",
        "pl": "Razem",
        "pt": "Total",
        "sk": "Celkom",
        "th": "ผลรวม"
    },
    "created-by": {
        "de": "Erstellt von",
        "en": "Created by",
        "es": "Creado por",
        "fr": "Créé par",
        "km": "បង្កើតដោយ",
        "lv": "Izveidoja",
        "nl": "Gemaakt door",
        "pl": "Utworzono przez",
        "pt": "Criado por",
        "sk": "Vytvoril",
        "th": "พัฒนาโดย"
    },
    "dashboard": {
        "de": "DASHBOARD",
        "en": "DASHBOARD",
        "es": "PANEL",
        "fr": "TABLEAU DE BORD",
        "km": "ផ្ទាំងគ្រប់គ្រង",
        "lv": "INFORMĀCIJAS PANELIS",
        "nl": "DASHBOARD",
        "pl": "PANEL STEROWANIA",
        "pt": "PAINEL",
        "sk": "PREHĽAD",
        "th": "แดชบอร์ด"
    },
    "tag": {
        "de": "Tag hinzufügen",
        "en": "Tag",
        "es": "Etiquetar",
        "fr": "Étiqueter",
        "km": "ដាក់ស្លាក",
        "lv": "Pievienot atzīmi",
        "nl": "Tag toevoegen",
        "pl": "Oznacz tagiem",
        "pt": "Etiquetar",
        "sk": "Pridať značku",
        "th": "ติดแท็ก"
    },
    "account-activity": {
        "de": "Kontoaktivität",
        "en": "Account activity",
        "es": "Actividad de la cuenta",
        "fr": "Activité du compte",
        "km": "សកម្មភាពគណនី",
        "lv": "Konta darbība",
        "nl": "Accountactiviteit",
        "pl": "Aktywność konta",
        "pt": "Atividade da conta",
        "sk": "Aktivita účtu",
        "th": "กิจกรรมบัญชี"
    },
    "account-created": {
        "de": "Konto erstellt",
        "en": "Account created",
        "es": "Cuenta creada",
        "fr": "Compte créé",
        "km": "បានបង្កើតគណនី",
        "lv": "Konts izveidots",
        "nl": "Account aangemaakt",
        "pl": "Konto utworzone",
        "pt": "Conta criada",
        "sk": "Účet vytvorený",
        "th": "สร้างบัญชีแล้ว"
    },
    "add-at-least-one-content-item-to-continue": {
        "de": "Fügen Sie mindestens ein Inhaltselement hinzu, um fortzufahren.",
        "en": "Add at least one content item to continue.",
        "es": "Agregue al menos un elemento de contenido para continuar.",
        "fr": "Ajoutez au moins un élément de contenu pour continuer.",
        "km": "បន្ថែមធាតុមាតិកាយ៉ាងហោចណាស់មួយដើម្បីបន្ត។",
        "lv": "Lai turpinātu, pievienojiet vismaz vienu satura vienumu.",
        "nl": "Voeg ten minste één inhoudsitem toe om door te gaan.",
        "pl": "Dodaj co najmniej jeden element treści, aby kontynuować.",
        "pt": "Adicione pelo menos um item de conteúdo para continuar.",
        "sk": "Ak chcete pokračovať, pridajte aspoň jednu položku obsahu.",
        "th": "เพิ่มเนื้อหาอย่างน้อยหนึ่งรายการเพื่อดำเนินการต่อ"
    },
    "add-feedback": {
        "de": "Feedback hinzufügen",
        "en": "Add Feedback",
        "es": "Agregar comentarios",
        "fr": "Ajouter un commentaire",
        "km": "បន្ថែមមតិកែលម្អ",
        "lv": "Pievienot atsauksmes",
        "nl": "Feedback toevoegen",
        "pl": "Dodaj opinię",
        "pt": "Adicionar comentários",
        "sk": "Pridať spätnú väzbu",
        "th": "เพิ่มข้อเสนอแนะ"
    },
    "add-row": {
        "de": "Zeile hinzufügen",
        "en": "Add Row",
        "es": "Agregar fila",
        "fr": "Ajouter une ligne",
        "km": "បន្ថែមជួរដេក",
        "lv": "Pievienot rindu",
        "nl": "Rij toevoegen",
        "pl": "Dodaj wiersz",
        "pt": "Adicionar linha",
        "sk": "Pridať riadok",
        "th": "เพิ่มแถว"
    },
    "add-students-to-group": {
        "de": "Schüler zur Gruppe hinzufügen",
        "en": "Add students to group",
        "es": "Agregar estudiantes al grupo",
        "fr": "Ajouter des élèves au groupe",
        "km": "បន្ថែមសិស្សទៅក្រុម",
        "lv": "Pievienojiet skolēnus grupai",
        "nl": "Voeg leerlingen toe aan de groep",
        "pl": "Dodaj uczniów do grupy",
        "pt": "Adicionar alunos ao grupo",
        "sk": "Pridajte žiakov do skupiny",
        "th": "เพิ่มนักเรียนเข้ากลุ่ม"
    },
    "add-to": {
        "de": "Hinzufügen zu",
        "en": "Add To",
        "es": "Añadir a",
        "fr": "Ajouter à",
        "km": "បន្ថែមទៅ",
        "lv": "Pievienot",
        "nl": "Toevoegen aan",
        "pl": "Dodaj do",
        "pt": "Adicionar a",
        "sk": "Pridať do",
        "th": "เพิ่มไปยัง"
    },
    "add-to-assignment-choice-subtitle": {
        "de": "Wählen Sie aus, wie Sie {name} zu einer Aufgabe hinzufügen möchten.",
        "en": "Choose how to add {name} to an assignment.",
        "es": "Elija cómo desea agregar {name} a una tarea.",
        "fr": "Choisissez comment ajouter {name} à un devoir.",
        "km": "ជ្រើសរើសរបៀបបន្ថែម {name} ទៅកិច្ចការ។",
        "lv": "Izvēlieties, kā uzdevumam pievienot {name}.",
        "nl": "Kies hoe je {name} aan een opdracht wilt toevoegen.",
        "pl": "Wybierz, jak dodać {name} do zadania.",
        "pt": "Escolha como deseja adicionar {name} a uma tarefa.",
        "sk": "Vyberte, ako chcete pridať {name} k úlohe.",
        "th": "เลือกวิธีที่ต้องการเพิ่ม {name} ไปยังงานที่มอบหมาย"
    },
    "add-to-existing-assignment": {
        "de": "Zu einer vorhandenen Aufgabe hinzufügen",
        "en": "Add to existing assignment",
        "es": "Agregar a una tarea existente",
        "fr": "Ajouter à un devoir existant",
        "km": "បន្ថែមទៅកិច្ចការដែលមានស្រាប់",
        "lv": "Pievienot esošam uzdevumam",
        "nl": "Voeg toe aan een bestaande opdracht",
        "pl": "Dodaj do istniejącego zadania",
        "pt": "Adicionar a uma tarefa existente",
        "sk": "Pridať k existujúcej úlohe",
        "th": "เพิ่มไปยังงานที่มอบหมายที่มีอยู่"
    },
    "add-to-existing-assignment-subtitle": {
        "de": "Wählen Sie eine Aufgabe aus, zu der Sie {name} hinzufügen möchten.",
        "en": "Add {name} to a one of the assignments listed below.",
        "es": "Elija una tarea a la que desee agregar {name}.",
        "fr": "Choisissez un devoir auquel ajouter {name}.",
        "km": "ជ្រើសរើសកិច្ចការដែលអ្នកចង់បន្ថែម {name}។",
        "lv": "Izvēlieties uzdevumu, kuram vēlaties pievienot {name}.",
        "nl": "Kies een opdracht waaraan je {name} wilt toevoegen.",
        "pl": "Wybierz zadanie, do którego chcesz dodać {name}.",
        "pt": "Escolha uma tarefa à qual deseja adicionar {name}.",
        "sk": "Vyberte úlohu, ku ktorej chcete pridať {name}.",
        "th": "เลือกงานที่มอบหมายที่ต้องการเพิ่ม {name}"
    },
    "add-to-existing-assignment-title": {
        "de": "Zu einer vorhandenen Aufgabe hinzufügen",
        "en": "Add to an existing assignment",
        "es": "Agregar a una tarea existente",
        "fr": "Ajouter à un devoir existant",
        "km": "បន្ថែមទៅកិច្ចការដែលមានស្រាប់",
        "lv": "Pievienot esošam uzdevumam",
        "nl": "Voeg toe aan een bestaande opdracht",
        "pl": "Dodaj do istniejącego zadania",
        "pt": "Adicionar a uma tarefa existente",
        "sk": "Pridať k existujúcej úlohe",
        "th": "เพิ่มไปยังงานที่มอบหมายที่มีอยู่"
    },
    "add-to-groups": {
        "de": "Zu Gruppen hinzufügen",
        "en": "Add To Groups",
        "es": "Agregar a grupos",
        "fr": "Ajouter aux groupes",
        "km": "បន្ថែមទៅក្រុម",
        "lv": "Pievienot grupām",
        "nl": "Toevoegen aan groepen",
        "pl": "Dodaj do grup",
        "pt": "Adicionar aos grupos",
        "sk": "Pridať do skupín",
        "th": "เพิ่มไปยังกลุ่ม"
    },
    "add-to-selected-assignment": {
        "de": "Zur ausgewählten Aufgabe hinzufügen",
        "en": "Add to selection",
        "es": "Agregar a la tarea seleccionada",
        "fr": "Ajouter au devoir sélectionné",
        "km": "បន្ថែមទៅកិច្ចការដែលបានជ្រើស",
        "lv": "Pievienot atlasītajam uzdevumam",
        "nl": "Voeg toe aan de geselecteerde opdracht",
        "pl": "Dodaj do wybranego zadania",
        "pt": "Adicionar à tarefa selecionada",
        "sk": "Pridať k vybranej úlohe",
        "th": "เพิ่มไปยังงานที่มอบหมายที่เลือก"
    },
    "add-to-sequence-subtitle": {
        "de": "Fügen Sie dieses Element zu einer vorhandenen Sequenz hinzu",
        "en": "Add this item to an existing sequence",
        "es": "Agregar este elemento a una secuencia existente",
        "fr": "Ajouter cet élément à une séquence existante",
        "km": "បន្ថែមធាតុនេះទៅលំដាប់ដែលមានស្រាប់",
        "lv": "Pievienojiet šo vienumu esošai secībai",
        "nl": "Voeg dit item toe aan een bestaande reeks",
        "pl": "Dodaj ten element do istniejącej sekwencji",
        "pt": "Adicione este item a uma sequência existente",
        "sk": "Pridajte túto položku do existujúcej sekvencie",
        "th": "เพิ่มรายการนี้ไปยังลำดับที่มีอยู่"
    },
    "all-selected-already-in-assignment": {
        "de": "Alle ausgewählten Elemente befinden sich bereits in dieser Aufgabe",
        "en": "All selected items are already in this assignment",
        "es": "Todos los elementos seleccionados ya están en esta tarea.",
        "fr": "Tous les éléments sélectionnés sont déjà dans ce devoir",
        "km": "ធាតុដែលបានជ្រើសទាំងអស់មាននៅក្នុងកិច្ចការនេះរួចហើយ",
        "lv": "Visi atlasītie vienumi jau ir iekļauti šajā uzdevumā",
        "nl": "Alle geselecteerde items zitten al in deze opdracht",
        "pl": "Wszystkie wybrane elementy są już w tym zadaniu",
        "pt": "Todos os itens selecionados já estão nesta tarefa",
        "sk": "Všetky vybraté položky sú už v tejto úlohe",
        "th": "รายการที่เลือกทั้งหมดอยู่ในงานที่มอบหมายนี้แล้ว"
    },
    "all-selected-already-in-sequence": {
        "de": "Alle ausgewählten Elemente befinden sich bereits in dieser Sequenz",
        "en": "All selected items are already in this sequence",
        "es": "Todos los elementos seleccionados ya están en esta secuencia",
        "fr": "Tous les éléments sélectionnés sont déjà dans cette séquence",
        "km": "ធាតុដែលបានជ្រើសទាំងអស់មាននៅក្នុងលំដាប់នេះរួចហើយ",
        "lv": "Visi atlasītie vienumi jau atrodas šajā secībā",
        "nl": "Alle geselecteerde items staan al in deze reeks",
        "pl": "Wszystkie wybrane elementy są już w tej sekwencji",
        "pt": "Todos os itens selecionados já estão nesta sequência",
        "sk": "Všetky vybrané položky sú už v tejto sekvencii",
        "th": "รายการที่เลือกทั้งหมดอยู่ในลำดับนี้แล้ว"
    },
    "already-exists-continue": {
        "de": "existiert bereits. Trotzdem weitermachen?",
        "en": "already exists. Continue anyway?",
        "es": "ya existe. ¿Continuar de todos modos?",
        "fr": "existe déjà. Continuer quand même ?",
        "km": "មានរួចហើយ។ បន្តទេ?",
        "lv": "jau pastāv. Vai tomēr turpināt?",
        "nl": "bestaat al. Toch doorgaan?",
        "pl": "już istnieje. Kontynuować mimo to?",
        "pt": "já existe. Continuar mesmo assim?",
        "sk": "už existuje. Chcete napriek tomu pokračovať?",
        "th": "มีอยู่แล้ว ดำเนินการต่อหรือไม่?"
    },
    "already-in-assignment": {
        "de": "bereits in der Aufgabe",
        "en": "already in assignment",
        "es": "ya está en la tarea",
        "fr": "déjà dans le devoir",
        "km": "មាននៅក្នុងកិច្ចការរួចហើយ",
        "lv": "jau ir uzdevumā",
        "nl": "al in opdracht",
        "pl": "już w zadaniu",
        "pt": "já está na tarefa",
        "sk": "už je v úlohe",
        "th": "อยู่ในงานที่มอบหมายแล้ว"
    },
    "already-in-sequence": {
        "de": "Dieses Element befindet sich bereits in der Sequenz",
        "en": "This item is already in the sequence",
        "es": "Este elemento ya está en la secuencia.",
        "fr": "Cet élément est déjà dans la séquence",
        "km": "ធាតុនេះមាននៅក្នុងលំដាប់រួចហើយ",
        "lv": "Šis vienums jau atrodas secībā",
        "nl": "Dit item staat al in de reeks",
        "pl": "Ten element jest już w sekwencji",
        "pt": "Este item já está na sequência",
        "sk": "Táto položka už je v sekvencii",
        "th": "รายการนี้อยู่ในลำดับแล้ว"
    },
    "app-specific-dashboard": {
        "de": "App-spezifisches Dashboard",
        "en": "App-specific dashboard",
        "es": "Panel de control específico de la aplicación",
        "fr": "Tableau de bord spécifique à l’application",
        "km": "ផ្ទាំងគ្រប់គ្រងជាក់លាក់តាមកម្មវិធី",
        "lv": "Lietotnei specifisks informācijas panelis",
        "nl": "App-specifiek dashboard",
        "pl": "Panel specyficzny dla aplikacji",
        "pt": "Painel específico do aplicativo",
        "sk": "Informačný panel špecifický pre aplikáciu",
        "th": "แดชบอร์ดเฉพาะแอป"
    },
    "applying-key": {
        "de": "Anwenden des Schlüssels",
        "en": "Applying key",
        "es": "Aplicar clave",
        "fr": "Application de la clé…",
        "km": "កំពុងអនុវត្តសោ…",
        "lv": "Atslēgas pielietošana",
        "nl": "Sleutel toepassen",
        "pl": "Stosowanie klucza…",
        "pt": "Aplicando Chave",
        "sk": "Aplikuje sa kľúč",
        "th": "กำลังใช้คีย์…"
    },
    "archive-assignment-confirm-intro": {
        "de": "Wählen Sie aus, wie „{name}“ archiviert werden soll. Nichts wird dauerhaft gelöscht – Sie können es später aus archivierten Aufgaben wiederherstellen.",
        "en": "Choose how to archive \"{name}\". Nothing is permanently deleted — it can be restored later by clicking ‘Show archived’ and reselecting the assignment.",
        "es": "Elija cómo archivar \"{name}\". Nada se elimina permanentemente; puedes restaurarlo más tarde desde las tareas archivadas.",
        "fr": "Choisissez comment archiver « {name} ». Rien n’est supprimé définitivement — vous pourrez le restaurer plus tard depuis les devoirs archivés.",
        "km": "ជ្រើសរើសរបៀបទុកជាឯកសារ \"{name}\"។ គ្មានអ្វីត្រូវបានលុបជាអចិន្ត្រៃយ៍ទេ — អ្នកអាចស្តារឡើងវិញពីកិច្ចការដែលបានទុកជាឯកសារនៅពេលក្រោយ។",
        "lv": "Izvēlieties, kā arhivēt \"{name}\". Nekas netiek neatgriezeniski izdzēsts — varat to vēlāk atjaunot no arhivētajiem uzdevumiem.",
        "nl": "Kies hoe u \"{name}\" wilt archiveren. Niets wordt permanent verwijderd. Je kunt het later herstellen vanuit gearchiveerde opdrachten.",
        "pl": "Wybierz sposób archiwizacji „{name}”. Nic nie zostanie trwale usunięte — możesz później przywrócić to z zarchiwizowanych zadań.",
        "pt": "Escolha como arquivar \"{name}\". Nada é excluído permanentemente – você pode restaurá-lo mais tarde a partir de tarefas arquivadas.",
        "sk": "Vyberte spôsob archivácie „{name}“. Nič sa natrvalo neodstráni – môžete to neskôr obnoviť z archivovaných úloh.",
        "th": "เลือกวิธีเก็บถาวร \"{name}\" ไม่มีการลบถาวร — คุณสามารถกู้คืนได้ในภายหลังจากงานที่มอบหมายที่เก็บถาวร"
    },
    "archive-assignment-confirm-title": {
        "de": "Diese Aufgabe archivieren?",
        "en": "Archive this assignment?",
        "es": "¿Archivar esta tarea?",
        "fr": "Archiver ce devoir ?",
        "km": "ទុកកិច្ចការនេះជាឯកសារ?",
        "lv": "Vai arhivēt šo uzdevumu?",
        "nl": "Deze opdracht archiveren?",
        "pl": "Zarchiwizować to zadanie?",
        "pt": "Arquivar esta tarefa?",
        "sk": "Archivovať túto úlohu?",
        "th": "เก็บถาวรงานที่มอบหมายนี้หรือไม่?"
    },
    "archive-assignment-for-all-description": {
        "de": "Blendet diese Aufgabe aus Ihrer Liste aus und entfernt sie aus allen zugewiesenen Gruppen ({groups}). Die Schüler sehen diese Aufgabe nicht mehr.",
        "en": "Removes this assignment from 'My Assignments' and from all assigned groups ({groups}). Students will no longer see it in their accounts.",
        "es": "Oculta esta tarea de tu lista y la elimina de todos los grupos asignados ({groups}). Los estudiantes ya no verán esta tarea.",
        "fr": "Masque ce devoir de votre liste et le retire de tous les groupes assignés ({groups}). Les élèves ne le verront plus.",
        "km": "លាក់កិច្ចការនេះពីបញ្ជីរបស់អ្នក និងដកចេញពីក្រុមដែលបានកំណត់ទាំងអស់ ({groups})។ សិស្សនឹងមិនឃើញវាទៀតទេ។",
        "lv": "Paslēpj šo uzdevumu jūsu sarakstā un noņem no visām piešķirtajām grupām ({groups}). Skolēni vairs neredzēs šo uzdevumu.",
        "nl": "Verbergt deze opdracht uit je lijst en verwijdert deze uit alle toegewezen groepen ({groups}). Leerlingen zien deze opdracht niet meer.",
        "pl": "Ukrywa to zadanie z Twojej listy i usuwa je ze wszystkich przypisanych grup ({groups}). Uczniowie nie będą go już widzieć.",
        "pt": "Oculta esta tarefa da sua lista e a remove de todos os grupos atribuídos ({groups}). Os alunos não verão mais esta tarefa.",
        "sk": "Skryje túto úlohu vo vašom zozname a odstráni ju zo všetkých priradených skupín ({groups}). Toto zadanie už žiaci neuvidia.",
        "th": "ซ่อนงานที่มอบหมายนี้จากรายการของคุณและนำออกจากกลุ่มที่มอบหมายทั้งหมด ({groups}) นักเรียนจะไม่เห็นอีกต่อไป"
    },
    "archive-assignment-for-all-description-draft": {
        "de": "Blendet diese Aufgabe aus Ihrer Liste aus. Es sind keine Gruppen zugewiesen, daher hat dies denselben Effekt wie „Für mich archivieren“.",
        "en": "Removes this assignment from 'My Assignments' for this teacher account. No groups are assigned, so this has the same effect as selecting 'Archive for me'.",
        "es": "Oculta esta tarea de tu lista. No hay grupos asignados, por lo que tiene el mismo efecto que «Archivar para mí».",
        "fr": "Masque ce devoir de votre liste. Aucun groupe n’est assigné, donc l’effet est le même que « archiver pour moi ».",
        "km": "លាក់កិច្ចការនេះពីបញ្ជីរបស់អ្នក។ មិនមានក្រុមណាត្រូវបានកំណត់ទេ ដូច្នេះមានប្រសិទ្ធភាពដូចការទុកជាឯកសារសម្រាប់ខ្ញុំ។",
        "lv": "Paslēpj šo uzdevumu jūsu sarakstā. Neviena grupa nav piešķirta, tāpēc rezultāts ir tāds pats kā arhivējot tikai sev.",
        "nl": "Verbergt deze opdracht in uw lijst. Er zijn geen groepen toegewezen, dus dit heeft hetzelfde effect als ‘Voor mij archiveren’.",
        "pl": "Ukrywa to zadanie z Twojej listy. Nie przypisano żadnych grup, więc efekt jest taki sam jak „archiwizuj dla mnie”.",
        "pt": "Oculta esta tarefa da sua lista. Nenhum grupo está atribuído, portanto, tem o mesmo efeito que “Arquivar para mim”.",
        "sk": "Skryje túto úlohu vo vašom zozname. Nie sú priradené žiadne skupiny, takže výsledok je rovnaký ako pri možnosti „Archivovať pre mňa“.",
        "th": "ซ่อนงานที่มอบหมายนี้จากรายการของคุณ ไม่มีกลุ่มที่มอบหมาย จึงมีผลเช่นเดียวกับการเก็บถาวรสำหรับฉัน"
    },
    "archive-assignment-for-all-label": {
        "de": "Für alle archivieren",
        "en": "Archive for all",
        "es": "Archivar para todos",
        "fr": "Archiver pour tous",
        "km": "ទុកជាឯកសារសម្រាប់ទាំងអស់",
        "lv": "Arhivēt visiem",
        "nl": "Voor iedereen archiveren",
        "pl": "Archiwizuj dla wszystkich",
        "pt": "Arquivar para todos",
        "sk": "Archivovať pre všetkých",
        "th": "เก็บถาวรสำหรับทุกคน"
    },
    "archive-assignment-for-me-description": {
        "de": "Blendet diese Aufgabe nur aus Ihrer Liste aus. Schüler in den zugewiesenen Gruppen ({groups}) können sie weiterhin sehen und bearbeiten, bis Sie diese Gruppen aus der Aufgabe entfernen.",
        "en": "This assignment will be removed from 'My Assignments' for this teacher account only. Students in assigned groups ({groups}) can still see and work on it until you remove those groups from the assignment.",
        "es": "Oculta esta tarea solo de tu lista. Los estudiantes de los grupos asignados ({groups}) podrán seguir viéndola y trabajando en ella hasta que elimines esos grupos de la tarea.",
        "fr": "Masque ce devoir de votre liste uniquement. Les élèves des groupes assignés ({groups}) pourront encore le voir et y travailler jusqu’à ce que vous retiriez ces groupes du devoir.",
        "km": "លាក់កិច្ចការនេះពីបញ្ជីរបស់អ្នកតែប៉ុណ្ណោះ។ សិស្សក្នុងក្រុមដែលបានកំណត់ ({groups}) នៅតែអាចមើល និងធ្វើការលើវា រហូតដល់អ្នកដកក្រុមទាំងនោះចេញពីកិច្ចការ។",
        "lv": "Paslēpj šo uzdevumu tikai jūsu sarakstā. Skolēni piešķirtajās grupās ({groups}) joprojām varēs to redzēt un pildīt, līdz noņemsiet šīs grupas no uzdevuma.",
        "nl": "Verbergt deze opdracht alleen in uw lijst. Leerlingen in toegewezen groepen ({groups}) kunnen de opdracht nog steeds zien en eraan werken totdat u die groepen uit de opdracht verwijdert.",
        "pl": "Ukrywa to zadanie tylko z Twojej listy. Uczniowie w przypisanych grupach ({groups}) nadal będą je widzieć i mogli nad nim pracować, dopóki nie usuniesz tych grup z zadania.",
        "pt": "Oculta esta tarefa apenas da sua lista. Os alunos nos grupos atribuídos ({groups}) ainda poderão vê-la e realizá-la até que você remova esses grupos da tarefa.",
        "sk": "Skryje túto úlohu iba vo vašom zozname. Žiaci v priradených skupinách ({groups}) ju budú môcť naďalej vidieť a riešiť, kým tieto skupiny z úlohy neodstránite.",
        "th": "ซ่อนงานที่มอบหมายนี้จากรายการของคุณเท่านั้น นักเรียนในกลุ่มที่มอบหมาย ({groups}) ยังเห็นและทำได้จนกว่าคุณจะนำกลุ่มเหล่านั้นออกจากงาน"
    },
    "archive-assignment-for-me-description-draft": {
        "de": "Blendet diese Aufgabe aus Ihrer aktiven Liste aus. Sie ist für keine Gruppe veröffentlicht, daher sind Schüler nicht betroffen.",
        "en": "Removes this assignment from 'My Assignments' for this teacher account. It is not yet published to any groups, so students cannot view it.",
        "es": "Oculta esta tarea de tu lista activa. No se publica en ningún grupo, por lo que los estudiantes no se ven afectados.",
        "fr": "Masque ce devoir de votre liste active. Il n’est publié pour aucun groupe, donc les élèves ne sont pas concernés.",
        "km": "លាក់កិច្ចការនេះពីបញ្ជីសកម្ម។ វាមិនត្រូវបានផ្សព្វផ្សាយទៅក្រុមណាទេ ដូច្នេះសិស្សមិនរងផលប៉ះពាល់។",
        "lv": "Paslēpj šo uzdevumu jūsu aktīvajā sarakstā. Tas nav publicēts nevienai grupai, tāpēc skolēni netiek ietekmēti.",
        "nl": "Verbergt deze opdracht in uw actieve lijst. De opdracht is niet voor groepen gepubliceerd, dus leerlingen ondervinden hiervan geen gevolgen.",
        "pl": "Ukrywa to zadanie z aktywnej listy. Nie jest opublikowane dla żadnych grup, więc uczniowie nie są dotknięci.",
        "pt": "Oculta esta tarefa da sua lista ativa. Não é publicado em nenhum grupo, portanto os alunos não são afetados.",
        "sk": "Skryje túto úlohu vo vašom aktívnom zozname. Nie je zverejnená pre žiadnu skupinu, takže žiakov sa to netýka.",
        "th": "ซ่อนงานที่มอบหมายนี้จากรายการที่ใช้งาน ไม่ได้เผยแพร่ไปยังกลุ่มใด นักเรียนจึงไม่ได้รับผลกระทบ"
    },
    "archive-assignment-for-me-label": {
        "de": "Für mich archivieren",
        "en": "Archive for me",
        "es": "Archivar para mí",
        "fr": "Archiver pour moi",
        "km": "ទុកជាឯកសារសម្រាប់ខ្ញុំ",
        "lv": "Arhivēt tikai sev",
        "nl": "Voor mij archiveren",
        "pl": "Archiwizuj dla mnie",
        "pt": "Arquivar para mim",
        "sk": "Archivovať pre mňa",
        "th": "เก็บถาวรสำหรับฉัน"
    },
    "archive-assignment-n-groups": {
        "de": "{count} Gruppen",
        "en": "{count} groups",
        "es": "{count} grupos",
        "fr": "{count} groupes",
        "km": "{count} ក្រុម",
        "lv": "{count} grupas",
        "nl": "{count} groepen",
        "pl": "{count} grup(y)",
        "pt": "{count} grupos",
        "sk": "{count} skupín",
        "th": "{count} กลุ่ม"
    },
    "archive-assignment-one-group": {
        "de": "1 Gruppe",
        "en": "1 group",
        "es": "1 grupo",
        "fr": "1 groupe",
        "km": "1 ក្រុម",
        "lv": "1 grupa",
        "nl": "1 groep",
        "pl": "1 grupa",
        "pt": "1 grupo",
        "sk": "1 skupina",
        "th": "1 กลุ่ม"
    },
    "archive-group-confirm-description": {
        "de": "Diese Gruppe hat {count} Schüler. Durch die Archivierung wird die Gruppe aus Ihrer aktiven Liste ausgeblendet. Die Schüler bleiben in der Gruppe und können die dort veröffentlichten Aufgaben weiterhin sehen, bis Sie die Zuweisung zur Gruppe aufheben. Sie können die Gruppe später aus archivierten Gruppen wiederherstellen.",
        "en": "Archiving this group will remove it from the 'Active' groups list. It can be restored by clicking ‘Show archived’ and reselecting the group.",
        "es": "Este grupo tiene {count} estudiantes. Archivar oculta el grupo de su lista activa. Los estudiantes permanecen en el grupo y aún pueden ver las tareas publicadas en él hasta que cancele la asignación del grupo. Puede restaurar el grupo más tarde desde grupos archivados.",
        "fr": "Ce groupe compte {count} élève(s). L’archivage le masque de votre liste active. Les élèves restent dans le groupe et peuvent encore voir les devoirs publiés pour ce groupe jusqu’à ce que vous le retiriez. Vous pourrez restaurer le groupe plus tard depuis les groupes archivés.",
        "km": "ក្រុមនេះមានសិស្ស {count} នាក់។ ការទុកជាឯកសារលាក់វាពីបញ្ជីសកម្ម។ សិស្សនៅតែស្ថិតក្នុងក្រុម និងអាចមើលកិច្ចការដែលបានផ្សព្វផ្សាយទៅវា រហូតដល់អ្នកដកក្រុម។ អ្នកអាចស្តារក្រុមពីក្រុមដែលបានទុកជាឯកសារនៅពេលក្រោយ។",
        "lv": "Šajā grupā ir {count} skolēns(i). Arhivējot, grupa tiek paslēpta jūsu aktīvajā sarakstā. Skolēni paliek grupā un joprojām var redzēt tajā publicētos uzdevumus, līdz atceļat grupas piešķiršanu. Varat atjaunot grupu vēlāk no arhivētām grupām.",
        "nl": "Deze groep heeft {count} leerling(en). Door te archiveren wordt de groep verborgen voor uw actieve lijst. Leerlingen blijven in de groep en kunnen nog steeds de gepubliceerde opdrachten zien totdat u de toewijzing van de groep ongedaan maakt. U kunt de groep later herstellen vanuit gearchiveerde groepen.",
        "pl": "Ta grupa ma {count} ucznia/uczniów. Archiwizacja ukrywa ją z aktywnej listy. Uczniowie pozostają w grupie i mogą nadal widzieć zadania opublikowane dla niej, dopóki jej nie usuniesz. Możesz później przywrócić grupę z zarchiwizowanych grup.",
        "pt": "Este grupo tem {count} aluno(s). O arquivamento oculta o grupo da sua lista ativa. Os alunos permanecem no grupo e ainda podem ver as tarefas publicadas nele até você cancelar a atribuição do grupo. Você pode restaurar o grupo posteriormente a partir de grupos arquivados.",
        "sk": "Táto skupina má {count} žiakov. Archivácia skryje skupinu z vášho aktívneho zoznamu. Žiaci zostávajú v skupine a stále môžu vidieť úlohy, ktoré sú v nej zverejnené, kým nezrušíte priradenie skupiny. Skupinu môžete neskôr obnoviť z archivovaných skupín.",
        "th": "กลุ่มนี้มีนักเรียน {count} คน การเก็บถาวรจะซ่อนจากรายการที่ใช้งาน นักเรียนยังอยู่ในกลุ่มและอาจยังเห็นงานที่เผยแพร่ไปยังกลุ่มจนกว่าคุณจะนำกลุ่มออก คุณสามารถกู้คืนกลุ่มได้ในภายหลังจากกลุ่มที่เก็บถาวร"
    },
    "archive-group-confirm-title": {
        "de": "Gruppe „{name}“ archivieren?",
        "en": "Archive group \"{name}\"?",
        "es": "¿Archivar el grupo \"{name}\"?",
        "fr": "Archiver le groupe « {name} » ?",
        "km": "ទុកក្រុម \"{name}\" ជាឯកសារ?",
        "lv": "Vai arhivēt grupu \"{name}\"?",
        "nl": "Groep \"{name}\" archiveren?",
        "pl": "Zarchiwizować grupę „{name}”?",
        "pt": "Arquivar o grupo \"{name}\"?",
        "sk": "Archivovať skupinu „{name}“?",
        "th": "เก็บถาวรกลุ่ม \"{name}\" หรือไม่?"
    },
    "archive-sequence": {
        "de": "Sequenz archivieren",
        "en": "Archive this sequence?",
        "es": "Archivar secuencia",
        "fr": "Archiver la séquence",
        "km": "ទុកលំដាប់ជាឯកសារ",
        "lv": "Arhivēt secību",
        "nl": "Reeks archiveren",
        "pl": "Archiwizuj sekwencję",
        "pt": "Arquivar sequência",
        "sk": "Archivovať sekvenciu",
        "th": "เก็บถาวรลำดับ"
    },
    "archive-sequence-confirm": {
        "de": "Diese Sequenz archivieren? Sie wird aus Ihren aktiven Sequenzen entfernt. Sie können sie später wiederherstellen.",
        "en": "Archive this sequence? It will be removed from 'My Sequences' and can be restored later.",
        "es": "¿Archivar esta secuencia? Se eliminará de tus secuencias activas. Puedes restaurarla más tarde.",
        "fr": "Archiver cette séquence ? Elle sera retirée de vos séquences actives. Vous pourrez la restaurer plus tard.",
        "km": "ទុកលំដាប់នេះជាឯកសារ? វានឹងត្រូវបានដកចេញពីលំដាប់សកម្ម។ អ្នកអាចស្តារវានៅពេលក្រោយ។",
        "lv": "Vai arhivēt šo secību? Tā tiks noņemta no jūsu aktīvajām secībām. Varat to atjaunot vēlāk.",
        "nl": "Deze reeks archiveren? De reeks wordt uit uw actieve reeksen verwijderd. U kunt deze later herstellen.",
        "pl": "Zarchiwizować tę sekwencję? Zostanie usunięta z aktywnych sekwencji. Możesz ją później przywrócić.",
        "pt": "Arquivar esta sequência? Ela será removida das suas sequências ativas. Você poderá restaurá-la mais tarde.",
        "sk": "Archivovať túto sekvenciu? Odstráni sa z vašich aktívnych sekvencií. Neskôr ju môžete obnoviť.",
        "th": "เก็บถาวรลำดับนี้หรือไม่? จะถูกลบออกจากลำดับที่ใช้งาน คุณสามารถกู้คืนได้ในภายหลัง"
    },
    "assessment": {
        "de": "Bewertung",
        "en": "Assessment",
        "es": "Evaluación",
        "fr": "Évaluation",
        "km": "ការវាយតម្លៃ",
        "lv": "Novērtējums",
        "nl": "Beoordeling",
        "pl": "Ocenianie",
        "pt": "Avaliação",
        "sk": "Hodnotenie",
        "th": "การประเมิน"
    },
    "assign-to-groups-optional-hint": {
        "de": "Sie können Kurse jetzt zuweisen oder sie später über die Aufgabenseite hinzufügen.",
        "en": "Assign classes now or add them later from the assignments page.",
        "es": "Puede asignar clases ahora o agregarlas más tarde desde la página de tareas.",
        "fr": "Vous pouvez assigner des classes maintenant ou les ajouter plus tard depuis la page des devoirs.",
        "km": "អ្នកអាចកំណត់ថ្នាក់ឥឡូវនេះ ឬបន្ថែមពួកវាពីទំព័រកិច្ចការនៅពេលក្រោយ។",
        "lv": "Varat piešķirt nodarbības tagad vai pievienot tās vēlāk no uzdevumu lapas.",
        "nl": "Je kunt nu klassen toewijzen of ze later toevoegen via de opdrachtenpagina.",
        "pl": "Możesz przypisać klasy teraz lub dodać je później ze strony zadań.",
        "pt": "Você pode atribuir aulas agora ou adicioná-las mais tarde na página de tarefas.",
        "sk": "Triedy môžete priradiť teraz alebo ich môžete pridať neskôr na stránke úloh.",
        "th": "คุณสามารถมอบหมายชั้นเรียนตอนนี้ หรือเพิ่มทีหลังจากหน้างานที่มอบหมาย"
    },
    "assignment-status": {
        "de": "Aufgabenstatus",
        "en": "Assignment Status",
        "es": "Estado de la tarea",
        "fr": "Statut du devoir",
        "km": "ស្ថានភាពកិច្ចការ",
        "lv": "Uzdevuma statuss",
        "nl": "Toewijzingsstatus",
        "pl": "Status zadania",
        "pt": "Status da tarefa",
        "sk": "Stav úlohy",
        "th": "สถานะงานที่มอบหมาย"
    },
    "assignment-title-required-for-draft": {
        "de": "Geben Sie einen Aufgabentitel ein, um einen Entwurf zu speichern.",
        "en": "Enter an assignment title to save a draft.",
        "es": "Ingrese el título de una tarea para guardar un borrador.",
        "fr": "Saisissez un titre de devoir pour enregistrer un brouillon.",
        "km": "បញ្ចូលចំណងជើងកិច្ចការដើម្បីរក្សាទុកសេចក្តីព្រាង។",
        "lv": "Ievadiet uzdevuma nosaukumu, lai saglabātu melnrakstu.",
        "nl": "Voer een opdrachttitel in om een concept op te slaan.",
        "pl": "Wprowadź tytuł zadania, aby zapisać wersję roboczą.",
        "pt": "Insira um título de tarefa para salvar um rascunho.",
        "sk": "Ak chcete uložiť koncept, zadajte názov úlohy.",
        "th": "ใส่ชื่องานที่มอบหมายเพื่อบันทึกฉบับร่าง"
    },
    "assignment-updated-successfully": {
        "de": "Aufgabe erfolgreich aktualisiert",
        "en": "Assignment updated successfully",
        "es": "Tarea actualizada exitosamente",
        "fr": "Devoir mis à jour avec succès",
        "km": "បានធ្វើបច្ចុប្បន្នភាពកិច្ចការដោយជោគជ័យ",
        "lv": "Uzdevums veiksmīgi atjaunināts",
        "nl": "Opdracht bijgewerkt",
        "pl": "Zadanie zaktualizowane pomyślnie",
        "pt": "A tarefa foi atualizada com sucesso",
        "sk": "Úloha bola úspešne aktualizovaná",
        "th": "อัปเดตงานที่มอบหมายสำเร็จ"
    },
    "basic-information": {
        "de": "Grundlegende Informationen",
        "en": "Basic information",
        "es": "Información básica",
        "fr": "Informations de base",
        "km": "ព័ត៌មានមូលដ្ឋាន",
        "lv": "Pamatinformācija",
        "nl": "Basisinformatie",
        "pl": "Informacje podstawowe",
        "pt": "Informações Básicas",
        "sk": "Základné informácie",
        "th": "ข้อมูลพื้นฐาน"
    },
    "browse-and-select-content-from-library": {
        "de": "Durchsuchen Sie Inhalte aus der Bibliothek und wählen Sie sie aus",
        "en": "Browse and select content from the library",
        "es": "Explorar y seleccionar contenido de la biblioteca",
        "fr": "Parcourir et sélectionner du contenu dans la bibliothèque",
        "km": "រកមើល និងជ្រើសមាតិកាពីបណ្ណាល័យ",
        "lv": "Pārlūkojiet un atlasiet saturu no bibliotēkas",
        "nl": "Blader en selecteer inhoud uit de bibliotheek",
        "pl": "Przeglądaj i wybieraj treści z biblioteki",
        "pt": "Navegue e selecione conteúdo da biblioteca",
        "sk": "Prehliadajte a vyberte obsah z knižnice",
        "th": "เรียกดูและเลือกเนื้อหาจากคลัง"
    },
    "bulk-archive-students-confirm-description": {
        "de": "Archivierte Schüler werden aus Ihrer aktiven Liste ausgeblendet. Sie werden nicht gelöscht und verbleiben in ihren Gruppen. Schüler können weiterhin Aufgaben sehen, die für diese Gruppen veröffentlicht wurden. Sie können sie jederzeit über den Bereich „Archivierte Schüler“ wiederherstellen.",
        "en": "Archived students will be removed from the 'Active' student list. They will still see their assignments unless they are removed from relevant groups. Student accounts may be restored by clicking 'Show archived' and reselecting their profiles.",
        "es": "Los estudiantes archivados están ocultos de su lista activa. No se eliminan y permanecen en sus grupos. Es posible que los estudiantes aún vean las tareas publicadas en esos grupos. Restáurelos en cualquier momento desde la sección de estudiantes archivados.",
        "fr": "Les élèves archivés sont masqués de votre liste active. Ils ne sont pas supprimés et restent dans leurs groupes. Ils peuvent encore voir les devoirs publiés pour ces groupes. Restaurez-les à tout moment depuis la section des élèves archivés.",
        "km": "សិស្សដែលបានទុកជាឯកសារត្រូវបានលាក់ពីបញ្ជីសកម្ម។ ពួកគេមិនត្រូវបានលុប និងនៅតែស្ថិតក្នុងក្រុម។ ពួកគេអាចនៅតែមើលកិច្ចការដែលបានផ្សព្វផ្សាយទៅក្រុមទាំងនោះ។ ស្តារពួកគេពីផ្នែកសិស្សដែលបានទុកជាឯកសារនៅពេលណាក៏បាន។",
        "lv": "Arhivētie skolēni ir paslēpti jūsu aktīvajā sarakstā. Viņi netiek dzēsti un paliek savās grupās. Skolēni joprojām var redzēt šajās grupās publicētos uzdevumus. Atjaunojiet tos jebkurā laikā no arhivēto skolēnu sadaļas.",
        "nl": "Gearchiveerde leerlingen worden verborgen voor uw actieve lijst. Ze worden niet verwijderd en blijven in hun groepen. Leerlingen kunnen nog steeds opdrachten zien die voor die groepen zijn gepubliceerd. Herstel ze op elk gewenst moment vanuit de gearchiveerde leerlingensectie.",
        "pl": "Zarchiwizowani uczniowie są ukryci na aktywnej liście. Nie są usuwani i pozostają w grupach. Mogą nadal widzieć zadania opublikowane dla tych grup. Przywróć ich w dowolnym momencie z sekcji zarchiwizowanych uczniów.",
        "pt": "Os alunos arquivados ficam ocultos na sua lista ativa. Eles não são excluídos e permanecem em seus grupos. Os alunos ainda poderão ver as tarefas publicadas nesses grupos. Restaure-os a qualquer momento na seção de alunos arquivados.",
        "sk": "Archivovaní žiaci sú skrytí z vášho aktívneho zoznamu. Neodstránia sa a zostávajú vo svojich skupinách. Žiaci môžu stále vidieť úlohy zverejnené v týchto skupinách. Obnovte ich kedykoľvek v sekcii archivovaných žiakov.",
        "th": "นักเรียนที่เก็บถาวรจะถูกซ่อนจากรายการที่ใช้งาน ไม่ถูกลบและยังอยู่ในกลุ่ม อาจยังเห็นงานที่เผยแพร่ไปยังกลุ่มเหล่านั้น กู้คืนได้ทุกเมื่อจากส่วนนักเรียนที่เก็บถาวร"
    },
    "bulk-archive-students-confirm-title": {
        "de": "{count} ausgewählte Schüler archivieren?",
        "en": "Archive {count} selected student(s)?",
        "es": "¿Archivar {count} estudiante(s) seleccionado(s)?",
        "fr": "Archiver {count} élève(s) sélectionné(s) ?",
        "km": "ទុកសិស្សដែលបានជ្រើស {count} នាក់ជាឯកសារ?",
        "lv": "Vai arhivēt {count} atlasītos skolēnus?",
        "nl": "{count} geselecteerde leerling(en) archiveren?",
        "pl": "Zarchiwizować {count} wybranych uczniów?",
        "pt": "Arquivar {count} aluno(s) selecionado(s)?",
        "sk": "Archivovať {count} vybratých žiakov?",
        "th": "เก็บถาวรนักเรียนที่เลือก {count} คนหรือไม่?"
    },
    "bulk-duplicate-already-exists": {
        "de": "Existiert bereits:",
        "en": "Already exists:",
        "es": "Ya existe:",
        "fr": "Existe déjà :",
        "km": "មានរួចហើយ៖",
        "lv": "Jau pastāv:",
        "nl": "Bestaat al:",
        "pl": "Już istnieje:",
        "pt": "Já existe:",
        "sk": "Už existuje:",
        "th": "มีอยู่แล้ว:"
    },
    "bulk-duplicate-repeated-in-upload": {
        "de": "Beim Hochladen wiederholt:",
        "en": "Repeated in upload:",
        "es": "Repetido en la carga:",
        "fr": "Répété dans le fichier :",
        "km": "ស្ទួនក្នុងឯកសារផ្ទុកឡើង៖",
        "lv": "Atkārtots augšupielādē:",
        "nl": "Herhaald tijdens het uploaden:",
        "pl": "Powtórzone w przesłanym pliku:",
        "pt": "Repetido no upload:",
        "sk": "Opakované pri nahrávaní:",
        "th": "ซ้ำในไฟล์อัปโหลด:"
    },
    "bulk-duplicate-skipped-reason": {
        "de": "doppelte Namen",
        "en": "duplicate names",
        "es": "nombres duplicados",
        "fr": "noms en double",
        "km": "ឈ្មោះស្ទួន",
        "lv": "dublēti vārdi",
        "nl": "dubbele namen",
        "pl": "zduplikowane nazwy",
        "pt": "nomes duplicados",
        "sk": "duplicitné mená",
        "th": "ชื่อซ้ำ"
    },
    "bulk-duplicate-students-intro": {
        "de": "{count} doppelte Namen gefunden.",
        "en": "{count} duplicate name(s) found.",
        "es": "{count} nombre(s) duplicado(s) encontrado(s).",
        "fr": "{count} nom(s) en double trouvé(s).",
        "km": "រកឃើញឈ្មោះស្ទួន {count}។",
        "lv": "Atrasti {count} vārda dublikāti.",
        "nl": "{count} dubbele naam/namen gevonden.",
        "pl": "Znaleziono {count} zduplikowanych nazw.",
        "pt": "{count} nomes duplicados encontrados.",
        "sk": "Našli sa duplicitné mená ({count}).",
        "th": "พบชื่อซ้ำ {count} รายการ"
    },
    "bulk-duplicate-students-summary": {
        "de": "{create} neue Schüler erstellen und {skip} Duplikate überspringen?",
        "en": "Create {create} new student(s) and skip {skip} duplicate(s)?",
        "es": "¿Crear {create} nuevos estudiantes y omitir {skip} duplicados?",
        "fr": "Créer {create} nouvel/nouveaux élève(s) et ignorer {skip} doublon(s) ?",
        "km": "បង្កើតសិស្សថ្មី {create} នាក់ និងរំលងស្ទួន {skip}?",
        "lv": "Vai izveidot {create} jaunu(-us) skolēnu(-us) un izlaist {skip} dublikātu(-us)?",
        "nl": "{create} nieuwe leerling(en) aanmaken en {skip} dubbele(n) overslaan?",
        "pl": "Utworzyć {create} nowych uczniów i pominąć {skip} duplikat(ów)?",
        "pt": "Criar {create} novos alunos e pular {skip} duplicatas?",
        "sk": "Vytvoriť {create} nových žiakov a preskočiť {skip} duplikáty?",
        "th": "สร้างนักเรียนใหม่ {create} คนและข้ามรายการซ้ำ {skip} รายการหรือไม่?"
    },
    "complete-profile-information-for": {
        "de": "Profilinformationen vervollständigen für",
        "en": "Complete Profile Information For",
        "es": "Completar la información del perfil de",
        "fr": "Compléter les informations du profil pour",
        "km": "បំពេញព័ត៌មានប្រវត្តិរូបសម្រាប់",
        "lv": "Aizpildiet profila informāciju par",
        "nl": "Profielgegevens invullen voor",
        "pl": "Uzupełnij informacje profilu dla",
        "pt": "Preencher as informações do perfil de",
        "sk": "Vyplniť profilové informácie pre",
        "th": "กรอกข้อมูลโปรไฟล์ให้ครบสำหรับ"
    },
    "complete-required-steps-before-saving": {
        "de": "Führen Sie vor dem Speichern alle erforderlichen Schritte aus.",
        "en": "Complete all required steps before saving.",
        "es": "Complete todos los pasos requeridos antes de guardar.",
        "fr": "Terminez toutes les étapes obligatoires avant d’enregistrer.",
        "km": "បំពេញជំហានចាំបាច់ទាំងអស់មុនពេលរក្សាទុក។",
        "lv": "Pirms saglabāšanas veiciet visas nepieciešamās darbības.",
        "nl": "Voltooi alle vereiste stappen voordat u opslaat.",
        "pl": "Ukończ wszystkie wymagane kroki przed zapisaniem.",
        "pt": "Conclua todas as etapas necessárias antes de salvar.",
        "sk": "Pred uložením vykonajte všetky požadované kroky.",
        "th": "ทำขั้นตอนที่จำเป็นทั้งหมดให้ครบก่อนบันทึก"
    },
    "content-added-to-assignment": {
        "de": "Inhalt zur Aufgabe hinzugefügt",
        "en": "Content added to assignment",
        "es": "Contenido agregado a la tarea",
        "fr": "Contenu ajouté au devoir",
        "km": "បានបន្ថែមមាតិកាទៅកិច្ចការ",
        "lv": "Uzdevumam pievienots saturs",
        "nl": "Inhoud toegevoegd aan opdracht",
        "pl": "Treść dodana do zadania",
        "pt": "Conteúdo adicionado à tarefa",
        "sk": "Obsah pridaný do úlohy",
        "th": "เพิ่มเนื้อหาไปยังงานที่มอบหมายแล้ว"
    },
    "content-already-in-assignment": {
        "de": "Der Inhalt ist bereits in dieser Aufgabe enthalten",
        "en": "Content is already in this assignment",
        "es": "El contenido ya está en esta tarea.",
        "fr": "Le contenu est déjà dans ce devoir",
        "km": "មាតិកាមាននៅក្នុងកិច្ចការនេះរួចហើយ",
        "lv": "Saturs jau ir šajā uzdevumā",
        "nl": "Inhoud zit al in deze opdracht",
        "pl": "Treść jest już w tym zadaniu",
        "pt": "O conteúdo já está nesta tarefa",
        "sk": "Obsah je už v tejto úlohe",
        "th": "เนื้อหานี้อยู่ในงานที่มอบหมายนี้แล้ว"
    },
    "content-info": {
        "de": "Inhaltsinfo",
        "en": "Content info",
        "es": "Información de contenido",
        "fr": "Infos sur le contenu",
        "km": "ព័ត៌មានមាតិកា",
        "lv": "Informācija par saturu",
        "nl": "Inhoudsinformatie",
        "pl": "Informacje o treści",
        "pt": "Informações de conteúdo",
        "sk": "Informácie o obsahu",
        "th": "ข้อมูลเนื้อหา"
    },
    "content-type": {
        "de": "Inhaltstyp",
        "en": "Content type",
        "es": "tipo de contenido",
        "fr": "Type de contenu",
        "km": "ប្រភេទមាតិកា",
        "lv": "Satura veids",
        "nl": "Inhoudstype",
        "pl": "Typ treści",
        "pt": "Tipo de conteúdo",
        "sk": "Typ obsahu",
        "th": "ประเภทเนื้อหา"
    },
    "continue-anyway": {
        "de": "Machen Sie trotzdem weiter",
        "en": "Continue anyway",
        "es": "Continuar de todos modos",
        "fr": "Continuer quand même",
        "km": "បន្តទៅមុខ",
        "lv": "Tomēr turpināt",
        "nl": "Ga toch door",
        "pl": "Kontynuuj mimo to",
        "pt": "Continuar mesmo assim",
        "sk": "Napriek tomu pokračujte",
        "th": "ดำเนินการต่อ"
    },
    "continue-browsing": {
        "de": "Stöbern Sie weiter",
        "en": "Continue browsing",
        "es": "Continuar navegando",
        "fr": "Continuer la navigation",
        "km": "បន្តរកមើល",
        "lv": "Turpiniet pārlūkošanu",
        "nl": "Ga door met browsen",
        "pl": "Kontynuuj przeglądanie",
        "pt": "Continuar navegando",
        "sk": "Pokračujte v prehliadaní",
        "th": "เรียกดูต่อ"
    },
    "continue-without-adding": {
        "de": "Fahren Sie fort, ohne etwas hinzuzufügen",
        "en": "Continue without adding",
        "es": "Continuar sin agregar",
        "fr": "Continuer sans ajouter",
        "km": "បន្តដោយមិនបន្ថែម",
        "lv": "Turpiniet, nepievienojot",
        "nl": "Ga verder zonder iets toe te voegen",
        "pl": "Kontynuuj bez dodawania",
        "pt": "Continuar sem adicionar",
        "sk": "Pokračujte bez pridávania",
        "th": "ดำเนินการต่อโดยไม่เพิ่ม"
    },
    "create-a-copy-of": {
        "de": "Erstellen Sie eine Kopie von",
        "en": "Create a copy of",
        "es": "Crear una copia de",
        "fr": "Créer une copie de",
        "km": "បង្កើតច្បាប់ចម្លងនៃ",
        "lv": "Izveidojiet kopiju",
        "nl": "Maak een kopie van",
        "pl": "Utwórz kopię",
        "pt": "Crie uma cópia de",
        "sk": "Vytvorte kópiu",
        "th": "สร้างสำเนาของ"
    },
    "create-all-accounts": {
        "de": "Alle Konten erstellen",
        "en": "Create accounts",
        "es": "Crear todas las cuentas",
        "fr": "Créer tous les comptes",
        "km": "បង្កើតគណនីទាំងអស់",
        "lv": "Izveidot visus kontus",
        "nl": "Maak alle accounts aan",
        "pl": "Utwórz wszystkie konta",
        "pt": "Criar todas as contas",
        "sk": "Vytvoriť všetky účty",
        "th": "สร้างบัญชีทั้งหมด"
    },
    "csv-required-columns": {
        "de": "Erforderliche CSV-Spalten",
        "en": "Csv Required Columns",
        "es": "Columnas obligatorias CSV",
        "fr": "Colonnes CSV obligatoires",
        "km": "ជួរឈរ CSV ដែលត្រូវការ",
        "lv": "Obligātās CSV kolonnas",
        "nl": "Vereiste CSV-kolommen",
        "pl": "Wymagane kolumny CSV",
        "pt": "Colunas obrigatórias do CSV",
        "sk": "Povinné stĺpce CSV",
        "th": "คอลัมน์ CSV ที่จำเป็น"
    },
    "current-item-sequence-count": {
        "de": "Aktuelles Element/aktuelle Sequenz ({count})",
        "en": "Current item/sequence ({count})",
        "es": "Elemento/secuencia actual ({count})",
        "fr": "Élément/séquence actuel(le) ({count})",
        "km": "ធាតុ/លំដាប់បច្ចុប្បន្ន ({count})",
        "lv": "Pašreizējais vienums/secība ({count})",
        "nl": "Huidig item/reeks ({count})",
        "pl": "Bieżący element/sekwencja ({count})",
        "pt": "Item/sequência atual ({count})",
        "sk": "Aktuálna položka/sekvencia ({count})",
        "th": "รายการ/ลำดับปัจจุบัน ({count})"
    },
    "date-format-placeholder": {
        "de": "MM/TT/JJJJ",
        "en": "mm/dd/yyyy",
        "es": "dd/mm/aaaa",
        "fr": "jj/mm/aaaa",
        "km": "ថ្ងៃ/ខែ/ឆ្នាំ",
        "lv": "mm/dd/gggg",
        "nl": "mm/dd/jjjj",
        "pl": "dd/mm/rrrr",
        "pt": "mm/dd/aaaa",
        "sk": "mm/dd/rrrr",
        "th": "วว/ดด/ปปปป"
    },
    "describe-your-sequence": {
        "de": "Beschreiben Sie Ihre Sequenz",
        "en": "Describe Your Sequence",
        "es": "Describe tu secuencia",
        "fr": "Décrivez votre séquence",
        "km": "ពិពណ៌នាលំដាប់របស់អ្នក",
        "lv": "Aprakstiet savu secību",
        "nl": "Beschrijf uw reeks",
        "pl": "Opisz swoją sekwencję",
        "pt": "Descreva sua sequência",
        "sk": "Popíšte svoju postupnosť",
        "th": "อธิบายลำดับของคุณ"
    },
    "discard": {
        "de": "Verwerfen",
        "en": "Discard",
        "es": "Descartar",
        "fr": "Abandonner",
        "km": "បោះបង់",
        "lv": "Izmest",
        "nl": "Gooi weg",
        "pl": "Odrzuć",
        "pt": "Descartar",
        "sk": "Zahodiť",
        "th": "ละทิ้ง"
    },
    "discard-changes": {
        "de": "Änderungen verwerfen?",
        "en": "Discard changes?",
        "es": "¿Descartar cambios?",
        "fr": "Abandonner les modifications ?",
        "km": "បោះបង់ការផ្លាស់ប្តូរ?",
        "lv": "Vai atmest izmaiņas?",
        "nl": "Wijzigingen weggooien?",
        "pl": "Odrzucić zmiany?",
        "pt": "Descartar alterações?",
        "sk": "Zahodiť zmeny?",
        "th": "ละทิ้งการเปลี่ยนแปลงหรือไม่?"
    },
    "discover-customise-and-add-content-to-your-assignments": {
        "de": "Inhalte für Ihre Aufgaben entdecken, anpassen und hinzufügen",
        "en": "Customise and add content to assignments",
        "es": "Descubre, personaliza y añade contenido a tus tareas",
        "fr": "Découvrez, personnalisez et ajoutez du contenu à vos devoirs",
        "km": "ស្វែងរក ប្ដូរតាមបំណង និងបន្ថែមមាតិកាទៅកិច្ចការរបស់អ្នក",
        "lv": "Atklājiet, pielāgojiet un pievienojiet saturu saviem uzdevumiem",
        "nl": "Ontdek, pas aan en voeg inhoud toe aan uw opdrachten",
        "pl": "Odkrywaj, dostosowuj i dodawaj treści do zadań",
        "pt": "Descubra, personalize e adicione conteúdo às suas tarefas",
        "sk": "Objavujte, prispôsobujte a pridávajte obsah do svojich úloh",
        "th": "ค้นหา ปรับแต่ง และเพิ่มเนื้อหาไปยังงานที่มอบหมายของคุณ"
    },
    "download-login": {
        "de": "Anmeldecode herunterladen",
        "en": "Download login",
        "es": "Descargar código de inicio de sesión",
        "fr": "Télécharger la connexion",
        "km": "ទាញយកការចូល",
        "lv": "Lejupielādēt pieteikšanās kodu",
        "nl": "Inlogcode downloaden",
        "pl": "Pobierz dane logowania",
        "pt": "Baixar código de login",
        "sk": "Stiahnuť prihlasovací kód",
        "th": "ดาวน์โหลดข้อมูลเข้าสู่ระบบ"
    },
    "download-login-code": {
        "de": "Anmeldecode herunterladen",
        "en": "Download login",
        "es": "Descargar código de inicio de sesión",
        "fr": "Télécharger le code de connexion",
        "km": "ទាញយកលេខកូដចូល",
        "lv": "Lejupielādēt pieteikšanās kodu",
        "nl": "Inlogcode downloaden",
        "pl": "Pobierz kod logowania",
        "pt": "Baixar código de login",
        "sk": "Stiahnuť prihlasovací kód",
        "th": "ดาวน์โหลดรหัสเข้าสู่ระบบ"
    },
    "download-template": {
        "de": "Vorlage herunterladen",
        "en": "Download template",
        "es": "Descargar plantilla",
        "fr": "Télécharger le modèle",
        "km": "ទាញយកគំរូ",
        "lv": "Lejupielādēt veidni",
        "nl": "Sjabloon downloaden",
        "pl": "Pobierz szablon",
        "pt": "Baixar modelo",
        "sk": "Stiahnite si šablónu",
        "th": "ดาวน์โหลดเทมเพลต"
    },
    "draft-saved-successfully": {
        "de": "Entwurf erfolgreich gespeichert",
        "en": "Draft saved successfully",
        "es": "Borrador guardado exitosamente",
        "fr": "Brouillon enregistré avec succès",
        "km": "បានរក្សាទុកសេចក្តីព្រាងដោយជោគជ័យ",
        "lv": "Melnraksts ir veiksmīgi saglabāts",
        "nl": "Concept succesvol opgeslagen",
        "pl": "Wersja robocza zapisana pomyślnie",
        "pt": "Rascunho salvo com sucesso",
        "sk": "Koncept bol úspešne uložený",
        "th": "บันทึกฉบับร่างสำเร็จ"
    },
    "drag-content-here": {
        "de": "Ziehen Sie Inhalte hierher, um Elemente hinzuzufügen",
        "en": "Drag content here to add items",
        "es": "Arrastre el contenido aquí para agregar elementos",
        "fr": "Glissez du contenu ici pour ajouter des éléments",
        "km": "អូសមាតិកាមកទីនេះដើម្បីបន្ថែមធាតុ",
        "lv": "Velciet saturu šeit, lai pievienotu vienumus",
        "nl": "Sleep inhoud hierheen om items toe te voegen",
        "pl": "Przeciągnij treść tutaj, aby dodać elementy",
        "pt": "Arraste o conteúdo aqui para adicionar itens",
        "sk": "Presuňte obsah sem a pridajte položky",
        "th": "ลากเนื้อมาที่นี่เพื่อเพิ่มรายการ"
    },
    "drop-csv-file-here": {
        "de": "Legen Sie die CSV-Datei hier ab",
        "en": "Drop CSV file here",
        "es": "Suelte el archivo CSV aquí",
        "fr": "Déposez le fichier CSV ici",
        "km": "ទម្លាក់ឯកសារ CSV នៅទីនេះ",
        "lv": "Nometiet CSV failu šeit",
        "nl": "Zet het CSV-bestand hier neer",
        "pl": "Upuść plik CSV tutaj",
        "pt": "Solte o arquivo CSV aqui",
        "sk": "Sem presuňte súbor CSV",
        "th": "วางไฟล์ CSV ที่นี่"
    },
    "drop-here": {
        "de": "Hier ablegen",
        "en": "Drop Here",
        "es": "Suelte aquí",
        "fr": "Déposer ici",
        "km": "ទម្លាក់នៅទីនេះ",
        "lv": "Nometiet šeit",
        "nl": "Hier neerzetten",
        "pl": "Upuść tutaj",
        "pt": "Solte aqui",
        "sk": "Presuňte sem",
        "th": "วางที่นี่"
    },
    "duplicate-name-description": {
        "de": "Ein Schüler namens",
        "en": "A student named",
        "es": "un estudiante llamado",
        "fr": "Un élève nommé",
        "km": "សិស្សឈ្មោះ",
        "lv": "Skolnieks vārdā",
        "nl": "Een leerling genaamd",
        "pl": "Uczeń o imieniu",
        "pt": "Um aluno chamado",
        "sk": "Žiak s menom",
        "th": "นักเรียนชื่อ"
    },
    "duplicate-name-title": {
        "de": "Name existiert bereits",
        "en": "Name already exists",
        "es": "El nombre ya existe",
        "fr": "Ce nom existe déjà",
        "km": "ឈ្មោះមានរួចហើយ",
        "lv": "Vārds jau pastāv",
        "nl": "Naam bestaat al",
        "pl": "Nazwa już istnieje",
        "pt": "O nome já existe",
        "sk": "Názov už existuje",
        "th": "มีชื่อนี้อยู่แล้ว"
    },
    "edit-feedback": {
        "de": "Feedback bearbeiten",
        "en": "Edit Feedback",
        "es": "Editar comentarios",
        "fr": "Modifier le commentaire",
        "km": "កែមតិកែលម្អ",
        "lv": "Rediģēt atsauksmes",
        "nl": "Feedback bewerken",
        "pl": "Edytuj opinię",
        "pt": "Editar comentários",
        "sk": "Upraviť spätnú väzbu",
        "th": "แก้ไขข้อเสนอแนะ"
    },
    "edit-student": {
        "de": "Schüler bearbeiten",
        "en": "Edit Student",
        "es": "Editar estudiante",
        "fr": "Modifier l’élève",
        "km": "កែសិស្ស",
        "lv": "Rediģēt skolēnu",
        "nl": "Leerling bewerken",
        "pl": "Edytuj ucznia",
        "pt": "Editar aluno",
        "sk": "Upraviť žiaka",
        "th": "แก้ไขนักเรียน"
    },
    "edit-students-details": {
        "de": "Schülerdetails bearbeiten",
        "en": "Edit students details",
        "es": "Editar detalles de estudiantes",
        "fr": "Modifier les détails de l’élève",
        "km": "កែព័ត៌មានលម្អិតសិស្ស",
        "lv": "Rediģēt skolēnu informāciju",
        "nl": "Leerlinggegevens bewerken",
        "pl": "Edytuj dane ucznia",
        "pt": "Editar detalhes dos alunos",
        "sk": "Upraviť podrobnosti o žiakoch",
        "th": "แก้ไขรายละเอียดนักเรียน"
    },
    "encryption-key-invalid-badge": {
        "de": "Das Verschlüsselungsschlüsselwort ist möglicherweise falsch",
        "en": "Encryption key-word may be incorrect",
        "es": "La palabra clave de cifrado puede ser incorrecta",
        "fr": "Le mot-clé de chiffrement est peut-être incorrect",
        "km": "ពាក្យគន្លឹះអ៊ីនគ្រីបប្រហែលមិនត្រឹមត្រូវ",
        "lv": "Šifrēšanas atslēgas vārds var būt nepareizs",
        "nl": "Het coderingssleutelwoord is mogelijk onjuist",
        "pl": "Słowo kluczowe szyfrowania może być nieprawidłowe",
        "pt": "A palavra-chave de criptografia pode estar incorreta",
        "sk": "Kľúčové slovo šifrovania môže byť nesprávne",
        "th": "คำสำคัญการเข้ารหัสอาจไม่ถูกต้อง"
    },
    "encryption-key-invalid-banner": {
        "de": "Schülerinformationen konnten nicht entschlüsselt werden. Überprüfen Sie, ob Ihr Verschlüsselungsschlüsselwort korrekt ist.",
        "en": "Student information could not be decrypted. Check that the encryption key-word is correct.",
        "es": "La información del estudiante no se pudo descifrar. Compruebe que su palabra clave de cifrado sea correcta.",
        "fr": "Les informations des élèves n’ont pas pu être déchiffrées. Vérifiez que votre mot-clé de chiffrement est correct.",
        "km": "មិនអាចឌិគ្រីបព័ត៌មានសិស្សបានទេ។ ពិនិត្យថាពាក្យគន្លឹះអ៊ីនគ្រីបរបស់អ្នកត្រឹមត្រូវ។",
        "lv": "Skolēna informāciju nevarēja atšifrēt. Pārbaudiet, vai šifrēšanas atslēgas vārds ir pareizs.",
        "nl": "De leerlinggegevens konden niet worden ontsleuteld. Controleer of uw coderingssleutelwoord correct is.",
        "pl": "Nie udało się odszyfrować informacji o uczniach. Sprawdź, czy słowo kluczowe szyfrowania jest poprawne.",
        "pt": "As informações do aluno não puderam ser descriptografadas. Verifique se a sua palavra-chave de criptografia está correta.",
        "sk": "Informácie o žiakovi sa nepodarilo dešifrovať. Skontrolujte, či je vaše šifrovacie kľúčové slovo správne.",
        "th": "ถอดรหัสข้อมูลนักเรียนไม่ได้ ตรวจสอบว่าคำสำคัญการเข้ารหัสถูกต้อง"
    },
    "encryption-key-invalid-hint": {
        "de": "Dieses Schlüsselwort konnte die Schülerinformationen nicht entschlüsseln. Probieren Sie das Schlüsselwort aus, das Sie beim Erstellen oder Verknüpfen von Schülern verwendet haben.",
        "en": "This key-word could not decrypt student information. Use the same key-word from when student accounts were created.",
        "es": "Esta palabra clave no pudo descifrar la información del estudiante. Pruebe la palabra clave que utilizó al crear o vincular estudiantes.",
        "fr": "Ce mot-clé n’a pas pu déchiffrer les informations des élèves. Essayez le mot-clé utilisé lors de la création ou de la liaison des élèves.",
        "km": "ពាក្យគន្លឹះនេះមិនអាចឌិគ្រីបព័ត៌មានសិស្សបានទេ។ សាកល្បងពាក្យដែលអ្នកបានប្រើពេលបង្កើត ឬភ្ជាប់សិស្ស។",
        "lv": "Šis atslēgas vārds nevarēja atšifrēt skolēnu informāciju. Izmēģiniet atslēgas vārdu, ko izmantojāt, veidojot vai saistot skolēnus.",
        "nl": "Dit sleutelwoord kon de leerlinginformatie niet ontsleutelen. Probeer het trefwoord dat u hebt gebruikt bij het aanmaken of koppelen van leerlingen.",
        "pl": "To słowo kluczowe nie odszyfrowało informacji o uczniach. Spróbuj słowa użytego przy tworzeniu lub łączeniu uczniów.",
        "pt": "Esta palavra-chave não conseguiu descriptografar as informações do aluno. Experimente a palavra-chave que você usou ao criar ou vincular alunos.",
        "sk": "Toto kľúčové slovo nedokázalo dešifrovať informácie o žiakovi. Vyskúšajte kľúčové slovo, ktoré ste použili pri vytváraní alebo spájaní žiakov.",
        "th": "คำสำคัญนี้ถอดรหัสข้อมูลนักเรียนไม่ได้ ลองใช้คำที่คุณใช้ตอนสร้างหรือเชื่อมโยงนักเรียน"
    },
    "encryption-key-missing-badge": {
        "de": "Verschlüsselungsschlüsselwort nicht festgelegt",
        "en": "Encryption key-word not set",
        "es": "Palabra clave de cifrado no establecida",
        "fr": "Mot-clé de chiffrement non défini",
        "km": "មិនទាន់កំណត់ពាក្យគន្លឹះអ៊ីនគ្រីប",
        "lv": "Šifrēšanas atslēgas vārds nav iestatīts",
        "nl": "Versleutelingssleutelwoord niet ingesteld",
        "pl": "Nie ustawiono słowa kluczowego szyfrowania",
        "pt": "Palavra-chave de criptografia não definida",
        "sk": "Kľúčové slovo šifrovania nie je nastavené",
        "th": "ยังไม่ได้ตั้งคำสำคัญการเข้ารหัส"
    },
    "encryption-key-missing-banner": {
        "de": "Die Schülerinformationen werden als anonyme IDs angezeigt, bis Sie Ihr Verschlüsselungsschlüsselwort eingeben.",
        "en": "Student information is shown as anonymous IDs until you enter your encryption key-word.",
        "es": "La información del estudiante se muestra como identificaciones anónimas hasta que ingresa su palabra clave de cifrado.",
        "fr": "Les informations des élèves s’affichent comme des identifiants anonymes tant que vous n’avez pas saisi votre mot-clé de chiffrement.",
        "km": "ព័ត៌មានសិស្សបង្ហាញជា ID អនាមិក រហូតដល់អ្នកបញ្ចូលពាក្យគន្លឹះអ៊ីនគ្រីប។",
        "lv": "Skolēna informācija tiek rādīta kā anonīmi ID, līdz ievadāt šifrēšanas atslēgvārdu.",
        "nl": "Leerlinginformatie wordt weergegeven als anonieme ID's totdat u uw coderingssleutelwoord invoert.",
        "pl": "Informacje o uczniach są pokazywane jako anonimowe ID, dopóki nie wprowadzisz słowa kluczowego szyfrowania.",
        "pt": "As informações dos alunos são mostradas como IDs anônimos até que você insira sua palavra-chave de criptografia.",
        "sk": "Informácie o žiakovi sa zobrazujú ako anonymné ID, kým nezadáte svoje šifrovacie kľúčové slovo.",
        "th": "ข้อมูลนักเรียนจะแสดงเป็นรหัสนิรนามจนกว่าคุณจะใส่คำสำคัญการเข้ารหัส"
    },
    "encryption-key-required-hint": {
        "de": "Zum Anzeigen der Schülerinformationen ist ein Verschlüsselungsschlüsselwort erforderlich.",
        "en": "An encryption key-word is required to view student information.",
        "es": "Se requiere una palabra clave de cifrado para ver la información del estudiante.",
        "fr": "Un mot-clé de chiffrement est requis pour voir les informations des élèves.",
        "km": "ត្រូវការពាក្យគន្លឹះអ៊ីនគ្រីបដើម្បីមើលព័ត៌មានសិស្ស។",
        "lv": "Lai skatītu informāciju par skolēnu, ir nepieciešams šifrēšanas atslēgas vārds.",
        "nl": "Om leerlinginformatie te kunnen bekijken, is een coderingssleutelwoord vereist.",
        "pl": "Do wyświetlenia informacji o uczniach wymagane jest słowo kluczowe szyfrowania.",
        "pt": "Uma palavra-chave de criptografia é necessária para visualizar as informações do aluno.",
        "sk": "Na zobrazenie informácií o žiakovi je potrebné šifrovacie kľúčové slovo.",
        "th": "ต้องมีคำสำคัญการเข้ารหัสเพื่อดูข้อมูลนักเรียน"
    },
    "enter-sequence-title": {
        "de": "Geben Sie den Titel der Sequenz ein",
        "en": "Enter sequence title",
        "es": "Ingrese el título de la secuencia",
        "fr": "Saisir le titre de la séquence",
        "km": "បញ្ចូលចំណងជើងលំដាប់",
        "lv": "Ievadiet secības nosaukumu",
        "nl": "Voer de titel van de reeks in",
        "pl": "Wprowadź tytuł sekwencji",
        "pt": "Insira o título da sequência",
        "sk": "Zadajte názov sekvencie",
        "th": "ใส่ชื่อลำดับ"
    },
    "excel-save-as-csv-first": {
        "de": "Der Einfachheit halber werden Excel-Dateien aufgelistet – bitte speichern Sie sie als CSV und laden Sie diese Datei hoch.",
        "en": "Excel files are listed for convenience — please save as CSV and upload that file.",
        "es": "Los archivos de Excel se enumeran para su comodidad; guárdelos como CSV y cargue ese archivo.",
        "fr": "Les fichiers Excel sont listés pour commodité — veuillez enregistrer en CSV et téléverser ce fichier.",
        "km": "ឯកសារ Excel ត្រូវបានរាយសម្រាប់ភាពងាយស្រួល — សូមរក្សាទុកជា CSV ហើយផ្ទុកឡើងឯកសារនោះ។",
        "lv": "Ērtības labad ir norādīti Excel faili — lūdzu, saglabājiet to kā CSV un augšupielādējiet šo failu.",
        "nl": "Voor het gemak worden Excel-bestanden weergegeven. Sla deze op als CSV en upload dat bestand.",
        "pl": "Pliki Excel są widoczne dla wygody — zapisz jako CSV i prześlij ten plik.",
        "pt": "Os arquivos Excel estão listados por conveniência – salve como CSV e carregue esse arquivo.",
        "sk": "Súbory Excel sú uvedené pre pohodlie – uložte ich ako CSV a nahrajte daný súbor.",
        "th": "ไฟล์ Excel แสดงไว้เพื่อความสะดวก — โปรดบันทึกเป็น CSV แล้วอัปโหลดไฟล์นั้น"
    },
    "favorites": {
        "de": "Favoriten",
        "en": "Favorites",
        "es": "Favoritos",
        "fr": "Favoris",
        "km": "សំណព្វ",
        "lv": "Izlase",
        "nl": "Favorieten",
        "pl": "Ulubione",
        "pt": "Favoritos",
        "sk": "Obľúbené",
        "th": "รายการโปรด"
    },
    "favorites-only": {
        "de": "Nur Favoriten",
        "en": "Favourites only",
        "es": "Sólo favoritos",
        "fr": "Favoris uniquement",
        "km": "សំណព្វតែប៉ុណ្ណោះ",
        "lv": "Tikai izlase",
        "nl": "Alleen favorieten",
        "pl": "Tylko ulubione",
        "pt": "Somente favoritos",
        "sk": "Iba obľúbené",
        "th": "เฉพาะรายการโปรด"
    },
    "feedback": {
        "de": "Rückmeldung",
        "en": "Feedback",
        "es": "Comentarios",
        "fr": "Commentaires",
        "km": "មតិកែលម្អ",
        "lv": "Atsauksmes",
        "nl": "Feedback",
        "pl": "Opinia",
        "pt": "Comentários",
        "sk": "Spätná väzba",
        "th": "ข้อเสนอแนะ"
    },
    "fill-required-fields-to-continue": {
        "de": "Füllen Sie alle erforderlichen Felder aus, um fortzufahren.",
        "en": "Fill in all required fields to continue.",
        "es": "Complete todos los campos obligatorios para continuar.",
        "fr": "Remplissez tous les champs obligatoires pour continuer.",
        "km": "បំពេញវាលចាំបាច់ទាំងអស់ដើម្បីបន្ត។",
        "lv": "Lai turpinātu, aizpildiet visus obligātos laukus.",
        "nl": "Vul alle verplichte velden in om door te gaan.",
        "pl": "Wypełnij wszystkie wymagane pola, aby kontynuować.",
        "pt": "Preencha todos os campos obrigatórios para continuar.",
        "sk": "Ak chcete pokračovať, vyplňte všetky povinné polia.",
        "th": "กรอกช่องที่จำเป็นทั้งหมดเพื่อดำเนินการต่อ"
    },
    "go-to-assignment": {
        "de": "Zur Aufgabe",
        "en": "Go to assignment",
        "es": "Ir a la tarea",
        "fr": "Aller au devoir",
        "km": "ទៅកាន់កិច្ចការ",
        "lv": "Doties uz uzdevumu",
        "nl": "Naar opdracht",
        "pl": "Przejdź do zadania",
        "pt": "Ir para a tarefa",
        "sk": "Prejsť na úlohu",
        "th": "ไปที่งานที่มอบหมาย"
    },
    "graded": {
        "de": "Benotet",
        "en": "Graded",
        "es": "Calificado",
        "fr": "Noté",
        "km": "បានដាក់ពិន្ទុ",
        "lv": "Novērtēts",
        "nl": "Beoordeeld",
        "pl": "Ocenione",
        "pt": "Classificado",
        "sk": "Známkované",
        "th": "ให้คะแนนแล้ว"
    },
    "group-created-successfully": {
        "de": "Gruppe erfolgreich erstellt",
        "en": "Group successfully created",
        "es": "Grupo creado exitosamente",
        "fr": "Groupe créé avec succès",
        "km": "បានបង្កើតក្រុមដោយជោគជ័យ",
        "lv": "Grupa veiksmīgi izveidota",
        "nl": "Groep is succesvol aangemaakt",
        "pl": "Grupa utworzona pomyślnie",
        "pt": "Grupo criado com sucesso",
        "sk": "Skupina bola úspešne vytvorená",
        "th": "สร้างกลุ่มสำเร็จ"
    },
    "group-updated-successfully": {
        "de": "Gruppe erfolgreich aktualisiert",
        "en": "Group updated successfully",
        "es": "Grupo actualizado exitosamente",
        "fr": "Groupe mis à jour avec succès",
        "km": "បានធ្វើបច្ចុប្បន្នភាពក្រុមដោយជោគជ័យ",
        "lv": "Grupa ir veiksmīgi atjaunināta",
        "nl": "Groep is succesvol bijgewerkt",
        "pl": "Grupa zaktualizowana pomyślnie",
        "pt": "Grupo atualizado com sucesso",
        "sk": "Skupina bola úspešne aktualizovaná",
        "th": "อัปเดตกลุ่มสำเร็จ"
    },
    "homework": {
        "de": "Hausaufgaben",
        "en": "Homework",
        "es": "Tarea",
        "fr": "Devoirs",
        "km": "កិច្ចការផ្ទះ",
        "lv": "Mājas darbs",
        "nl": "Huiswerk",
        "pl": "Praca domowa",
        "pt": "Lição de casa",
        "sk": "Domáce úlohy",
        "th": "การบ้าน"
    },
    "i-confirm-consent-collected": {
        "de": "Ich bestätige die eingeholte Einwilligung",
        "en": "I confirm consent collected",
        "es": "Confirmo el consentimiento obtenido",
        "fr": "Je confirme que le consentement a été recueilli",
        "km": "ខ្ញុំបញ្ជាក់ថាបានប្រមូលការយល់ព្រម",
        "lv": "Es apstiprinu, ka piekrišana ir savākta",
        "nl": "Ik bevestig dat toestemming is verkregen",
        "pl": "Potwierdzam, że uzyskano zgodę",
        "pt": "Confirmo o consentimento coletado",
        "sk": "Potvrdzujem zhromaždený súhlas",
        "th": "ฉันยืนยันว่าได้รับความยินยอมแล้ว"
    },
    "individual-submission": {
        "de": "Individuelle Einreichung",
        "en": "Individual Submission",
        "es": "Envío individual",
        "fr": "Soumission individuelle",
        "km": "ការដាក់ស្នើបុគ្គល",
        "lv": "Individuāls iesniegums",
        "nl": "Individuele inzending",
        "pl": "Indywidualne zgłoszenie",
        "pt": "Envio Individual",
        "sk": "Individuálne podanie",
        "th": "การส่งรายบุคคล"
    },
    "items-added": {
        "de": "hinzugefügt",
        "en": "added",
        "es": "añadido",
        "fr": "ajouté(s)",
        "km": "បានបន្ថែម",
        "lv": "pievienots",
        "nl": "toegevoegd",
        "pl": "dodano",
        "pt": "adicionado",
        "sk": "pridané",
        "th": "เพิ่มแล้ว"
    },
    "items-added-to-assignment": {
        "de": "Element(e) hinzugefügt zu",
        "en": "item(s) added to",
        "es": "artículo(s) agregado(s) a",
        "fr": "élément(s) ajouté(s) à",
        "km": "ធាតុបានបន្ថែមទៅ",
        "lv": "vienums(-i) pievienoti",
        "nl": "item(s) toegevoegd aan",
        "pl": "element(y) dodane do",
        "pt": "itens adicionados a",
        "sk": "položky pridané do",
        "th": "รายการที่เพิ่มไปยัง"
    },
    "learning": {
        "de": "Lernen",
        "en": "Learning",
        "es": "Aprendizaje",
        "fr": "Apprentissage",
        "km": "ការរៀន",
        "lv": "Mācīšanās",
        "nl": "Leren",
        "pl": "Nauka",
        "pt": "Aprendizagem",
        "sk": "Učenie",
        "th": "การเรียนรู้"
    },
    "learning-goals-and-description": {
        "de": "Lernziele und Beschreibung",
        "en": "Learning Goals And Description",
        "es": "Objetivos de aprendizaje y descripción",
        "fr": "Objectifs d’apprentissage et description",
        "km": "គោលដៅសិក្សា និងការពិពណ៌នា",
        "lv": "Mācību mērķi un apraksts",
        "nl": "Leerdoelen en beschrijving",
        "pl": "Cele uczenia się i opis",
        "pt": "Metas e descrição de aprendizagem",
        "sk": "Učebné ciele a popis",
        "th": "เป้าหมายการเรียนรู้และคำอธิบาย"
    },
    "login-code": {
        "de": "Login-Code",
        "en": "Login code",
        "es": "Código de inicio de sesión",
        "fr": "Code de connexion",
        "km": "លេខកូដចូល",
        "lv": "Pieteikšanās kods",
        "nl": "Inlogcode",
        "pl": "Kod logowania",
        "pt": "Código de login",
        "sk": "Prihlasovací kód",
        "th": "รหัสเข้าสู่ระบบ"
    },
    "manual-entry": {
        "de": "Manuelle Eingabe",
        "en": "Manual entry",
        "es": "Entrada manual",
        "fr": "Saisie manuelle",
        "km": "បញ្ចូលដោយដៃ",
        "lv": "Manuālā ievade",
        "nl": "Handmatige invoer",
        "pl": "Wpis ręczny",
        "pt": "Entrada manual",
        "sk": "Manuálny vstup",
        "th": "ป้อนด้วยตนเอง"
    },
    "modify-the-group-details": {
        "de": "Ändern Sie die Gruppendetails",
        "en": "Modify group details",
        "es": "Modificar los detalles del grupo",
        "fr": "Modifier les détails du groupe",
        "km": "កែព័ត៌មានលម្អិតក្រុម",
        "lv": "Mainiet grupas informāciju",
        "nl": "Wijzig de groepsdetails",
        "pl": "Zmień szczegóły grupy",
        "pt": "Modifique os detalhes do grupo",
        "sk": "Upravte podrobnosti skupiny",
        "th": "แก้ไขรายละเอียดกลุ่ม"
    },
    "new-assignment-created-with-content": {
        "de": "Eine neue Aufgabe „{name}“ wurde erstellt und „Inhalt“ wurde ihr erfolgreich hinzugefügt.",
        "en": "A new assignment \"{name}\" has been created and \"content\" has been successfully added to it.",
        "es": "Se creó una nueva tarea \"{name}\" y se le agregó \"contenido\" exitosamente.",
        "fr": "Un nouveau devoir « {name} » a été créé et le « contenu » y a été ajouté avec succès.",
        "km": "កិច្ចការថ្មី \"{name}\" ត្រូវបានបង្កើត ហើយ \"មាតិកា\" ត្រូវបានបន្ថែមដោយជោគជ័យ។",
        "lv": "Ir izveidots jauns uzdevums \"{name}\", un tam ir veiksmīgi pievienots \"saturs\".",
        "nl": "Er is een nieuwe opdracht \"{name}\" aangemaakt en \"inhoud\" is er succesvol aan toegevoegd.",
        "pl": "Utworzono nowe zadanie „{name}” i pomyślnie dodano do niego „treść”.",
        "pt": "Uma nova atribuição \"{name}\" foi criada e \"conteúdo\" foi adicionado a ela com sucesso.",
        "sk": "Bola vytvorená nová úloha „{name}“ a úspešne sa do nej pridal „obsah“.",
        "th": "สร้างงานที่มอบหมายใหม่ \"{name}\" และเพิ่ม \"เนื้อหา\" สำเร็จแล้ว"
    },
    "new-assignment-successfully-created": {
        "de": "Neue Aufgabe wurde erfolgreich erstellt",
        "en": "New assignment has been successfully created",
        "es": "La nueva tarea se ha creado correctamente.",
        "fr": "Le nouveau devoir a été créé avec succès",
        "km": "កិច្ចការថ្មីត្រូវបានបង្កើតដោយជោគជ័យ",
        "lv": "Jauns uzdevums ir veiksmīgi izveidots",
        "nl": "Nieuwe opdracht is succesvol aangemaakt",
        "pl": "Nowe zadanie zostało pomyślnie utworzone",
        "pt": "A nova tarefa foi criada com sucesso",
        "sk": "Nová úloha bola úspešne vytvorená",
        "th": "สร้างงานที่มอบหมายใหม่สำเร็จแล้ว"
    },
    "new-assignment-title": {
        "de": "Neuer Aufgabentitel",
        "en": "New assignment title",
        "es": "Nuevo título de tarea",
        "fr": "Titre du nouveau devoir",
        "km": "ចំណងជើងកិច្ចការថ្មី",
        "lv": "Jauns uzdevuma nosaukums",
        "nl": "Nieuwe opdrachttitel",
        "pl": "Tytuł nowego zadania",
        "pt": "Novo título da tarefa",
        "sk": "Nový názov úlohy",
        "th": "ชื่องานที่มอบหมายใหม่"
    },
    "new-login-code-is-ready": {
        "de": "Neuer Login-Code ist fertig",
        "en": "New login code is ready",
        "es": "El nuevo código de inicio de sesión está listo",
        "fr": "Le nouveau code de connexion est prêt",
        "km": "លេខកូដចូលថ្មីរួចរាល់",
        "lv": "Jauns pieteikšanās kods ir gatavs",
        "nl": "Nieuwe inlogcode is klaar",
        "pl": "Nowy kod logowania jest gotowy",
        "pt": "O novo código de login está pronto",
        "sk": "Nový prihlasovací kód je pripravený",
        "th": "รหัสเข้าสู่ระบบใหม่พร้อมแล้ว"
    },
    "nickname": {
        "de": "Spitzname",
        "en": "Nickname",
        "es": "Apodo",
        "fr": "Surnom",
        "km": "ឈ្មោះហៅក្រៅ",
        "lv": "Segvārds",
        "nl": "Bijnaam",
        "pl": "Pseudonim",
        "pt": "Apelido",
        "sk": "Prezývka",
        "th": "ชื่อเล่น"
    },
    "no-active-users-with-login-codes": {
        "de": "Keine aktiven Benutzer mit Login-Codes.",
        "en": "No active users with login codes.",
        "es": "No hay usuarios activos con códigos de inicio de sesión.",
        "fr": "Aucun utilisateur actif avec un code de connexion.",
        "km": "គ្មានអ្នកប្រើសកម្មដែលមានលេខកូដចូល។",
        "lv": "Nav aktīvu lietotāju ar pieteikšanās kodiem.",
        "nl": "Geen actieve gebruikers met inlogcodes.",
        "pl": "Brak aktywnych użytkowników z kodami logowania.",
        "pt": "Nenhum usuário ativo com códigos de login.",
        "sk": "Žiadni aktívni používatelia s prihlasovacími kódmi.",
        "th": "ไม่มีผู้ใช้ที่ใช้งานพร้อมรหัสเข้าสู่ระบบ"
    },
    "no-favorites-match-search": {
        "de": "Keine Favoriten entsprechen Ihrer Suche",
        "en": "No favourites match this search",
        "es": "Ningún favorito coincide con tu búsqueda",
        "fr": "Aucun favori ne correspond à votre recherche",
        "km": "គ្មានសំណព្វត្រូវនឹងការស្វែងរក",
        "lv": "Neviena izlase neatbilst jūsu meklēšanas vaicājumam",
        "nl": "Er zijn geen favorieten die overeenkomen met uw zoekopdracht",
        "pl": "Brak ulubionych pasujących do wyszukiwania",
        "pt": "Nenhum favorito corresponde à sua pesquisa",
        "sk": "Vášmu vyhľadávaniu nezodpovedajú žiadne obľúbené položky",
        "th": "ไม่มีรายการโปรดที่ตรงกับการค้นหา"
    },
    "no-favorites-yet": {
        "de": "Noch keine Favoriten",
        "en": "No favourites yet",
        "es": "Aún no hay favoritos",
        "fr": "Pas encore de favoris",
        "km": "មិនទាន់មានសំណព្វ",
        "lv": "Izlases vēl nav",
        "nl": "Nog geen favorieten",
        "pl": "Brak jeszcze ulubionych",
        "pt": "Ainda não há favoritos",
        "sk": "Zatiaľ žiadne obľúbené",
        "th": "ยังไม่มีรายการโปรด"
    },
    "no-results": {
        "de": "Keine Ergebnisse",
        "en": "No results",
        "es": "Sin resultados",
        "fr": "Aucun résultat",
        "km": "គ្មានលទ្ធផល",
        "lv": "Nav rezultātu",
        "nl": "Geen resultaten",
        "pl": "Brak wyników",
        "pt": "Nenhum resultado",
        "sk": "Žiadne výsledky",
        "th": "ไม่พบผลลัพธ์"
    },
    "no-results-found": {
        "de": "Keine Ergebnisse gefunden",
        "en": "No results found",
        "es": "No se encontraron resultados",
        "fr": "Aucun résultat trouvé",
        "km": "រកមិនឃើញលទ្ធផល",
        "lv": "Nav atrasts neviens rezultāts",
        "nl": "Geen resultaten gevonden",
        "pl": "Nie znaleziono wyników",
        "pt": "Nenhum resultado encontrado",
        "sk": "Nenašli sa žiadne výsledky",
        "th": "ไม่พบผลลัพธ์"
    },
    "no-sequences-match-search": {
        "de": "Keine Sequenzen entsprechen Ihrer Suche",
        "en": "No sequences match your search",
        "es": "Ninguna secuencia coincide con tu búsqueda",
        "fr": "Aucune séquence ne correspond à votre recherche",
        "km": "គ្មានលំដាប់ត្រូវនឹងការស្វែងរក",
        "lv": "Neviena secība neatbilst jūsu meklēšanas vaicājumam",
        "nl": "Er zijn geen reeksen die overeenkomen met uw zoekopdracht",
        "pl": "Brak sekwencji pasujących do wyszukiwania",
        "pt": "Nenhuma sequência corresponde à sua pesquisa",
        "sk": "Vášmu vyhľadávaniu nezodpovedajú žiadne sekvencie",
        "th": "ไม่มีลำดับที่ตรงกับการค้นหา"
    },
    "no-students-found": {
        "de": "Keine Schüler gefunden",
        "en": "No Students Found",
        "es": "No se encontraron estudiantes",
        "fr": "Aucun élève trouvé",
        "km": "រកមិនឃើញសិស្ស",
        "lv": "Nav atrasts neviens skolēns",
        "nl": "Geen leerlingen gevonden",
        "pl": "Nie znaleziono uczniów",
        "pt": "Nenhum aluno encontrado",
        "sk": "Nenašli sa žiadni žiaci",
        "th": "ไม่พบนักเรียน"
    },
    "no-students-selected": {
        "de": "Keine Schüler ausgewählt.",
        "en": "No students selected.",
        "es": "No se seleccionaron estudiantes.",
        "fr": "Aucun élève sélectionné.",
        "km": "មិនបានជ្រើសសិស្ស។",
        "lv": "Nav atlasīts neviens skolēns.",
        "nl": "Geen leerlingen geselecteerd.",
        "pl": "Nie wybrano uczniów.",
        "pt": "Nenhum aluno selecionado.",
        "sk": "Nie sú vybratí žiadni žiaci.",
        "th": "ยังไม่ได้เลือกนักเรียน"
    },
    "no-submission": {
        "de": "Keine Einreichung",
        "en": "No Submission",
        "es": "Sin envío",
        "fr": "Aucune soumission",
        "km": "គ្មានការដាក់ស្នើ",
        "lv": "Nav iesniegšanas",
        "nl": "Geen inzending",
        "pl": "Brak zgłoszenia",
        "pt": "Sem envio",
        "sk": "Žiadne predloženie",
        "th": "ไม่มีการส่ง"
    },
    "optional": {
        "de": "Optional",
        "en": "Optional",
        "es": "Opcional",
        "fr": "Facultatif",
        "km": "ស្រេចចិត្ត",
        "lv": "Pēc izvēles",
        "nl": "Optioneel",
        "pl": "Opcjonalne",
        "pt": "Opcional",
        "sk": "Voliteľné",
        "th": "ไม่บังคับ"
    },
    "password-reset-successfully": {
        "de": "Passwort erfolgreich zurückgesetzt",
        "en": "Password reset successfully",
        "es": "Contraseña restablecida correctamente",
        "fr": "Mot de passe réinitialisé avec succès",
        "km": "បានកំណត់ពាក្យសម្ងាត់ឡើងវិញដោយជោគជ័យ",
        "lv": "Parole veiksmīgi atiestatīta",
        "nl": "Wachtwoord succesvol opnieuw ingesteld",
        "pl": "Hasło zresetowane pomyślnie",
        "pt": "Senha redefinida com sucesso",
        "sk": "Heslo bolo úspešne obnovené",
        "th": "รีเซ็ตรหัสผ่านสำเร็จ"
    },
    "practice": {
        "de": "Übung",
        "en": "Practice",
        "es": "Práctica",
        "fr": "Pratique",
        "km": "អនុវត្ត",
        "lv": "Praktizēšana",
        "nl": "Oefening",
        "pl": "Ćwiczenie",
        "pt": "Prática",
        "sk": "Precvičovanie",
        "th": "ฝึกฝน"
    },
    "print": {
        "de": "Drucken",
        "en": "Print",
        "es": "Imprimir",
        "fr": "Imprimer",
        "km": "បោះពុម្ព",
        "lv": "Drukāt",
        "nl": "Afdrukken",
        "pl": "Drukuj",
        "pt": "Imprimir",
        "sk": "Tlačiť",
        "th": "พิมพ์"
    },
    "publication-date": {
        "de": "Veröffentlichungsdatum",
        "en": "Publication date",
        "es": "Fecha de publicación",
        "fr": "Date de publication",
        "km": "កាលបរិច្ឆេទផ្សព្វផ្សាយ",
        "lv": "Publicēšanas datums",
        "nl": "Publicatiedatum",
        "pl": "Data publikacji",
        "pt": "Data de publicação",
        "sk": "Dátum zverejnenia",
        "th": "วันที่เผยแพร่"
    },
    "publication-time": {
        "de": "Veröffentlichungszeitpunkt",
        "en": "Publication time",
        "es": "Hora de publicación",
        "fr": "Heure de publication",
        "km": "ម៉ោងផ្សព្វផ្សាយ",
        "lv": "Publicēšanas laiks",
        "nl": "Publicatietijd",
        "pl": "Godzina publikacji",
        "pt": "Hora da publicação",
        "sk": "Čas zverejnenia",
        "th": "เวลาเผยแพร่"
    },
    "publishes-on": {
        "de": "Veröffentlicht am",
        "en": "Publishes on",
        "es": "Se publica el",
        "fr": "Publié le",
        "km": "ផ្សព្វផ្សាយនៅ",
        "lv": "Tiks publicēts",
        "nl": "Wordt gepubliceerd op",
        "pl": "Publikacja",
        "pt": "Publica em",
        "sk": "Zverejní sa",
        "th": "เผยแพร่เมื่อ"
    },
    "remove-from-favorites": {
        "de": "Aus Favoriten entfernen",
        "en": "Remove from favorites",
        "es": "Quitar de favoritos",
        "fr": "Retirer des favoris",
        "km": "ដកចេញពីសំណព្វ",
        "lv": "Noņemt no izlases",
        "nl": "Verwijderen uit favorieten",
        "pl": "Usuń z ulubionych",
        "pt": "Remover dos favoritos",
        "sk": "Odstrániť z obľúbených",
        "th": "ลบออกจากรายการโปรด"
    },
    "reporting-dashboard": {
        "de": "Berichts-Dashboard",
        "en": "Reporting dashboard",
        "es": "Panel de informes",
        "fr": "Tableau de bord des rapports",
        "km": "ផ្ទាំងគ្រប់គ្រងរបាយការណ៍",
        "lv": "Pārskatu informācijas panelis",
        "nl": "Rapportagedashboard",
        "pl": "Panel raportowania",
        "pt": "Painel de relatórios",
        "sk": "Informačný panel prehľadov",
        "th": "แดชบอร์ดรายงาน"
    },
    "reset-password": {
        "de": "Passwort zurücksetzen",
        "en": "Reset password",
        "es": "Restablecer contraseña",
        "fr": "Réinitialiser le mot de passe",
        "km": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ",
        "lv": "Atiestatīt paroli",
        "nl": "Wachtwoord opnieuw instellen",
        "pl": "Resetuj hasło",
        "pt": "Redefinir senha",
        "sk": "Obnoviť heslo",
        "th": "รีเซ็ตรหัสผ่าน"
    },
    "reset-password-confirm-description": {
        "de": "Für diesen Schüler wird ein neuer Anmeldecode generiert.",
        "en": "Reset Password Confirm Description",
        "es": "Se generará un nuevo código de inicio de sesión para este estudiante.",
        "fr": "Un nouveau code de connexion sera généré pour cet élève.",
        "km": "លេខកូដចូលថ្មីនឹងត្រូវបានបង្កើតសម្រាប់សិស្សនេះ។",
        "lv": "Šim skolēnam tiks ģenerēts jauns pieteikšanās kods.",
        "nl": "Er wordt een nieuwe inlogcode voor deze leerling gegenereerd.",
        "pl": "Zostanie wygenerowany nowy kod logowania dla tego ucznia.",
        "pt": "Um novo código de login será gerado para este aluno.",
        "sk": "Pre tohto žiaka sa vygeneruje nový prihlasovací kód.",
        "th": "จะสร้างรหัสเข้าสู่ระบบใหม่สำหรับนักเรียนคนนี้"
    },
    "reset-password-confirm-title": {
        "de": "Passwort zurücksetzen?",
        "en": "Reset password",
        "es": "¿Restablecer la contraseña?",
        "fr": "Réinitialiser le mot de passe ?",
        "km": "កំណត់ពាក្យសម្ងាត់ឡើងវិញ?",
        "lv": "Vai atiestatīt paroli?",
        "nl": "Wachtwoord opnieuw instellen?",
        "pl": "Zresetować hasło?",
        "pt": "Redefinir a senha?",
        "sk": "Obnoviť heslo?",
        "th": "รีเซ็ตรหัสผ่านหรือไม่?"
    },
    "restore": {
        "de": "Wiederherstellen",
        "en": "Restore",
        "es": "Restaurar",
        "fr": "Restaurer",
        "km": "ស្តារ",
        "lv": "Atjaunot",
        "nl": "Herstellen",
        "pl": "Przywróć",
        "pt": "Restaurar",
        "sk": "Obnoviť",
        "th": "กู้คืน"
    },
    "restore-group-confirm-description": {
        "de": "Die Gruppe kehrt zu Ihrer aktiven Gruppenliste zurück. Die Schüler bleiben dieser Gruppe zugeordnet.",
        "en": "The group will return to your active groups list. Students stay assigned to this group.",
        "es": "El grupo volverá a su lista de grupos activos. Los estudiantes permanecen asignados a este grupo.",
        "fr": "Le groupe reviendra dans votre liste de groupes actifs. Les élèves restent assignés à ce groupe.",
        "km": "ក្រុមនឹងត្រឡប់ទៅបញ្ជីក្រុមសកម្ម។ សិស្សនៅតែត្រូវបានកំណត់ទៅក្រុមនេះ។",
        "lv": "Grupa atgriezīsies jūsu aktīvo grupu sarakstā. Skolēni paliek šajā grupā.",
        "nl": "De groep keert terug naar uw lijst met actieve groepen. Leerlingen blijven toegewezen aan deze groep.",
        "pl": "Grupa wróci na listę aktywnych grup. Uczniowie pozostaną przypisani do tej grupy.",
        "pt": "O grupo retornará à sua lista de grupos ativos. Os alunos permanecem atribuídos a este grupo.",
        "sk": "Skupina sa vráti do zoznamu aktívnych skupín. Žiaci zostávajú zaradení do tejto skupiny.",
        "th": "กลุ่มจะกลับไปยังรายการกลุ่มที่ใช้งาน นักเรียนยังอยู่ในกลุ่มนี้"
    },
    "restore-group-confirm-title": {
        "de": "Gruppe „{name}“ wiederherstellen?",
        "en": "Restore group \"{name}\"?",
        "es": "¿Restaurar el grupo \"{name}\"?",
        "fr": "Restaurer le groupe « {name} » ?",
        "km": "ស្តារក្រុម \"{name}\"?",
        "lv": "Vai atjaunot grupu \"{name}\"?",
        "nl": "Groep \"{name}\" herstellen?",
        "pl": "Przywrócić grupę „{name}”?",
        "pt": "Restaurar grupo \"{name}\"?",
        "sk": "Obnoviť skupinu „{name}“?",
        "th": "กู้คืนกลุ่ม \"{name}\" หรือไม่?"
    },
    "restore-student-confirm-description": {
        "de": "Der Schüler kehrt zu Ihrer aktiven Schülerliste zurück. Gruppen und Anmeldecode bleiben unverändert.",
        "en": "The student will return to your active student list. Their groups and login code are unchanged.",
        "es": "El estudiante regresará a su lista de estudiantes activos. Sus grupos y código de inicio de sesión no cambian.",
        "fr": "L’élève reviendra dans votre liste d’élèves actifs. Ses groupes et son code de connexion restent inchangés.",
        "km": "សិស្សនឹងត្រឡប់ទៅបញ្ជីសិស្សសកម្ម។ ក្រុម និងលេខកូដចូលរបស់ពួកគេមិនផ្លាស់ប្តូរ។",
        "lv": "Skolēns atgriezīsies jūsu aktīvo skolēnu sarakstā. Grupas un pieteikšanās kods paliks nemainīti.",
        "nl": "De leerling keert terug naar uw actieve leerlingenlijst. De groepen en inlogcode blijven ongewijzigd.",
        "pl": "Uczeń wróci na aktywną listę uczniów. Jego grupy i kod logowania pozostaną bez zmian.",
        "pt": "O aluno retornará à sua lista de alunos ativos. Seus grupos e código de login permanecem inalterados.",
        "sk": "Žiak sa vráti do vášho zoznamu aktívnych žiakov. Jeho skupiny a prihlasovací kód zostanú nezmenené.",
        "th": "นักเรียนจะกลับไปยังรายการนักเรียนที่ใช้งาน กลุ่มและรหัสเข้าสู่ระบบไม่เปลี่ยน"
    },
    "restore-student-confirm-title": {
        "de": "Diesen Schüler wiederherstellen?",
        "en": "Restore this student?",
        "es": "¿Restaurar a este estudiante?",
        "fr": "Restaurer cet élève ?",
        "km": "ស្តារសិស្សនេះ?",
        "lv": "Vai atjaunot šo skolēnu?",
        "nl": "Deze leerling herstellen?",
        "pl": "Przywrócić tego ucznia?",
        "pt": "Restaurar este aluno?",
        "sk": "Obnoviť tohto žiaka?",
        "th": "กู้คืนนักเรียนคนนี้หรือไม่?"
    },
    "review-student-submissions-and-provide-feedback": {
        "de": "Überprüfen Sie die Einsendungen der Schüler und geben Sie Feedback",
        "en": "Review Student Submissions And Provide Feedback",
        "es": "Revisar las presentaciones de los estudiantes y brindar comentarios",
        "fr": "Examiner les soumissions des élèves et fournir des commentaires",
        "km": "ពិនិត្យការដាក់ស្នើរបស់សិស្ស និងផ្តល់មតិកែលម្អ",
        "lv": "Pārskatiet skolēnu iesniegumus un sniedziet atsauksmes",
        "nl": "Beoordeel de inzendingen van leerlingen en geef feedback",
        "pl": "Przeglądaj prace uczniów i przekazuj opinię",
        "pt": "Revise os envios dos alunos e forneça feedback",
        "sk": "Skontrolujte príspevky žiakov a poskytnite spätnú väzbu",
        "th": "ตรวจงานที่นักเรียนส่งและให้ข้อเสนอแนะ"
    },
    "rows-selected-for-removal-summary": {
        "de": "Zusammenfassung der zum Entfernen ausgewählten Zeilen",
        "en": "Rows Selected For Removal Summary",
        "es": "Resumen de filas seleccionadas para eliminar",
        "fr": "Résumé des lignes sélectionnées pour suppression",
        "km": "សង្ខេបជួរដេកដែលបានជ្រើសសម្រាប់ដកចេញ",
        "lv": "Noņemšanai atlasīto rindu kopsavilkums",
        "nl": "Samenvatting van rijen geselecteerd voor verwijdering",
        "pl": "Podsumowanie wierszy wybranych do usunięcia",
        "pt": "Resumo das linhas selecionadas para remoção",
        "sk": "Súhrn riadkov vybratých na odstránenie",
        "th": "สรุปแถวที่เลือกเพื่อนำออก"
    },
    "save-changes": {
        "de": "Änderungen speichern",
        "en": "Save changes",
        "es": "Guardar cambios",
        "fr": "Enregistrer les modifications",
        "km": "រក្សាទុកការផ្លាស់ប្តូរ",
        "lv": "Saglabāt izmaiņas",
        "nl": "Wijzigingen opslaan",
        "pl": "Zapisz zmiany",
        "pt": "Salvar alterações",
        "sk": "Uložiť zmeny",
        "th": "บันทึกการเปลี่ยนแปลง"
    },
    "search-group": {
        "de": "Gruppe suchen",
        "en": "Search group",
        "es": "Buscar grupo",
        "fr": "Rechercher un groupe",
        "km": "ស្វែងរកក្រុម",
        "lv": "Meklēt grupu",
        "nl": "Groep zoeken",
        "pl": "Szukaj grupy",
        "pt": "Pesquisar grupo",
        "sk": "Hľadať skupinu",
        "th": "ค้นหากลุ่ม"
    },
    "search-sequences": {
        "de": "Sequenzen suchen",
        "en": "Search sequences",
        "es": "Buscar secuencias",
        "fr": "Rechercher des séquences",
        "km": "ស្វែងរកលំដាប់",
        "lv": "Meklēt secības",
        "nl": "Reeksen zoeken",
        "pl": "Szukaj sekwencji",
        "pt": "Pesquisar sequências",
        "sk": "Hľadať sekvencie",
        "th": "ค้นหาลำดับ"
    },
    "search-student": {
        "de": "Schüler suchen",
        "en": "Search Student",
        "es": "Buscar estudiante",
        "fr": "Rechercher un élève",
        "km": "ស្វែងរកសិស្ស",
        "lv": "Meklēt skolēnu",
        "nl": "Zoek leerling",
        "pl": "Szukaj ucznia",
        "pt": "Pesquisar aluno",
        "sk": "Hľadať žiaka",
        "th": "ค้นหานักเรียน"
    },
    "select-grade": {
        "de": "Klassenstufe auswählen",
        "en": "Select Grade",
        "es": "Seleccionar grado",
        "fr": "Sélectionner le niveau",
        "km": "ជ្រើសថ្នាក់",
        "lv": "Atlasiet klasi",
        "nl": "Leerjaar selecteren",
        "pl": "Wybierz klasę",
        "pt": "Selecionar ano escolar",
        "sk": "Vybrať ročník",
        "th": "เลือกระดับชั้น"
    },
    "select-subject": {
        "de": "Fach auswählen",
        "en": "Select Subject",
        "es": "Seleccionar asignatura",
        "fr": "Sélectionner la matière",
        "km": "ជ្រើសមុខវិជ្ជា",
        "lv": "Atlasiet mācību priekšmetu",
        "nl": "Vak selecteren",
        "pl": "Wybierz przedmiot",
        "pt": "Selecionar disciplina",
        "sk": "Vybrať predmet",
        "th": "เลือกวิชา"
    },
    "select-target-sequence": {
        "de": "Zielsequenz auswählen",
        "en": "Select target sequence",
        "es": "Seleccionar secuencia objetivo",
        "fr": "Sélectionner la séquence cible",
        "km": "ជ្រើសលំដាប់គោលដៅ",
        "lv": "Atlasiet mērķa secību",
        "nl": "Doelreeks selecteren",
        "pl": "Wybierz docelową sekwencję",
        "pt": "Selecione a sequência alvo",
        "sk": "Vyberte cieľovú sekvenciu",
        "th": "เลือกลำดับปลายทาง"
    },
    "selected": {
        "de": "Ausgewählt",
        "en": "Selected",
        "es": "Seleccionado",
        "fr": "Sélectionné",
        "km": "បានជ្រើស",
        "lv": "Atlasīts",
        "nl": "Geselecteerd",
        "pl": "Wybrane",
        "pt": "Selecionado",
        "sk": "Vybrané",
        "th": "ที่เลือก"
    },
    "selected-content": {
        "de": "den ausgewählten Inhalt",
        "en": "the selected content",
        "es": "el contenido seleccionado",
        "fr": "le contenu sélectionné",
        "km": "មាតិកាដែលបានជ្រើស",
        "lv": "atlasīto saturu",
        "nl": "de geselecteerde inhoud",
        "pl": "wybrana treść",
        "pt": "o conteúdo selecionado",
        "sk": "vybraný obsah",
        "th": "เนื้อหาที่เลือก"
    },
    "selected-students-will-be-added": {
        "de": "Ausgewählte Schüler werden hinzugefügt",
        "en": "Selected Students Will Be Added",
        "es": "Se agregarán los estudiantes seleccionados",
        "fr": "Les élèves sélectionnés seront ajoutés",
        "km": "សិស្សដែលបានជ្រើសនឹងត្រូវបានបន្ថែម",
        "lv": "Tiks pievienoti atlasītie skolēni",
        "nl": "Geselecteerde leerlingen worden toegevoegd",
        "pl": "Wybrani uczniowie zostaną dodani",
        "pt": "Os alunos selecionados serão adicionados",
        "sk": "Vybraní žiaci budú pridaní",
        "th": "นักเรียนที่เลือกจะถูกเพิ่ม"
    },
    "sequences-only": {
        "de": "Nur Sequenzen",
        "en": "Sequences only",
        "es": "Solo secuencias",
        "fr": "Séquences uniquement",
        "km": "លំដាប់តែប៉ុណ្ណោះ",
        "lv": "Tikai secības",
        "nl": "Alleen reeksen",
        "pl": "Tylko sekwencje",
        "pt": "Apenas sequências",
        "sk": "Iba sekvencie",
        "th": "เฉพาะลำดับ"
    },
    "set-publication-date": {
        "de": "Legen Sie fest, wann diese Aufgabe für Schüler veröffentlicht wird",
        "en": "Set when this assignment will be published to students",
        "es": "Establecer cuándo se publicará esta tarea para los estudiantes",
        "fr": "Définir quand ce devoir sera publié aux élèves",
        "km": "កំណត់ពេលដែលកិច្ចការនេះនឹងត្រូវបានផ្សព្វផ្សាយទៅសិស្ស",
        "lv": "Iestatiet, kad šis uzdevums tiks publicēts skolēniem",
        "nl": "Stel in wanneer deze opdracht voor de leerlingen wordt gepubliceerd",
        "pl": "Ustaw, kiedy to zadanie zostanie opublikowane uczniom",
        "pt": "Defina quando esta tarefa será publicada para os alunos",
        "sk": "Nastavte, kedy sa táto úloha zverejní žiakom",
        "th": "กำหนดเวลาที่จะเผยแพร่งานนี้ให้นักเรียน"
    },
    "set-publication-date-to-save": {
        "de": "Legen Sie zum Speichern ein Veröffentlichungsdatum fest.",
        "en": "Set a publication date to save.",
        "es": "Establece una fecha de publicación para guardar.",
        "fr": "Définissez une date de publication pour enregistrer.",
        "km": "កំណត់កាលបរិច្ឆេទផ្សព្វផ្សាយដើម្បីរក្សាទុក។",
        "lv": "Iestatiet publicēšanas datumu saglabāšanai.",
        "nl": "Stel een publicatiedatum in om op te slaan.",
        "pl": "Ustaw datę publikacji, aby zapisać.",
        "pt": "Defina uma data de publicação para salvar.",
        "sk": "Ak chcete uložiť, nastavte dátum zverejnenia.",
        "th": "กำหนดวันที่เผยแพร่เพื่อบันทึก"
    },
    "something-went-wrong": {
        "de": "Etwas ist schief gelaufen",
        "en": "Something went wrong",
        "es": "algo salió mal",
        "fr": "Une erreur s’est produite",
        "km": "មានអ្វីមួយខុសប្រក្រតី",
        "lv": "Kaut kas nogāja greizi",
        "nl": "Er is iets misgegaan",
        "pl": "Coś poszło nie tak",
        "pt": "Algo deu errado",
        "sk": "Niečo sa pokazilo",
        "th": "เกิดข้อผิดพลาด"
    },
    "step-n": {
        "de": "Schritt {n}",
        "en": "Step {n}",
        "es": "Paso {n}",
        "fr": "Étape {n}",
        "km": "ជំហាន {n}",
        "lv": "Solis {n}",
        "nl": "Stap {n}",
        "pl": "Krok {n}",
        "pt": "Etapa {n}",
        "sk": "Krok {n}",
        "th": "ขั้นตอน {n}"
    },
    "student-account-created": {
        "de": "Schülerkonto erstellt",
        "en": "Student account created",
        "es": "Cuenta de estudiante creada",
        "fr": "Compte élève créé",
        "km": "បានបង្កើតគណនីសិស្ស",
        "lv": "Izveidots skolēna konts",
        "nl": "Leerlingaccount aangemaakt",
        "pl": "Konto ucznia utworzone",
        "pt": "Conta de estudante criada",
        "sk": "Žiacke konto vytvorené",
        "th": "สร้างบัญชีนักเรียนแล้ว"
    },
    "student-added-to-group": {
        "de": "Schüler zur Gruppe hinzugefügt",
        "en": "Student added to group",
        "es": "Estudiante agregado al grupo",
        "fr": "Élève ajouté au groupe",
        "km": "បានបន្ថែមសិស្សទៅក្រុម",
        "lv": "Skolēns pievienots grupai",
        "nl": "Leerling toegevoegd aan groep",
        "pl": "Uczeń dodany do grupy",
        "pt": "Aluno adicionado ao grupo",
        "sk": "Žiak bol pridaný do skupiny",
        "th": "เพิ่มนักเรียนเข้ากลุ่มแล้ว"
    },
    "student-already-in-group": {
        "de": "Schüler bereits in der Gruppe",
        "en": "Student already in group",
        "es": "Estudiante ya en grupo",
        "fr": "L’élève est déjà dans le groupe",
        "km": "សិស្សមាននៅក្នុងក្រុមរួចហើយ",
        "lv": "Skolēns jau ir grupā",
        "nl": "Leerling zit al in de groep",
        "pl": "Uczeń jest już w grupie",
        "pt": "Aluno já está no grupo",
        "sk": "Žiak je už v skupine",
        "th": "นักเรียนอยู่ในกลุ่มแล้ว"
    },
    "student-submissions": {
        "de": "Einreichungen von Schülern",
        "en": "Student Submissions",
        "es": "Envíos de estudiantes",
        "fr": "Soumissions des élèves",
        "km": "ការដាក់ស្នើរបស់សិស្ស",
        "lv": "Skolēnu iesniegumi",
        "nl": "Inzendingen van leerlingen",
        "pl": "Prace uczniów",
        "pt": "Envios de alunos",
        "sk": "Odovzdané práce žiakov",
        "th": "งานที่นักเรียนส่ง"
    },
    "student-updated-successfully": {
        "de": "Schüler erfolgreich aktualisiert",
        "en": "Student updated successfully",
        "es": "Estudiante actualizado exitosamente",
        "fr": "Élève mis à jour avec succès",
        "km": "បានធ្វើបច្ចុប្បន្នភាពសិស្សដោយជោគជ័យ",
        "lv": "Skolēns ir veiksmīgi atjaunināts",
        "nl": "Leerling is succesvol bijgewerkt",
        "pl": "Uczeń zaktualizowany pomyślnie",
        "pt": "Aluno atualizado com sucesso",
        "sk": "Žiak bol úspešne aktualizovaný",
        "th": "อัปเดตนักเรียนสำเร็จ"
    },
    "students-archived-successfully": {
        "de": "Schüler erfolgreich archiviert",
        "en": "Students successfully archived",
        "es": "Estudiantes archivados exitosamente",
        "fr": "Élèves archivés avec succès",
        "km": "បានទុកសិស្សជាឯកសារដោយជោគជ័យ",
        "lv": "Skolēni veiksmīgi arhivēti",
        "nl": "Leerlingen zijn succesvol gearchiveerd",
        "pl": "Uczniowie zarchiwizowani pomyślnie",
        "pt": "Alunos arquivados com sucesso",
        "sk": "Žiaci boli úspešne archivovaní",
        "th": "เก็บถาวรนักเรียนสำเร็จ"
    },
    "students-profile": {
        "de": "Schülerprofil",
        "en": "Student profile",
        "es": "Perfil de los estudiantes",
        "fr": "Profil de l’élève",
        "km": "ប្រវត្តិរូបសិស្ស",
        "lv": "Skolēnu profils",
        "nl": "Leerlingenprofiel",
        "pl": "Profil ucznia",
        "pt": "Perfil dos Alunos",
        "sk": "Profil žiakov",
        "th": "โปรไฟล์นักเรียน"
    },
    "students-successfully-added-to-the-groups": {
        "de": "Schüler wurden erfolgreich zu den Gruppen hinzugefügt",
        "en": "Students successfully added to the groups",
        "es": "Estudiantes agregados exitosamente a los grupos.",
        "fr": "Élèves ajoutés aux groupes avec succès",
        "km": "បានបន្ថែមសិស្សទៅក្រុមដោយជោគជ័យ",
        "lv": "Skolēni veiksmīgi pievienoti grupām",
        "nl": "Leerlingen zijn succesvol toegevoegd aan de groepen",
        "pl": "Uczniowie pomyślnie dodani do grup",
        "pt": "Alunos adicionados com sucesso aos grupos",
        "sk": "Žiaci sa úspešne pridali do skupín",
        "th": "เพิ่มนักเรียนเข้ากลุ่มสำเร็จ"
    },
    "subject": {
        "de": "Fach",
        "en": "Subject",
        "es": "Asignatura",
        "fr": "Matière",
        "km": "មុខវិជ្ជា",
        "lv": "Mācību priekšmets",
        "nl": "Vak",
        "pl": "Przedmiot",
        "pt": "Disciplina",
        "sk": "Predmet",
        "th": "วิชา"
    },
    "symbol-passphrase": {
        "de": "Symbol-Passwortsatz",
        "en": "Symbol Passphrase",
        "es": "Frase secreta de símbolos",
        "fr": "Phrase secrète symbolique",
        "km": "ឃ្លាសម្ងាត់និមិត្តសញ្ញា",
        "lv": "Simbolu ieejas frāze",
        "nl": "Wachtwoordzin met symbolen",
        "pl": "Hasło symboliczne",
        "pt": "Frase secreta de símbolos",
        "sk": "Symbolová prístupová fráza",
        "th": "วลีสัญลักษณ์"
    },
    "tags": {
        "de": "Schlagworte",
        "en": "Tags",
        "es": "Etiquetas",
        "fr": "Étiquettes",
        "km": "ស្លាក",
        "lv": "Tagi",
        "nl": "Labels",
        "pl": "Tagi",
        "pt": "Etiquetas",
        "sk": "Tagy",
        "th": "แท็ก"
    },
    "this-assignment": {
        "de": "Diese Aufgabe",
        "en": "This Assignment",
        "es": "Esta tarea",
        "fr": "Ce devoir",
        "km": "កិច្ចការនេះ",
        "lv": "Šis uzdevums",
        "nl": "Deze opdracht",
        "pl": "To zadanie",
        "pt": "Esta tarefa",
        "sk": "Táto úloha",
        "th": "งานที่มอบหมายนี้"
    },
    "time-format-placeholder": {
        "de": "hh:mm",
        "en": "Time Format Placeholder",
        "es": "hh:mm",
        "fr": "hh:mm",
        "km": "ម៉ោង:នាទី",
        "lv": "hh:mm",
        "nl": "uu:mm",
        "pl": "gg:mm",
        "pt": "hh:mm",
        "sk": "hh:mm",
        "th": "ชม:นาที"
    },
    "total-student": {
        "de": "Schüler insgesamt",
        "en": "Total Student",
        "es": "Total de estudiantes",
        "fr": "Total élèves",
        "km": "សិស្សសរុប",
        "lv": "Skolēni kopā",
        "nl": "Totaal aantal leerlingen",
        "pl": "Łącznie uczniów",
        "pt": "Total de alunos",
        "sk": "Celkový počet žiakov",
        "th": "นักเรียนทั้งหมด"
    },
    "unknown": {
        "de": "Unbekannt",
        "en": "Unknown",
        "es": "Desconocido",
        "fr": "Inconnu",
        "km": "មិនស្គាល់",
        "lv": "Nezināms",
        "nl": "Onbekend",
        "pl": "Nieznane",
        "pt": "Desconhecido",
        "sk": "Neznámy",
        "th": "ไม่ทราบ"
    },
    "unsaved-changes-will-be-lost": {
        "de": "Nicht gespeicherte Änderungen gehen verloren.",
        "en": "Unsaved changes will be lost.",
        "es": "Los cambios no guardados se perderán.",
        "fr": "Les modifications non enregistrées seront perdues.",
        "km": "ការផ្លាស់ប្តូរដែលមិនបានរក្សាទុកនឹងបាត់។",
        "lv": "Nesaglabātās izmaiņas tiks zaudētas.",
        "nl": "Niet-opgeslagen wijzigingen gaan verloren.",
        "pl": "Niezapisane zmiany zostaną utracone.",
        "pt": "As alterações não salvas serão perdidas.",
        "sk": "Neuložené zmeny sa stratia.",
        "th": "การเปลี่ยนแปลงที่ยังไม่บันทึกจะหายไป"
    },
    "update": {
        "de": "Aktualisieren",
        "en": "Update",
        "es": "Actualizar",
        "fr": "Mettre à jour",
        "km": "ធ្វើបច្ចុប្បន្នភាព",
        "lv": "Atjaunināt",
        "nl": "Bijwerken",
        "pl": "Aktualizuj",
        "pt": "Atualizar",
        "sk": "Aktualizovať",
        "th": "อัปเดต"
    },
    "update-the-students-information": {
        "de": "Aktualisieren Sie die Schülerinformationen",
        "en": "Update The Students Information",
        "es": "Actualizar la información de los estudiantes",
        "fr": "Mettre à jour les informations de l’élève",
        "km": "ធ្វើបច្ចុប្បន្នភាពព័ត៌មានសិស្ស",
        "lv": "Atjauniniet skolēnu informāciju",
        "nl": "Update de leerlingeninformatie",
        "pl": "Zaktualizuj informacje o uczniu",
        "pt": "Atualize as informações dos alunos",
        "sk": "Aktualizujte informácie o žiakoch",
        "th": "อัปเดตข้อมูลนักเรียน"
    },
    "view": {
        "de": "Anzeigen",
        "en": "View",
        "es": "Ver",
        "fr": "Voir",
        "km": "មើល",
        "lv": "Skatīt",
        "nl": "Bekijk",
        "pl": "Zobacz",
        "pt": "Ver",
        "sk": "Zobraziť",
        "th": "ดู"
    },
    "view-and-download-login-code": {
        "de": "Anmeldecode ansehen und herunterladen",
        "en": "View and download login code",
        "es": "Ver y descargar el código de inicio de sesión",
        "fr": "Voir et télécharger le code de connexion",
        "km": "មើល និងទាញយកលេខកូដចូល",
        "lv": "Skatiet un lejupielādējiet pieteikšanās kodu",
        "nl": "Bekijk en download de inlogcode",
        "pl": "Zobacz i pobierz kod logowania",
        "pt": "Ver e baixar o código de login",
        "sk": "Zobraziť a stiahnuť prihlasovací kód",
        "th": "ดูและดาวน์โหลดรหัสเข้าสู่ระบบ"
    },
    "view-dashboard": {
        "de": "Dashboard anzeigen",
        "en": "View dashboard",
        "es": "Ver panel",
        "fr": "Voir le tableau de bord",
        "km": "មើលផ្ទាំងគ្រប់គ្រង",
        "lv": "Skatīt informācijas paneli",
        "nl": "Dashboard bekijken",
        "pl": "Zobacz panel",
        "pt": "Ver painel",
        "sk": "Zobraziť informačný panel",
        "th": "ดูแดชบอร์ด"
    },
    "view-dashboards": {
        "de": "Dashboards anzeigen",
        "en": "View dashboards",
        "es": "Ver paneles",
        "fr": "Voir les tableaux de bord",
        "km": "មើលផ្ទាំងគ្រប់គ្រង",
        "lv": "Skatīt informācijas paneļus",
        "nl": "Dashboards bekijken",
        "pl": "Zobacz panele",
        "pt": "Ver painéis",
        "sk": "Zobraziť informačné panely",
        "th": "ดูแดชบอร์ด"
    },
    "view-students": {
        "de": "Schüler ansehen",
        "en": "View students",
        "es": "Ver estudiantes",
        "fr": "Voir les élèves",
        "km": "មើលសិស្ស",
        "lv": "Skatīt skolēnus",
        "nl": "Bekijk leerlingen",
        "pl": "Zobacz uczniów",
        "pt": "Ver alunos",
        "sk": "Zobraziť žiakov",
        "th": "ดูนักเรียน"
    },
    "where-add-content": {
        "de": "Wo möchten Sie diesen Inhalt hinzufügen?",
        "en": "Select one of two options below:",
        "es": "¿Dónde te gustaría agregar este contenido?",
        "fr": "Où souhaitez-vous ajouter ce contenu ?",
        "km": "តើអ្នកចង់បន្ថែមមាតិកានេះនៅឯណា?",
        "lv": "Kur vēlaties pievienot šo saturu?",
        "nl": "Waar wilt u deze inhoud toevoegen?",
        "pl": "Gdzie chcesz dodać tę treść?",
        "pt": "Onde você gostaria de adicionar este conteúdo?",
        "sk": "Kam by ste chceli pridať tento obsah?",
        "th": "ต้องการเพิ่มเนื้อหานี้ที่ไหน?"
    },
    "without-login-codes": {
        "de": "ohne Login-Codes (unten nicht dargestellt).",
        "en": "without login codes (not shown below).",
        "es": "sin códigos de inicio de sesión (no se muestran a continuación).",
        "fr": "sans codes de connexion (non affichés ci-dessous).",
        "km": "ដោយគ្មានលេខកូដចូល (មិនបង្ហាញខាងក្រោម)។",
        "lv": "bez pieteikšanās kodiem (nav parādīts zemāk).",
        "nl": "zonder inlogcodes (niet hieronder weergegeven).",
        "pl": "bez kodów logowania (nie pokazano poniżej).",
        "pt": "sem códigos de login (não mostrados abaixo).",
        "sk": "bez prihlasovacích kódov (nie sú zobrazené nižšie).",
        "th": "โดยไม่มีรหัสเข้าสู่ระบบ (ไม่ได้แสดงด้านล่าง)"
    },
    "you-can-now-add-students-to-this-group": {
        "de": "Sie können nun Schüler zu dieser Gruppe hinzufügen",
        "en": "You can now add students to this group",
        "es": "Ahora puedes agregar estudiantes a este grupo.",
        "fr": "Vous pouvez maintenant ajouter des élèves à ce groupe",
        "km": "ឥឡូវអ្នកអាចបន្ថែមសិស្សទៅក្រុមនេះ",
        "lv": "Tagad šai grupai varat pievienot skolēnus",
        "nl": "U kunt nu leerlingen aan deze groep toevoegen",
        "pl": "Możesz teraz dodać uczniów do tej grupy",
        "pt": "Agora você pode adicionar alunos a este grupo",
        "sk": "Teraz môžete do tejto skupiny pridať žiakov",
        "th": "คุณสามารถเพิ่มนักเรียนเข้ากลุ่มนี้ได้แล้ว"
    },
    "assignment-successfully-created": {
        "de": "Aufgabe erfolgreich erstellt",
        "en": "Assignment successfully created",
        "es": "Tarea creada exitosamente",
        "fr": "Devoir créé avec succès",
        "km": "បានបង្កើតកិច្ចការដោយជោគជ័យ",
        "lv": "Uzdevums veiksmīgi izveidots",
        "nl": "Opdracht succesvol aangemaakt",
        "pl": "Zadanie utworzone pomyślnie",
        "pt": "Tarefa criada com sucesso",
        "sk": "Úloha bola úspešne vytvorená",
        "th": "สร้างงานที่มอบหมายสำเร็จ"
    },
    "student-view": {
        "de": "Schüleransicht",
        "en": "Student View",
        "es": "Vista de estudiante",
        "fr": "Vue élève",
        "km": "ទិដ្ឋភាពសិស្ស",
        "lv": "Skolēna skats",
        "nl": "Leerlingweergave",
        "pl": "Widok ucznia",
        "pt": "Vista do aluno",
        "sk": "Zobrazenie žiaka",
        "th": "มุมมองนักเรียน"
    },
    "teacher-agreement": {
        "de": "Vereinbarung für Lehrkräfte",
        "en": "Teacher Agreement",
        "es": "Acuerdo para docentes",
        "fr": "Accord enseignant",
        "km": "កិច្ចព្រមព្រៀងសម្រាប់គ្រូបង្រៀន",
        "lv": "Skolotāja līgums",
        "nl": "Docentenovereenkomst",
        "pl": "Umowa dla nauczyciela",
        "pt": "Acordo do professor",
        "sk": "Dohoda pre učiteľov",
        "th": "ข้อตกลงสำหรับครู"
    },
}
